webpackJsonp([35783957827783],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(169);
	var isBuffer = __webpack_require__(541);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(187);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 17 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(51),
	    getRawTag = __webpack_require__(359),
	    objectToString = __webpack_require__(385);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(336),
	    getValue = __webpack_require__(360);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(53),
	    isLength = __webpack_require__(195);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(106),
	    baseAssignValue = __webpack_require__(107);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(176),
	    baseKeys = __webpack_require__(179),
	    isArrayLike = __webpack_require__(28);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(16);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 52 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(26),
	    isObject = __webpack_require__(22);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(373),
	    listCacheDelete = __webpack_require__(374),
	    listCacheGet = __webpack_require__(375),
	    listCacheHas = __webpack_require__(376),
	    listCacheSet = __webpack_require__(377);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(74);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(329),
	    baseIsNaN = __webpack_require__(335),
	    strictIndexOf = __webpack_require__(396);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(371);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(312),
	    Map = __webpack_require__(103),
	    Promise = __webpack_require__(314),
	    Set = __webpack_require__(315),
	    WeakMap = __webpack_require__(318),
	    baseGetTag = __webpack_require__(26),
	    toSource = __webpack_require__(193);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(27);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 74 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(333),
	    isObjectLike = __webpack_require__(17);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(16),
	    stubFalse = __webpack_require__(411);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(164)(module)))

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(176),
	    baseKeysIn = __webpack_require__(339),
	    isArrayLike = __webpack_require__(28);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _cloudinaryCore = __webpack_require__(102);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var camelCase = _cloudinaryCore.Util.camelCase;
	var snakeCase = _cloudinaryCore.Util.snakeCase;
	/**
	 * A base component for Cloudinary components.
	 * @protected
	 */
	
	var CloudinaryComponent =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(CloudinaryComponent, _Component);
	
	  function CloudinaryComponent(props, context) {
	    _classCallCheck(this, CloudinaryComponent);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(CloudinaryComponent).call(this, props, context));
	  }
	
	  _createClass(CloudinaryComponent, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {};
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }, {
	    key: "getChildTransformations",
	    value: function getChildTransformations(children) {
	      var _this = this;
	
	      if (children === undefined || children === null) return null;
	
	      var mapped = _react.default.Children.map(children, function (child) {
	        if (!_react.default.isValidElement(child)) {
	          // child is not an element (e.g. simple text)
	          return;
	        }
	
	        var options = {};
	
	        if (child.type && child.type.exposesProps) {
	          options = CloudinaryComponent.normalizeOptions(child.props, child.context);
	        }
	
	        var childOptions = _this.getChildTransformations(child.props.children);
	
	        if (childOptions !== undefined && childOptions !== null) {
	          options.transformation = childOptions;
	        }
	
	        return options;
	      });
	
	      if (mapped != null) {
	        return mapped.filter(function (o) {
	          return !_cloudinaryCore.Util.isEmpty(o);
	        });
	      } else return null;
	    }
	    /**
	     * Returns an object with all the transformation parameters based on the context and properties of this element
	     * and any children.
	     * @param extendedProps
	     * @returns {object} a hash of transformation and configuration parameters
	     * @protected
	     */
	
	  }, {
	    key: "getTransformation",
	    value: function getTransformation(extendedProps) {
	      var transformation;
	
	      if (extendedProps.children !== undefined) {
	        var childrenOptions = this.getChildTransformations(extendedProps.children);
	
	        if (!_cloudinaryCore.Util.isEmpty(childrenOptions)) {
	          transformation = childrenOptions;
	          return _objectSpread({}, extendedProps, {
	            transformation: transformation
	          });
	        }
	      }
	
	      return _objectSpread({}, extendedProps);
	    }
	    /**
	     * Combine properties of all options to create an option Object that can be passed to Cloudinary methods.<br>
	     *   `undefined` and `null` values are filtered out.
	     * @protected
	     * @returns {Object}
	     * @param options one or more options objects
	     */
	
	  }, {
	    key: "getUrl",
	
	    /**
	     * Generate a Cloudinary resource URL based on the options provided and child Transformation elements
	     * @param extendedProps React props combined with custom Cloudinary configuration options
	     * @returns {string} a cloudinary URL
	     * @protected
	     */
	    value: function getUrl(extendedProps) {
	      var transformation = this.getTransformation(extendedProps);
	
	      var cl = _cloudinaryCore.Cloudinary.new(_cloudinaryCore.Util.withSnakeCaseKeys(extendedProps));
	
	      return cl.url(extendedProps.publicId, transformation);
	    }
	  }], [{
	    key: "normalizeOptions",
	    value: function normalizeOptions() {
	      for (var _len = arguments.length, options = new Array(_len), _key = 0; _key < _len; _key++) {
	        options[_key] = arguments[_key];
	      }
	
	      return options.reduce(function (left, right) {
	        for (var key in right) {
	          var value = right[key];
	
	          if (value !== null && value !== undefined) {
	            left[key] = value;
	          }
	        }
	
	        return left;
	      }, {});
	    }
	  }]);
	
	  return CloudinaryComponent;
	}(_react.Component);
	
	CloudinaryComponent.VALID_OPTIONS = _cloudinaryCore.Transformation.PARAM_NAMES.map(camelCase);
	CloudinaryComponent.contextTypes = typesFrom(CloudinaryComponent.VALID_OPTIONS);
	CloudinaryComponent.propTypes = CloudinaryComponent.contextTypes;
	CloudinaryComponent.propTypes.publicId = _propTypes.default.string;
	CloudinaryComponent.propTypes.responsive = _propTypes.default.bool;
	CloudinaryComponent.childContextTypes = {};
	/**
	 * Create a React type definition object. All items are PropTypes.string or [string] or object or [object].
	 * @param {Array} configParams a list of parameter names
	 * @returns {Object}
	 * @private
	 */
	
	function typesFrom(configParams) {
	  configParams = configParams || [];
	  var types = {};
	
	  for (var i = 0; i < configParams.length; i++) {
	    var key = configParams[i];
	    types[camelCase(key)] = _propTypes.default.any;
	  }
	
	  return types;
	}
	
	var _default = CloudinaryComponent;
	exports.default = _default;

/***/ }),
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(12);
	var normalizeHeaderName = __webpack_require__(279);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(165);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(165);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45)))

/***/ }),
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Buffer, process) {
	/**
	 * Cloudinary's JavaScript library - Version 2.5.0
	 * Copyright Cloudinary
	 * see https://github.com/cloudinary/cloudinary_js
	 *
	 */
	var slice = [].slice,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	(function(root, factory) {
	  var factoryWrapper, name, ref, results, value;
	  factoryWrapper = function(assign, cloneDeep, compact, difference, functions, identity, includes, isArray, isElement, isEmpty, isFunction, isPlainObject, isString, merge, trim) {
	    return factory({
	      assign: assign,
	      cloneDeep: cloneDeep,
	      compact: compact,
	      difference: difference,
	      functions: functions,
	      identity: identity,
	      includes: includes,
	      isArray: isArray,
	      isElement: isElement,
	      isEmpty: isEmpty,
	      isFunction: isFunction,
	      isPlainObject: isPlainObject,
	      isString: isString,
	      merge: merge,
	      trim: trim
	    });
	  };
	  if (true) {
	    return !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(399), __webpack_require__(400), __webpack_require__(401), __webpack_require__(403), __webpack_require__(404), __webpack_require__(112), __webpack_require__(405), __webpack_require__(21), __webpack_require__(406), __webpack_require__(407), __webpack_require__(53), __webpack_require__(113), __webpack_require__(196), __webpack_require__(410), __webpack_require__(417)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factoryWrapper), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    return module.exports = factoryWrapper(require('lodash/assign'), require('lodash/cloneDeep'), require('lodash/compact'), require('lodash/difference'), require('lodash/functions'), require('lodash/identity'), require('lodash/includes'), require('lodash/isArray'), require('lodash/isElement'), require('lodash/isEmpty'), require('lodash/isFunction'), require('lodash/isPlainObject'), require('lodash/isString'), require('lodash/merge'), require('lodash/trim'));
	  } else {
	    root.cloudinary || (root.cloudinary = {});
	    ref = factory(_);
	    results = [];
	    for (name in ref) {
	      value = ref[name];
	      results.push(root.cloudinary[name] = value);
	    }
	    return results;
	  }
	})(this, function(_) {
	
	  /*
	   * Includes common utility methods and shims
	   */
	
	  /**
	   * Return true if all items in list are strings
	   * @function Util.allString
	   * @param {Array} list - an array of items
	   */
	  var ArrayParam, BaseUtil, ClientHintsMetaTag, Cloudinary, Condition, Configuration, Expression, ExpressionParam, FetchLayer, HtmlTag, ImageTag, Layer, LayerParam, Param, RangeParam, RawParam, SubtitlesLayer, TextLayer, Transformation, TransformationBase, TransformationParam, Util, VideoTag, addClass, allStrings, augmentWidthOrHeight, base64Encode, base64EncodeURL, camelCase, cloudinary, contains, convertKeys, crc32, cssExpand, cssValue, curCSS, defaults, domStyle, funcTag, getAttribute, getData, getStyles, getWidthOrHeight, hasClass, isFunction, isNumberLike, isObject, m, objToString, objectProto, parameters, pnum, reWords, removeAttribute, rnumnonpx, setAttribute, setAttributes, setData, smartEscape, snakeCase, utf8_encode, width, withCamelCaseKeys, withSnakeCaseKeys, without;
	  allStrings = function(list) {
	    var item, j, len;
	    for (j = 0, len = list.length; j < len; j++) {
	      item = list[j];
	      if (!Util.isString(item)) {
	        return false;
	      }
	    }
	    return true;
	  };
	
	  /**
	  * Creates a new array without the given item.
	  * @function Util.without
	  * @param {Array} array - original array
	  * @param {*} item - the item to exclude from the new array
	  * @return {Array} a new array made of the original array's items except for `item`
	   */
	  without = function(array, item) {
	    var i, length, newArray;
	    newArray = [];
	    i = -1;
	    length = array.length;
	    while (++i < length) {
	      if (array[i] !== item) {
	        newArray.push(array[i]);
	      }
	    }
	    return newArray;
	  };
	
	  /**
	  * Return true is value is a number or a string representation of a number.
	  * @function Util.isNumberLike
	  * @param {*} value
	  * @returns {boolean} true if value is a number
	  * @example
	  *    Util.isNumber(0) // true
	  *    Util.isNumber("1.3") // true
	  *    Util.isNumber("") // false
	  *    Util.isNumber(undefined) // false
	   */
	  isNumberLike = function(value) {
	    return (value != null) && !isNaN(parseFloat(value));
	  };
	
	  /**
	   * Escape all characters matching unsafe in the given string
	   * @function Util.smartEscape
	   * @param {string} string - source string to escape
	   * @param {RegExp} unsafe - characters that must be escaped
	   * @return {string} escaped string
	   */
	  smartEscape = function(string, unsafe) {
	    if (unsafe == null) {
	      unsafe = /([^a-zA-Z0-9_.\-\/:]+)/g;
	    }
	    return string.replace(unsafe, function(match) {
	      return match.split("").map(function(c) {
	        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
	      }).join("");
	    });
	  };
	
	  /**
	   * Assign values from sources if they are not defined in the destination.
	   * Once a value is set it does not change
	   * @function Util.defaults
	   * @param {Object} destination - the object to assign defaults to
	   * @param {...Object} source - the source object(s) to assign defaults from
	   * @return {Object} destination after it was modified
	   */
	  defaults = function() {
	    var destination, sources;
	    destination = arguments[0], sources = 2 <= arguments.length ? slice.call(arguments, 1) : [];
	    return sources.reduce(function(dest, source) {
	      var key, value;
	      for (key in source) {
	        value = source[key];
	        if (dest[key] === void 0) {
	          dest[key] = value;
	        }
	      }
	      return dest;
	    }, destination);
	  };
	
	  /*********** lodash functions */
	  objectProto = Object.prototype;
	
	  /**
	   * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	   * of values.
	   */
	  objToString = objectProto.toString;
	
	  /**
	   * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	   * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	   *
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	   * @example
	   *
	  #isObject({});
	   * // => true
	   *
	  #isObject([1, 2, 3]);
	   * // => true
	   *
	  #isObject(1);
	   * // => false
	   */
	  isObject = function(value) {
	    var type;
	    type = typeof value;
	    return !!value && (type === 'object' || type === 'function');
	  };
	  funcTag = '[object Function]';
	
	  /**
	  * Checks if `value` is classified as a `Function` object.
	  * @function Util.isFunction
	  * @param {*} value The value to check.
	  * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	  * @example
	  *
	  * function Foo(){};  
	  * isFunction(Foo);
	  * // => true
	  *
	  * isFunction(/abc/);
	  * // => false
	   */
	  isFunction = function(value) {
	    return isObject(value) && objToString.call(value) === funcTag;
	  };
	
	  /*********** lodash functions */
	
	  /** Used to match words to create compound words. */
	  reWords = (function() {
	    var lower, upper;
	    upper = '[A-Z]';
	    lower = '[a-z]+';
	    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
	  })();
	
	  /**
	  * Convert string to camelCase
	  * @function Util.camelCase
	  * @param {string} string - the string to convert
	  * @return {string} in camelCase format
	   */
	  camelCase = function(source) {
	    var i, word, words;
	    words = source.match(reWords);
	    words = (function() {
	      var j, len, results;
	      results = [];
	      for (i = j = 0, len = words.length; j < len; i = ++j) {
	        word = words[i];
	        word = word.toLocaleLowerCase();
	        if (i) {
	          results.push(word.charAt(0).toLocaleUpperCase() + word.slice(1));
	        } else {
	          results.push(word);
	        }
	      }
	      return results;
	    })();
	    return words.join('');
	  };
	
	  /**
	   * Convert string to snake_case
	   * @function Util.snakeCase
	   * @param {string} string - the string to convert
	   * @return {string} in snake_case format
	   */
	  snakeCase = function(source) {
	    var i, word, words;
	    words = source.match(reWords);
	    words = (function() {
	      var j, len, results;
	      results = [];
	      for (i = j = 0, len = words.length; j < len; i = ++j) {
	        word = words[i];
	        results.push(word.toLocaleLowerCase());
	      }
	      return results;
	    })();
	    return words.join('_');
	  };
	  convertKeys = function(source, converter) {
	    var key, result, value;
	    if (converter == null) {
	      converter = Util.identity;
	    }
	    result = {};
	    for (key in source) {
	      value = source[key];
	      key = converter(key);
	      if (!Util.isEmpty(key)) {
	        result[key] = value;
	      }
	    }
	    return result;
	  };
	
	  /**
	   * Create a copy of the source object with all keys in camelCase
	   * @function Util.withCamelCaseKeys
	   * @param {Object} value - the object to copy
	   * @return {Object} a new object
	   */
	  withCamelCaseKeys = function(source) {
	    return convertKeys(source, Util.camelCase);
	  };
	
	  /**
	   * Create a copy of the source object with all keys in snake_case
	   * @function Util.withSnakeCaseKeys
	   * @param {Object} value - the object to copy
	   * @return {Object} a new object
	   */
	  withSnakeCaseKeys = function(source) {
	    return convertKeys(source, Util.snakeCase);
	  };
	  base64Encode = typeof btoa !== 'undefined' && isFunction(btoa) ? btoa : typeof Buffer !== 'undefined' && isFunction(Buffer) ? function(input) {
	    if (!(input instanceof Buffer)) {
	      input = new Buffer.from(String(input), 'binary');
	    }
	    return input.toString('base64');
	  } : function(input) {
	    throw new Error("No base64 encoding function found");
	  };
	
	  /**
	  * Returns the Base64-decoded version of url.<br>
	  * This method delegates to `btoa` if present. Otherwise it tries `Buffer`.
	  * @function Util.base64EncodeURL
	  * @param {string} url - the url to encode. the value is URIdecoded and then re-encoded before converting to base64 representation
	  * @return {string} the base64 representation of the URL
	   */
	  base64EncodeURL = function(input) {
	    var error1, ignore;
	    try {
	      input = decodeURI(input);
	    } catch (error1) {
	      ignore = error1;
	    }
	    input = encodeURI(input);
	    return base64Encode(input);
	  };
	  BaseUtil = {
	    allStrings: allStrings,
	    camelCase: camelCase,
	    convertKeys: convertKeys,
	    defaults: defaults,
	    snakeCase: snakeCase,
	    without: without,
	    isFunction: isFunction,
	    isNumberLike: isNumberLike,
	    smartEscape: smartEscape,
	    withCamelCaseKeys: withCamelCaseKeys,
	    withSnakeCaseKeys: withSnakeCaseKeys,
	    base64EncodeURL: base64EncodeURL
	  };
	
	  /*
	   * Includes utility methods and lodash / jQuery shims
	   */
	
	  /**
	   * Get data from the DOM element.
	   *
	   * This method will use jQuery's `data()` method if it is available, otherwise it will get the `data-` attribute
	   * @param {Element} element - the element to get the data from
	   * @param {string} name - the name of the data item
	   * @returns the value associated with the `name`
	   * @function Util.getData
	   */
	  getData = function(element, name) {
	    var ref;
	    switch (false) {
	      case !(element == null):
	        return void 0;
	      case !_.isFunction(element.getAttribute):
	        return element.getAttribute("data-" + name);
	      case !_.isFunction(element.getAttr):
	        return element.getAttr("data-" + name);
	      case !_.isFunction(element.data):
	        return element.data(name);
	      case !(_.isFunction(typeof jQuery !== "undefined" && jQuery !== null ? (ref = jQuery.fn) != null ? ref.data : void 0 : void 0) && _.isElement(element)):
	        return jQuery(element).data(name);
	    }
	  };
	
	  /**
	   * Set data in the DOM element.
	   *
	   * This method will use jQuery's `data()` method if it is available, otherwise it will set the `data-` attribute
	   * @function Util.setData
	   * @param {Element} element - the element to set the data in
	   * @param {string} name - the name of the data item
	   * @param {*} value - the value to be set
	   *
	   */
	  setData = function(element, name, value) {
	    var ref;
	    switch (false) {
	      case !(element == null):
	        return void 0;
	      case !_.isFunction(element.setAttribute):
	        return element.setAttribute("data-" + name, value);
	      case !_.isFunction(element.setAttr):
	        return element.setAttr("data-" + name, value);
	      case !_.isFunction(element.data):
	        return element.data(name, value);
	      case !(_.isFunction(typeof jQuery !== "undefined" && jQuery !== null ? (ref = jQuery.fn) != null ? ref.data : void 0 : void 0) && _.isElement(element)):
	        return jQuery(element).data(name, value);
	    }
	  };
	
	  /**
	   * Get attribute from the DOM element.
	   *
	   * @function Util.getAttribute
	   * @param {Element} element - the element to set the attribute for
	   * @param {string} name - the name of the attribute
	   * @returns {*} the value of the attribute
	   *
	   */
	  getAttribute = function(element, name) {
	    switch (false) {
	      case !(element == null):
	        return void 0;
	      case !_.isFunction(element.getAttribute):
	        return element.getAttribute(name);
	      case !_.isFunction(element.attr):
	        return element.attr(name);
	      case !_.isFunction(element.getAttr):
	        return element.getAttr(name);
	    }
	  };
	
	  /**
	   * Set attribute in the DOM element.
	   *
	   * @function Util.setAttribute
	   * @param {Element} element - the element to set the attribute for
	   * @param {string} name - the name of the attribute
	   * @param {*} value - the value to be set
	   */
	  setAttribute = function(element, name, value) {
	    switch (false) {
	      case !(element == null):
	        return void 0;
	      case !_.isFunction(element.setAttribute):
	        return element.setAttribute(name, value);
	      case !_.isFunction(element.attr):
	        return element.attr(name, value);
	      case !_.isFunction(element.setAttr):
	        return element.setAttr(name, value);
	    }
	  };
	
	  /**
	   * Remove an attribute in the DOM element.
	   *
	   * @function Util.removeAttribute
	   * @param {Element} element - the element to set the attribute for
	   * @param {string} name - the name of the attribute
	   */
	  removeAttribute = function(element, name) {
	    switch (false) {
	      case !(element == null):
	        return void 0;
	      case !_.isFunction(element.removeAttribute):
	        return element.removeAttribute(name);
	      default:
	        return setAttribute(element, void 0);
	    }
	  };
	
	  /**
	    * Set a group of attributes to the element
	    * @function Util.setAttributes
	    * @param {Element} element - the element to set the attributes for
	    * @param {Object} attributes - a hash of attribute names and values
	   */
	  setAttributes = function(element, attributes) {
	    var name, results, value;
	    results = [];
	    for (name in attributes) {
	      value = attributes[name];
	      if (value != null) {
	        results.push(setAttribute(element, name, value));
	      } else {
	        results.push(removeAttribute(element, name));
	      }
	    }
	    return results;
	  };
	
	  /**
	    * Checks if element has a css class
	    * @function Util.hasClass
	    * @param {Element} element - the element to check
	    * @param {string} name - the class name
	    @returns {boolean} true if the element has the class
	   */
	  hasClass = function(element, name) {
	    if (_.isElement(element)) {
	      return element.className.match(new RegExp("\\b" + name + "\\b"));
	    }
	  };
	
	  /**
	    * Add class to the element
	    * @function Util.addClass
	    * @param {Element} element - the element
	    * @param {string} name - the class name to add
	   */
	  addClass = function(element, name) {
	    if (!element.className.match(new RegExp("\\b" + name + "\\b"))) {
	      return element.className = _.trim(element.className + " " + name);
	    }
	  };
	  getStyles = function(elem) {
	    if (elem.ownerDocument.defaultView.opener) {
	      return elem.ownerDocument.defaultView.getComputedStyle(elem, null);
	    }
	    return window.getComputedStyle(elem, null);
	  };
	  cssExpand = ["Top", "Right", "Bottom", "Left"];
	  contains = function(a, b) {
	    var adown, bup;
	    adown = (a.nodeType === 9 ? a.documentElement : a);
	    bup = b && b.parentNode;
	    return a === bup || !!(bup && bup.nodeType === 1 && adown.contains(bup));
	  };
	  domStyle = function(elem, name) {
	    if (!(!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style)) {
	      return elem.style[name];
	    }
	  };
	  curCSS = function(elem, name, computed) {
	    var maxWidth, minWidth, ret, rmargin, style, width;
	    rmargin = /^margin/;
	    width = void 0;
	    minWidth = void 0;
	    maxWidth = void 0;
	    ret = void 0;
	    style = elem.style;
	    computed = computed || getStyles(elem);
	    if (computed) {
	      ret = computed.getPropertyValue(name) || computed[name];
	    }
	    if (computed) {
	      if (ret === "" && !contains(elem.ownerDocument, elem)) {
	        ret = domStyle(elem, name);
	      }
	      if (rnumnonpx.test(ret) && rmargin.test(name)) {
	        width = style.width;
	        minWidth = style.minWidth;
	        maxWidth = style.maxWidth;
	        style.minWidth = style.maxWidth = style.width = ret;
	        ret = computed.width;
	        style.width = width;
	        style.minWidth = minWidth;
	        style.maxWidth = maxWidth;
	      }
	    }
	    if (ret !== undefined) {
	      return ret + "";
	    } else {
	      return ret;
	    }
	  };
	  cssValue = function(elem, name, convert, styles) {
	    var val;
	    val = curCSS(elem, name, styles);
	    if (convert) {
	      return parseFloat(val);
	    } else {
	      return val;
	    }
	  };
	  augmentWidthOrHeight = function(elem, name, extra, isBorderBox, styles) {
	    var j, len, side, sides, val;
	    if (extra === (isBorderBox ? "border" : "content")) {
	      return 0;
	    } else {
	      sides = name === "width" ? ["Right", "Left"] : ["Top", "Bottom"];
	      val = 0;
	      for (j = 0, len = sides.length; j < len; j++) {
	        side = sides[j];
	        if (extra === "margin") {
	          val += cssValue(elem, extra + side, true, styles);
	        }
	        if (isBorderBox) {
	          if (extra === "content") {
	            val -= cssValue(elem, "padding" + side, true, styles);
	          }
	          if (extra !== "margin") {
	            val -= cssValue(elem, "border" + side + "Width", true, styles);
	          }
	        } else {
	          val += cssValue(elem, "padding" + side, true, styles);
	          if (extra !== "padding") {
	            val += cssValue(elem, "border" + side + "Width", true, styles);
	          }
	        }
	      }
	      return val;
	    }
	  };
	  pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
	  rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
	  getWidthOrHeight = function(elem, name, extra) {
	    var isBorderBox, styles, val, valueIsBorderBox;
	    valueIsBorderBox = true;
	    val = (name === "width" ? elem.offsetWidth : elem.offsetHeight);
	    styles = getStyles(elem);
	    isBorderBox = cssValue(elem, "boxSizing", false, styles) === "border-box";
	    if (val <= 0 || (val == null)) {
	      val = curCSS(elem, name, styles);
	      if (val < 0 || (val == null)) {
	        val = elem.style[name];
	      }
	      if (rnumnonpx.test(val)) {
	        return val;
	      }
	      valueIsBorderBox = isBorderBox && (val === elem.style[name]);
	      val = parseFloat(val) || 0;
	    }
	    return val + augmentWidthOrHeight(elem, name, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles);
	  };
	  width = function(element) {
	    return getWidthOrHeight(element, "width", "content");
	  };
	
	  /**
	   * @class Util
	   */
	  Util = _.assign(BaseUtil, {
	    hasClass: hasClass,
	    addClass: addClass,
	    getAttribute: getAttribute,
	    setAttribute: setAttribute,
	    removeAttribute: removeAttribute,
	    setAttributes: setAttributes,
	    getData: getData,
	    setData: setData,
	    width: width,
	
	    /**
	     * Returns true if item is a string
	     * @function Util.isString
	     * @param item
	     * @returns {boolean} true if item is a string
	     */
	    isString: _.isString,
	    isArray: _.isArray,
	
	    /**
	     * Returns true if item is empty:
	     * <ul>
	     *   <li>item is null or undefined</li>
	     *   <li>item is an array or string of length 0</li>
	     *   <li>item is an object with no keys</li>
	     * </ul>
	     * @function Util.isEmpty
	     * @param item
	     * @returns {boolean} true if item is empty
	     */
	    isEmpty: _.isEmpty,
	
	    /**
	     * Assign source properties to destination.
	     * If the property is an object it is assigned as a whole, overriding the destination object.
	     * @function Util.assign
	     * @param {Object} destination - the object to assign to
	     */
	    assign: _.assign,
	
	    /**
	     * Recursively assign source properties to destination
	     * @function Util.merge
	     * @param {Object} destination - the object to assign to
	     * @param {...Object} [sources] The source objects.
	     */
	    merge: _.merge,
	
	    /**
	     * Create a new copy of the given object, including all internal objects.
	     * @function Util.cloneDeep
	     * @param {Object} value - the object to clone
	     * @return {Object} a new deep copy of the object
	     */
	    cloneDeep: _.cloneDeep,
	
	    /**
	     * Creates a new array from the parameter with "falsey" values removed
	     * @function Util.compact
	     * @param {Array} array - the array to remove values from
	     * @return {Array} a new array without falsey values
	     */
	    compact: _.compact,
	
	    /**
	     * Check if a given item is included in the given array
	     * @function Util.contains
	     * @param {Array} array - the array to search in
	     * @param {*} item - the item to search for
	     * @return {boolean} true if the item is included in the array
	     */
	    contains: _.includes,
	
	    /**
	     * Returns values in the given array that are not included in the other array
	     * @function Util.difference
	     * @param {Array} arr - the array to select from
	     * @param {Array} values - values to filter from arr
	     * @return {Array} the filtered values
	     */
	    difference: _.difference,
	
	    /**
	     * Returns a list of all the function names in obj
	     * @function Util.functions
	     * @param {Object} object - the object to inspect
	     * @return {Array} a list of functions of object
	     */
	    functions: _.functions,
	
	    /**
	     * Returns the provided value. This functions is used as a default predicate function.
	     * @function Util.identity
	     * @param {*} value
	     * @return {*} the provided value
	     */
	    identity: _.identity,
	    isPlainObject: _.isPlainObject,
	
	    /**
	     * Remove leading or trailing spaces from text
	     * @function Util.trim
	     * @param {string} text
	     * @return {string} the `text` without leading or trailing spaces
	     */
	    trim: _.trim
	  });
	
	  /**
	   * UTF8 encoder
	   *
	   */
	  utf8_encode = function(argString) {
	    var c1, enc, end, n, start, string, stringl, utftext;
	    if (argString === null || typeof argString === 'undefined') {
	      return '';
	    }
	    string = argString + '';
	    utftext = '';
	    start = void 0;
	    end = void 0;
	    stringl = 0;
	    start = end = 0;
	    stringl = string.length;
	    n = 0;
	    while (n < stringl) {
	      c1 = string.charCodeAt(n);
	      enc = null;
	      if (c1 < 128) {
	        end++;
	      } else if (c1 > 127 && c1 < 2048) {
	        enc = String.fromCharCode(c1 >> 6 | 192, c1 & 63 | 128);
	      } else {
	        enc = String.fromCharCode(c1 >> 12 | 224, c1 >> 6 & 63 | 128, c1 & 63 | 128);
	      }
	      if (enc !== null) {
	        if (end > start) {
	          utftext += string.slice(start, end);
	        }
	        utftext += enc;
	        start = end = n + 1;
	      }
	      n++;
	    }
	    if (end > start) {
	      utftext += string.slice(start, stringl);
	    }
	    return utftext;
	  };
	
	  /**
	   * CRC32 calculator
	   * Depends on 'utf8_encode'
	   */
	  crc32 = function(str) {
	    var crc, i, iTop, table, x, y;
	    str = utf8_encode(str);
	    table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
	    crc = 0;
	    x = 0;
	    y = 0;
	    crc = crc ^ -1;
	    i = 0;
	    iTop = str.length;
	    while (i < iTop) {
	      y = (crc ^ str.charCodeAt(i)) & 0xFF;
	      x = '0x' + table.substr(y * 9, 8);
	      crc = crc >>> 8 ^ x;
	      i++;
	    }
	    crc = crc ^ -1;
	    if (crc < 0) {
	      crc += 4294967296;
	    }
	    return crc;
	  };
	  Layer = (function() {
	
	    /**
	     * Layer
	     * @constructor Layer
	     * @param {Object} options - layer parameters
	     */
	    function Layer(options) {
	      this.options = {};
	      if (options != null) {
	        ["resourceType", "type", "publicId", "format"].forEach((function(_this) {
	          return function(key) {
	            var ref;
	            return _this.options[key] = (ref = options[key]) != null ? ref : options[Util.snakeCase(key)];
	          };
	        })(this));
	      }
	    }
	
	    Layer.prototype.resourceType = function(value) {
	      this.options.resourceType = value;
	      return this;
	    };
	
	    Layer.prototype.type = function(value) {
	      this.options.type = value;
	      return this;
	    };
	
	    Layer.prototype.publicId = function(value) {
	      this.options.publicId = value;
	      return this;
	    };
	
	
	    /**
	     * Get the public ID, formatted for layer parameter
	     * @function Layer#getPublicId
	     * @return {String} public ID
	     */
	
	    Layer.prototype.getPublicId = function() {
	      var ref;
	      return (ref = this.options.publicId) != null ? ref.replace(/\//g, ":") : void 0;
	    };
	
	
	    /**
	     * Get the public ID, with format if present
	     * @function Layer#getFullPublicId
	     * @return {String} public ID
	     */
	
	    Layer.prototype.getFullPublicId = function() {
	      if (this.options.format != null) {
	        return this.getPublicId() + "." + this.options.format;
	      } else {
	        return this.getPublicId();
	      }
	    };
	
	    Layer.prototype.format = function(value) {
	      this.options.format = value;
	      return this;
	    };
	
	
	    /**
	     * generate the string representation of the layer
	     * @function Layer#toString
	     */
	
	    Layer.prototype.toString = function() {
	      var components;
	      components = [];
	      if (this.options.publicId == null) {
	        throw "Must supply publicId";
	      }
	      if (!(this.options.resourceType === "image")) {
	        components.push(this.options.resourceType);
	      }
	      if (!(this.options.type === "upload")) {
	        components.push(this.options.type);
	      }
	      components.push(this.getFullPublicId());
	      return Util.compact(components).join(":");
	    };
	
	    return Layer;
	
	  })();
	  FetchLayer = (function(superClass) {
	    extend(FetchLayer, superClass);
	
	
	    /**
	     * @constructor FetchLayer
	     * @param {Object|string} options - layer parameters or a url
	     * @param {string} options.url the url of the image to fetch
	     */
	
	    function FetchLayer(options) {
	      FetchLayer.__super__.constructor.call(this, options);
	      if (Util.isString(options)) {
	        this.options.url = options;
	      } else if (options != null ? options.url : void 0) {
	        this.options.url = options.url;
	      }
	    }
	
	    FetchLayer.prototype.url = function(url) {
	      this.options.url = url;
	      return this;
	    };
	
	
	    /**
	     * generate the string representation of the layer
	     * @function FetchLayer#toString
	     * @return {String}
	     */
	
	    FetchLayer.prototype.toString = function() {
	      return "fetch:" + (cloudinary.Util.base64EncodeURL(this.options.url));
	    };
	
	    return FetchLayer;
	
	  })(Layer);
	  TextLayer = (function(superClass) {
	    extend(TextLayer, superClass);
	
	
	    /**
	     * @constructor TextLayer
	     * @param {Object} options - layer parameters
	     */
	
	    function TextLayer(options) {
	      var keys;
	      TextLayer.__super__.constructor.call(this, options);
	      keys = ["resourceType", "resourceType", "fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlign", "stroke", "letterSpacing", "lineSpacing", "text"];
	      if (options != null) {
	        keys.forEach((function(_this) {
	          return function(key) {
	            var ref;
	            return _this.options[key] = (ref = options[key]) != null ? ref : options[Util.snakeCase(key)];
	          };
	        })(this));
	      }
	      this.options.resourceType = "text";
	    }
	
	    TextLayer.prototype.resourceType = function(resourceType) {
	      throw "Cannot modify resourceType for text layers";
	    };
	
	    TextLayer.prototype.type = function(type) {
	      throw "Cannot modify type for text layers";
	    };
	
	    TextLayer.prototype.format = function(format) {
	      throw "Cannot modify format for text layers";
	    };
	
	    TextLayer.prototype.fontFamily = function(fontFamily) {
	      this.options.fontFamily = fontFamily;
	      return this;
	    };
	
	    TextLayer.prototype.fontSize = function(fontSize) {
	      this.options.fontSize = fontSize;
	      return this;
	    };
	
	    TextLayer.prototype.fontWeight = function(fontWeight) {
	      this.options.fontWeight = fontWeight;
	      return this;
	    };
	
	    TextLayer.prototype.fontStyle = function(fontStyle) {
	      this.options.fontStyle = fontStyle;
	      return this;
	    };
	
	    TextLayer.prototype.textDecoration = function(textDecoration) {
	      this.options.textDecoration = textDecoration;
	      return this;
	    };
	
	    TextLayer.prototype.textAlign = function(textAlign) {
	      this.options.textAlign = textAlign;
	      return this;
	    };
	
	    TextLayer.prototype.stroke = function(stroke) {
	      this.options.stroke = stroke;
	      return this;
	    };
	
	    TextLayer.prototype.letterSpacing = function(letterSpacing) {
	      this.options.letterSpacing = letterSpacing;
	      return this;
	    };
	
	    TextLayer.prototype.lineSpacing = function(lineSpacing) {
	      this.options.lineSpacing = lineSpacing;
	      return this;
	    };
	
	    TextLayer.prototype.text = function(text) {
	      this.options.text = text;
	      return this;
	    };
	
	
	    /**
	     * generate the string representation of the layer
	     * @function TextLayer#toString
	     * @return {String}
	     */
	
	    TextLayer.prototype.toString = function() {
	      var components, hasPublicId, hasStyle, publicId, re, res, start, style, text, textSource;
	      style = this.textStyleIdentifier();
	      if (this.options.publicId != null) {
	        publicId = this.getFullPublicId();
	      }
	      if (this.options.text != null) {
	        hasPublicId = !Util.isEmpty(publicId);
	        hasStyle = !Util.isEmpty(style);
	        if (hasPublicId && hasStyle || !hasPublicId && !hasStyle) {
	          throw "Must supply either style parameters or a public_id when providing text parameter in a text overlay/underlay, but not both!";
	        }
	        re = /\$\([a-zA-Z]\w*\)/g;
	        start = 0;
	        textSource = Util.smartEscape(this.options.text, /[,\/]/g);
	        text = "";
	        while (res = re.exec(textSource)) {
	          text += Util.smartEscape(textSource.slice(start, res.index));
	          text += res[0];
	          start = res.index + res[0].length;
	        }
	        text += Util.smartEscape(textSource.slice(start));
	      }
	      components = [this.options.resourceType, style, publicId, text];
	      return Util.compact(components).join(":");
	    };
	
	    TextLayer.prototype.textStyleIdentifier = function() {
	      var components;
	      components = [];
	      if (this.options.fontWeight !== "normal") {
	        components.push(this.options.fontWeight);
	      }
	      if (this.options.fontStyle !== "normal") {
	        components.push(this.options.fontStyle);
	      }
	      if (this.options.textDecoration !== "none") {
	        components.push(this.options.textDecoration);
	      }
	      components.push(this.options.textAlign);
	      if (this.options.stroke !== "none") {
	        components.push(this.options.stroke);
	      }
	      if (!(Util.isEmpty(this.options.letterSpacing) && !Util.isNumberLike(this.options.letterSpacing))) {
	        components.push("letter_spacing_" + this.options.letterSpacing);
	      }
	      if (!(Util.isEmpty(this.options.lineSpacing) && !Util.isNumberLike(this.options.lineSpacing))) {
	        components.push("line_spacing_" + this.options.lineSpacing);
	      }
	      if (!Util.isEmpty(Util.compact(components))) {
	        if (Util.isEmpty(this.options.fontFamily)) {
	          throw "Must supply fontFamily. " + components;
	        }
	        if (Util.isEmpty(this.options.fontSize) && !Util.isNumberLike(this.options.fontSize)) {
	          throw "Must supply fontSize.";
	        }
	      }
	      components.unshift(this.options.fontFamily, this.options.fontSize);
	      components = Util.compact(components).join("_");
	      return components;
	    };
	
	    return TextLayer;
	
	  })(Layer);
	  SubtitlesLayer = (function(superClass) {
	    extend(SubtitlesLayer, superClass);
	
	
	    /**
	     * Represent a subtitles layer
	     * @constructor SubtitlesLayer
	     * @param {Object} options - layer parameters
	     */
	
	    function SubtitlesLayer(options) {
	      SubtitlesLayer.__super__.constructor.call(this, options);
	      this.options.resourceType = "subtitles";
	    }
	
	    return SubtitlesLayer;
	
	  })(TextLayer);
	
	  /**
	   * Transformation parameters
	   * Depends on 'util', 'transformation'
	   */
	  Param = (function() {
	
	    /**
	     * Represents a single parameter
	     * @class Param
	     * @param {string} name - The name of the parameter in snake_case
	     * @param {string} shortName - The name of the serialized form of the parameter.
	     *                         If a value is not provided, the parameter will not be serialized.
	     * @param {function} [process=cloudinary.Util.identity ] - Manipulate origValue when value is called
	     * @ignore
	     */
	    function Param(name, shortName, process) {
	      if (process == null) {
	        process = cloudinary.Util.identity;
	      }
	
	      /**
	       * The name of the parameter in snake_case
	       * @member {string} Param#name
	       */
	      this.name = name;
	
	      /**
	       * The name of the serialized form of the parameter
	       * @member {string} Param#shortName
	       */
	      this.shortName = shortName;
	
	      /**
	       * Manipulate origValue when value is called
	       * @member {function} Param#process
	       */
	      this.process = process;
	    }
	
	
	    /**
	     * Set a (unprocessed) value for this parameter
	     * @function Param#set
	     * @param {*} origValue - the value of the parameter
	     * @return {Param} self for chaining
	     */
	
	    Param.prototype.set = function(origValue) {
	      this.origValue = origValue;
	      return this;
	    };
	
	
	    /**
	     * Generate the serialized form of the parameter
	     * @function Param#serialize
	     * @return {string} the serialized form of the parameter
	     */
	
	    Param.prototype.serialize = function() {
	      var val, valid;
	      val = this.value();
	      valid = cloudinary.Util.isArray(val) || cloudinary.Util.isPlainObject(val) || cloudinary.Util.isString(val) ? !cloudinary.Util.isEmpty(val) : val != null;
	      if ((this.shortName != null) && valid) {
	        return this.shortName + "_" + val;
	      } else {
	        return '';
	      }
	    };
	
	
	    /**
	     * Return the processed value of the parameter
	     * @function Param#value
	     */
	
	    Param.prototype.value = function() {
	      return this.process(this.origValue);
	    };
	
	    Param.norm_color = function(value) {
	      return value != null ? value.replace(/^#/, 'rgb:') : void 0;
	    };
	
	    Param.prototype.build_array = function(arg) {
	      if (arg == null) {
	        arg = [];
	      }
	      if (cloudinary.Util.isArray(arg)) {
	        return arg;
	      } else {
	        return [arg];
	      }
	    };
	
	
	    /**
	    * Covert value to video codec string.
	    *
	    * If the parameter is an object,
	    * @param {(string|Object)} param - the video codec as either a String or a Hash
	    * @return {string} the video codec string in the format codec:profile:level
	    * @example
	    * vc_[ :profile : [level]]
	    * or
	      { codec: 'h264', profile: 'basic', level: '3.1' }
	    * @ignore
	     */
	
	    Param.process_video_params = function(param) {
	      var video;
	      switch (param.constructor) {
	        case Object:
	          video = "";
	          if ('codec' in param) {
	            video = param['codec'];
	            if ('profile' in param) {
	              video += ":" + param['profile'];
	              if ('level' in param) {
	                video += ":" + param['level'];
	              }
	            }
	          }
	          return video;
	        case String:
	          return param;
	        default:
	          return null;
	      }
	    };
	
	    return Param;
	
	  })();
	  ArrayParam = (function(superClass) {
	    extend(ArrayParam, superClass);
	
	
	    /**
	     * A parameter that represents an array
	     * @param {string} name - The name of the parameter in snake_case
	     * @param {string} shortName - The name of the serialized form of the parameter
	     *                         If a value is not provided, the parameter will not be serialized.
	     * @param {string} [sep='.'] - The separator to use when joining the array elements together
	     * @param {function} [process=cloudinary.Util.identity ] - Manipulate origValue when value is called
	     * @class ArrayParam
	     * @extends Param
	     * @ignore
	     */
	
	    function ArrayParam(name, shortName, sep, process) {
	      if (sep == null) {
	        sep = '.';
	      }
	      this.sep = sep;
	      ArrayParam.__super__.constructor.call(this, name, shortName, process);
	    }
	
	    ArrayParam.prototype.serialize = function() {
	      var arrayValue, flat, t;
	      if (this.shortName != null) {
	        arrayValue = this.value();
	        if (cloudinary.Util.isEmpty(arrayValue)) {
	          return '';
	        } else if (cloudinary.Util.isString(arrayValue)) {
	          return this.shortName + "_" + arrayValue;
	        } else {
	          flat = (function() {
	            var j, len, results;
	            results = [];
	            for (j = 0, len = arrayValue.length; j < len; j++) {
	              t = arrayValue[j];
	              if (cloudinary.Util.isFunction(t.serialize)) {
	                results.push(t.serialize());
	              } else {
	                results.push(t);
	              }
	            }
	            return results;
	          })();
	          return this.shortName + "_" + (flat.join(this.sep));
	        }
	      } else {
	        return '';
	      }
	    };
	
	    ArrayParam.prototype.value = function() {
	      var j, len, ref, results, v;
	      if (cloudinary.Util.isArray(this.origValue)) {
	        ref = this.origValue;
	        results = [];
	        for (j = 0, len = ref.length; j < len; j++) {
	          v = ref[j];
	          results.push(this.process(v));
	        }
	        return results;
	      } else {
	        return this.process(this.origValue);
	      }
	    };
	
	    ArrayParam.prototype.set = function(origValue) {
	      if ((origValue == null) || cloudinary.Util.isArray(origValue)) {
	        return ArrayParam.__super__.set.call(this, origValue);
	      } else {
	        return ArrayParam.__super__.set.call(this, [origValue]);
	      }
	    };
	
	    return ArrayParam;
	
	  })(Param);
	  TransformationParam = (function(superClass) {
	    extend(TransformationParam, superClass);
	
	
	    /**
	     * A parameter that represents a transformation
	     * @param {string} name - The name of the parameter in snake_case
	     * @param {string} [shortName='t'] - The name of the serialized form of the parameter
	     * @param {string} [sep='.'] - The separator to use when joining the array elements together
	     * @param {function} [process=cloudinary.Util.identity ] - Manipulate origValue when value is called
	     * @class TransformationParam
	     * @extends Param
	     * @ignore
	     */
	
	    function TransformationParam(name, shortName, sep, process) {
	      if (shortName == null) {
	        shortName = "t";
	      }
	      if (sep == null) {
	        sep = '.';
	      }
	      this.sep = sep;
	      TransformationParam.__super__.constructor.call(this, name, shortName, process);
	    }
	
	    TransformationParam.prototype.serialize = function() {
	      var joined, result, t;
	      if (cloudinary.Util.isEmpty(this.value())) {
	        return '';
	      } else if (cloudinary.Util.allStrings(this.value())) {
	        joined = this.value().join(this.sep);
	        if (!cloudinary.Util.isEmpty(joined)) {
	          return this.shortName + "_" + joined;
	        } else {
	          return '';
	        }
	      } else {
	        result = (function() {
	          var j, len, ref, results;
	          ref = this.value();
	          results = [];
	          for (j = 0, len = ref.length; j < len; j++) {
	            t = ref[j];
	            if (t != null) {
	              if (cloudinary.Util.isString(t) && !cloudinary.Util.isEmpty(t)) {
	                results.push(this.shortName + "_" + t);
	              } else if (cloudinary.Util.isFunction(t.serialize)) {
	                results.push(t.serialize());
	              } else if (cloudinary.Util.isPlainObject(t) && !cloudinary.Util.isEmpty(t)) {
	                results.push(new Transformation(t).serialize());
	              } else {
	                results.push(void 0);
	              }
	            }
	          }
	          return results;
	        }).call(this);
	        return cloudinary.Util.compact(result);
	      }
	    };
	
	    TransformationParam.prototype.set = function(origValue1) {
	      this.origValue = origValue1;
	      if (cloudinary.Util.isArray(this.origValue)) {
	        return TransformationParam.__super__.set.call(this, this.origValue);
	      } else {
	        return TransformationParam.__super__.set.call(this, [this.origValue]);
	      }
	    };
	
	    return TransformationParam;
	
	  })(Param);
	  RangeParam = (function(superClass) {
	    extend(RangeParam, superClass);
	
	
	    /**
	     * A parameter that represents a range
	     * @param {string} name - The name of the parameter in snake_case
	     * @param {string} shortName - The name of the serialized form of the parameter
	     *                         If a value is not provided, the parameter will not be serialized.
	     * @param {function} [process=norm_range_value ] - Manipulate origValue when value is called
	     * @class RangeParam
	     * @extends Param
	     * @ignore
	     */
	
	    function RangeParam(name, shortName, process) {
	      if (process == null) {
	        process = this.norm_range_value;
	      }
	      RangeParam.__super__.constructor.call(this, name, shortName, process);
	    }
	
	    RangeParam.norm_range_value = function(value) {
	      var modifier, offset;
	      offset = String(value).match(new RegExp('^' + offset_any_pattern + '$'));
	      if (offset) {
	        modifier = offset[5] != null ? 'p' : '';
	        value = (offset[1] || offset[4]) + modifier;
	      }
	      return value;
	    };
	
	    return RangeParam;
	
	  })(Param);
	  RawParam = (function(superClass) {
	    extend(RawParam, superClass);
	
	    function RawParam(name, shortName, process) {
	      if (process == null) {
	        process = cloudinary.Util.identity;
	      }
	      RawParam.__super__.constructor.call(this, name, shortName, process);
	    }
	
	    RawParam.prototype.serialize = function() {
	      return this.value();
	    };
	
	    return RawParam;
	
	  })(Param);
	  LayerParam = (function(superClass) {
	    var LAYER_KEYWORD_PARAMS;
	
	    extend(LayerParam, superClass);
	
	    function LayerParam() {
	      return LayerParam.__super__.constructor.apply(this, arguments);
	    }
	
	    LayerParam.prototype.value = function() {
	      var layerOptions, result;
	      layerOptions = this.origValue;
	      if (cloudinary.Util.isPlainObject(layerOptions)) {
	        layerOptions = Util.withCamelCaseKeys(layerOptions);
	        if (layerOptions.resourceType === "text" || (layerOptions.text != null)) {
	          result = new cloudinary.TextLayer(layerOptions).toString();
	        } else if (layerOptions.resourceType === "subtitles") {
	          result = new cloudinary.SubtitlesLayer(layerOptions).toString();
	        } else if (layerOptions.resourceType === "fetch" || (layerOptions.url != null)) {
	          result = new cloudinary.FetchLayer(layerOptions).toString();
	        } else {
	          result = new cloudinary.Layer(layerOptions).toString();
	        }
	      } else if (/^fetch:.+/.test(layerOptions)) {
	        result = new FetchLayer(layerOptions.substr(6)).toString();
	      } else {
	        result = layerOptions;
	      }
	      return result;
	    };
	
	    LAYER_KEYWORD_PARAMS = [["font_weight", "normal"], ["font_style", "normal"], ["text_decoration", "none"], ["text_align", null], ["stroke", "none"], ["letter_spacing", null], ["line_spacing", null]];
	
	    LayerParam.prototype.textStyle = function(layer) {
	      return (new cloudinary.TextLayer(layer)).textStyleIdentifier();
	    };
	
	    return LayerParam;
	
	  })(Param);
	  ExpressionParam = (function(superClass) {
	    extend(ExpressionParam, superClass);
	
	    function ExpressionParam() {
	      return ExpressionParam.__super__.constructor.apply(this, arguments);
	    }
	
	    ExpressionParam.prototype.serialize = function() {
	      return Expression.normalize(ExpressionParam.__super__.serialize.call(this));
	    };
	
	    return ExpressionParam;
	
	  })(Param);
	  parameters = {};
	  parameters.Param = Param;
	  parameters.ArrayParam = ArrayParam;
	  parameters.RangeParam = RangeParam;
	  parameters.RawParam = RawParam;
	  parameters.TransformationParam = TransformationParam;
	  parameters.LayerParam = LayerParam;
	  parameters.ExpressionParam = ExpressionParam;
	  Expression = (function() {
	
	    /**
	     * @internal
	     */
	    var faceCount;
	
	    Expression.OPERATORS = {
	      "=": 'eq',
	      "!=": 'ne',
	      "<": 'lt',
	      ">": 'gt',
	      "<=": 'lte',
	      ">=": 'gte',
	      "&&": 'and',
	      "||": 'or',
	      "*": "mul",
	      "/": "div",
	      "+": "add",
	      "-": "sub"
	    };
	
	
	    /**
	     * @internal
	     */
	
	    Expression.PREDEFINED_VARS = {
	      "aspect_ratio": "ar",
	      "aspectRatio": "ar",
	      "current_page": "cp",
	      "currentPage": "cp",
	      "face_count": "fc",
	      "faceCount": "fc",
	      "height": "h",
	      "initial_aspect_ratio": "iar",
	      "initial_height": "ih",
	      "initial_width": "iw",
	      "initialAspectRatio": "iar",
	      "initialHeight": "ih",
	      "initialWidth": "iw",
	      "page_count": "pc",
	      "page_x": "px",
	      "page_y": "py",
	      "pageCount": "pc",
	      "pageX": "px",
	      "pageY": "py",
	      "tags": "tags",
	      "width": "w"
	    };
	
	
	    /**
	     * @internal
	     */
	
	    Expression.BOUNDRY = "[ _]+";
	
	
	    /**
	     * Represents a transformation expression
	     * @param {string} expressionStr - a expression in string format
	     * @class Expression
	     *
	     */
	
	    function Expression(expressionStr) {
	
	      /**
	        * @protected
	        * @inner Expression-expressions
	       */
	      this.expressions = [];
	      if (expressionStr != null) {
	        this.expressions.push(Expression.normalize(expressionStr));
	      }
	    }
	
	
	    /**
	     * Convenience constructor method
	     * @function Expression.new
	     */
	
	    Expression["new"] = function(expressionStr) {
	      return new this(expressionStr);
	    };
	
	
	    /**
	     * Normalize a string expression
	     * @function Cloudinary#normalize
	     * @param {string} expression a expression, e.g. "w gt 100", "width_gt_100", "width > 100"
	     * @return {string} the normalized form of the value expression, e.g. "w_gt_100"
	     */
	
	    Expression.normalize = function(expression) {
	      var operators, pattern, replaceRE;
	      if (expression == null) {
	        return expression;
	      }
	      expression = String(expression);
	      operators = "\\|\\||>=|<=|&&|!=|>|=|<|/|-|\\+|\\*";
	      pattern = "((" + operators + ")(?=[ _])|" + Object.keys(Expression.PREDEFINED_VARS).join("|") + ")";
	      replaceRE = new RegExp(pattern, "g");
	      expression = expression.replace(replaceRE, function(match) {
	        return Expression.OPERATORS[match] || Expression.PREDEFINED_VARS[match];
	      });
	      return expression.replace(/[ _]+/g, '_');
	    };
	
	
	    /**
	     * Serialize the expression
	     * @return {string} the expression as a string
	     */
	
	    Expression.prototype.serialize = function() {
	      return Expression.normalize(this.expressions.join("_"));
	    };
	
	    Expression.prototype.toString = function() {
	      return this.serialize();
	    };
	
	
	    /**
	     * Get the parent transformation of this expression
	     * @return Transformation
	     */
	
	    Expression.prototype.getParent = function() {
	      return this.parent;
	    };
	
	
	    /**
	     * Set the parent transformation of this expression
	     * @param {Transformation} the parent transformation
	     * @return {Expression} this expression
	     */
	
	    Expression.prototype.setParent = function(parent) {
	      this.parent = parent;
	      return this;
	    };
	
	
	    /**
	     * Add a expression
	     * @function Expression#predicate
	     * @internal
	     */
	
	    Expression.prototype.predicate = function(name, operator, value) {
	      if (Expression.OPERATORS[operator] != null) {
	        operator = Expression.OPERATORS[operator];
	      }
	      this.expressions.push(name + "_" + operator + "_" + value);
	      return this;
	    };
	
	
	    /**
	     * @function Expression#and
	     */
	
	    Expression.prototype.and = function() {
	      this.expressions.push("and");
	      return this;
	    };
	
	
	    /**
	     * @function Expression#or
	     */
	
	    Expression.prototype.or = function() {
	      this.expressions.push("or");
	      return this;
	    };
	
	
	    /**
	     * Conclude expression
	     * @function Expression#then
	     * @return {Transformation} the transformation this expression is defined for
	     */
	
	    Expression.prototype.then = function() {
	      return this.getParent()["if"](this.toString());
	    };
	
	
	    /**
	     * @function Expression#height
	     * @param {string} operator the comparison operator (e.g. "<", "lt")
	     * @param {string|number} value the right hand side value
	     * @return {Expression} this expression
	     */
	
	    Expression.prototype.height = function(operator, value) {
	      return this.predicate("h", operator, value);
	    };
	
	
	    /**
	     * @function Expression#width
	     * @param {string} operator the comparison operator (e.g. "<", "lt")
	     * @param {string|number} value the right hand side value
	     * @return {Expression} this expression
	     */
	
	    Expression.prototype.width = function(operator, value) {
	      return this.predicate("w", operator, value);
	    };
	
	
	    /**
	     * @function Expression#aspectRatio
	     * @param {string} operator the comparison operator (e.g. "<", "lt")
	     * @param {string|number} value the right hand side value
	     * @return {Expression} this expression
	     */
	
	    Expression.prototype.aspectRatio = function(operator, value) {
	      return this.predicate("ar", operator, value);
	    };
	
	
	    /**
	     * @function Expression#pages
	     * @param {string} operator the comparison operator (e.g. "<", "lt")
	     * @param {string|number} value the right hand side value
	     * @return {Expression} this expression
	     */
	
	    Expression.prototype.pageCount = function(operator, value) {
	      return this.predicate("pc", operator, value);
	    };
	
	
	    /**
	     * @function Expression#faces
	     * @param {string} operator the comparison operator (e.g. "<", "lt")
	     * @param {string|number} value the right hand side value
	     * @return {Expression} this expression
	     */
	
	    Expression.prototype.faceCount = function(operator, value) {
	      return this.predicate("fc", operator, value);
	    };
	
	    Expression.prototype.value = function(value) {
	      this.expressions.push(value);
	      return this;
	    };
	
	
	    /**
	     */
	
	    Expression.variable = function(name, value) {
	      return new this(name).value(value);
	    };
	
	
	    /**
	      * @returns a new expression with the predefined variable "width"
	      * @function Expression.width
	     */
	
	    Expression.width = function() {
	      return new this("width");
	    };
	
	
	    /**
	      * @returns a new expression with the predefined variable "height"
	      * @function Expression.height
	     */
	
	    Expression.height = function() {
	      return new this("height");
	    };
	
	
	    /**
	      * @returns a new expression with the predefined variable "initialWidth"
	      * @function Expression.initialWidth
	     */
	
	    Expression.initialWidth = function() {
	      return new this("initialWidth");
	    };
	
	
	    /**
	      * @returns a new expression with the predefined variable "initialHeight"
	      * @function Expression.initialHeight
	     */
	
	    Expression.initialHeight = function() {
	      return new this("initialHeight");
	    };
	
	
	    /**
	      * @returns a new expression with the predefined variable "aspectRatio"
	      * @function Expression.aspectRatio
	     */
	
	    Expression.aspectRatio = function() {
	      return new this("aspectRatio");
	    };
	
	
	    /**
	      * @returns a new expression with the predefined variable "initialAspectRatio"
	      * @function Expression.initialAspectRatio
	     */
	
	    Expression.initialAspectRatio = function() {
	      return new this("initialAspectRatio");
	    };
	
	
	    /**
	      * @returns a new expression with the predefined variable "pageCount"
	      * @function Expression.pageCount
	     */
	
	    Expression.pageCount = function() {
	      return new this("pageCount");
	    };
	
	
	    /**
	      * @returns a new expression with the predefined variable "faceCount"
	      * @function Expression.faceCount
	     */
	
	    faceCount = function() {
	      return new this("faceCount");
	    };
	
	
	    /**
	      * @returns a new expression with the predefined variable "currentPage"
	      * @function Expression.currentPage
	     */
	
	    Expression.currentPage = function() {
	      return new this("currentPage");
	    };
	
	
	    /**
	      * @returns a new expression with the predefined variable "tags"
	      * @function Expression.tags
	     */
	
	    Expression.tags = function() {
	      return new this("tags");
	    };
	
	
	    /**
	      * @returns a new expression with the predefined variable "pageX"
	      * @function Expression.pageX
	     */
	
	    Expression.pageX = function() {
	      return new this("pageX");
	    };
	
	
	    /**
	      * @returns a new expression with the predefined variable "pageY"
	      * @function Expression.pageY
	     */
	
	    Expression.pageY = function() {
	      return new this("pageY");
	    };
	
	    return Expression;
	
	  })();
	  Condition = (function(superClass) {
	    extend(Condition, superClass);
	
	
	    /**
	     * Represents a transformation condition
	     * @param {string} conditionStr - a condition in string format
	     * @class Condition
	     * @example
	     * // normally this class is not instantiated directly
	     * var tr = cloudinary.Transformation.new()
	     *    .if().width( ">", 1000).and().aspectRatio("<", "3:4").then()
	     *      .width(1000)
	     *      .crop("scale")
	     *    .else()
	     *      .width(500)
	     *      .crop("scale")
	     *
	     * var tr = cloudinary.Transformation.new()
	     *    .if("w > 1000 and aspectRatio < 3:4")
	     *      .width(1000)
	     *      .crop("scale")
	     *    .else()
	     *      .width(500)
	     *      .crop("scale")
	     *
	     */
	
	    function Condition(conditionStr) {
	      Condition.__super__.constructor.call(this, conditionStr);
	    }
	
	
	    /**
	     * @function Condition#height
	     * @param {string} operator the comparison operator (e.g. "<", "lt")
	     * @param {string|number} value the right hand side value
	     * @return {Condition} this condition
	     */
	
	    Condition.prototype.height = function(operator, value) {
	      return this.predicate("h", operator, value);
	    };
	
	
	    /**
	     * @function Condition#width
	     * @param {string} operator the comparison operator (e.g. "<", "lt")
	     * @param {string|number} value the right hand side value
	     * @return {Condition} this condition
	     */
	
	    Condition.prototype.width = function(operator, value) {
	      return this.predicate("w", operator, value);
	    };
	
	
	    /**
	     * @function Condition#aspectRatio
	     * @param {string} operator the comparison operator (e.g. "<", "lt")
	     * @param {string|number} value the right hand side value
	     * @return {Condition} this condition
	     */
	
	    Condition.prototype.aspectRatio = function(operator, value) {
	      return this.predicate("ar", operator, value);
	    };
	
	
	    /**
	     * @function Condition#pages
	     * @param {string} operator the comparison operator (e.g. "<", "lt")
	     * @param {string|number} value the right hand side value
	     * @return {Condition} this condition
	     */
	
	    Condition.prototype.pageCount = function(operator, value) {
	      return this.predicate("pc", operator, value);
	    };
	
	
	    /**
	     * @function Condition#faces
	     * @param {string} operator the comparison operator (e.g. "<", "lt")
	     * @param {string|number} value the right hand side value
	     * @return {Condition} this condition
	     */
	
	    Condition.prototype.faceCount = function(operator, value) {
	      return this.predicate("fc", operator, value);
	    };
	
	    return Condition;
	
	  })(Expression);
	
	  /**
	   * Cloudinary configuration class
	   * Depends on 'utils'
	   */
	  Configuration = (function() {
	
	    /**
	     * Defaults configuration.
	     */
	    var DEFAULT_CONFIGURATION_PARAMS, ref;
	
	    DEFAULT_CONFIGURATION_PARAMS = {
	      responsive_class: 'cld-responsive',
	      responsive_use_breakpoints: true,
	      round_dpr: true,
	      secure: (typeof window !== "undefined" && window !== null ? (ref = window.location) != null ? ref.protocol : void 0 : void 0) === 'https:'
	    };
	
	    Configuration.CONFIG_PARAMS = ["api_key", "api_secret", "callback", "cdn_subdomain", "cloud_name", "cname", "private_cdn", "protocol", "resource_type", "responsive", "responsive_class", "responsive_use_breakpoints", "responsive_width", "round_dpr", "secure", "secure_cdn_subdomain", "secure_distribution", "shorten", "type", "upload_preset", "url_suffix", "use_root_path", "version"];
	
	
	    /**
	     * Cloudinary configuration class
	     * @constructor Configuration
	     * @param {Object} options - configuration parameters
	     */
	
	    function Configuration(options) {
	      if (options == null) {
	        options = {};
	      }
	      this.configuration = Util.cloneDeep(options);
	      Util.defaults(this.configuration, DEFAULT_CONFIGURATION_PARAMS);
	    }
	
	
	    /**
	     * Initialize the configuration.
	     * The function first tries to retrieve the configuration form the environment and then from the document.
	     * @function Configuration#init
	     * @return {Configuration} returns this for chaining
	     * @see fromDocument
	     * @see fromEnvironment
	     */
	
	    Configuration.prototype.init = function() {
	      this.fromEnvironment();
	      this.fromDocument();
	      return this;
	    };
	
	
	    /**
	     * Set a new configuration item
	     * @function Configuration#set
	     * @param {string} name - the name of the item to set
	     * @param {*} value - the value to be set
	     * @return {Configuration}
	     *
	     */
	
	    Configuration.prototype.set = function(name, value) {
	      this.configuration[name] = value;
	      return this;
	    };
	
	
	    /**
	     * Get the value of a configuration item
	     * @function Configuration#get
	     * @param {string} name - the name of the item to set
	     * @return {*} the configuration item
	     */
	
	    Configuration.prototype.get = function(name) {
	      return this.configuration[name];
	    };
	
	    Configuration.prototype.merge = function(config) {
	      if (config == null) {
	        config = {};
	      }
	      Util.assign(this.configuration, Util.cloneDeep(config));
	      return this;
	    };
	
	
	    /**
	     * Initialize Cloudinary from HTML meta tags.
	     * @function Configuration#fromDocument
	     * @return {Configuration}
	     * @example <meta name="cloudinary_cloud_name" content="mycloud">
	     *
	     */
	
	    Configuration.prototype.fromDocument = function() {
	      var el, j, len, meta_elements;
	      meta_elements = typeof document !== "undefined" && document !== null ? document.querySelectorAll('meta[name^="cloudinary_"]') : void 0;
	      if (meta_elements) {
	        for (j = 0, len = meta_elements.length; j < len; j++) {
	          el = meta_elements[j];
	          this.configuration[el.getAttribute('name').replace('cloudinary_', '')] = el.getAttribute('content');
	        }
	      }
	      return this;
	    };
	
	
	    /**
	     * Initialize Cloudinary from the `CLOUDINARY_URL` environment variable.
	     *
	     * This function will only run under Node.js environment.
	     * @function Configuration#fromEnvironment
	     * @requires Node.js
	     */
	
	    Configuration.prototype.fromEnvironment = function() {
	      var cloudinary_url, j, k, len, query, ref1, ref2, ref3, uri, uriRegex, v, value;
	      cloudinary_url = typeof process !== "undefined" && process !== null ? (ref1 = ({"NODE_ENV":"production","PUBLIC_DIR":"/opt/build/repo/public"})) != null ? ref1.CLOUDINARY_URL : void 0 : void 0;
	      if (cloudinary_url != null) {
	        uriRegex = /cloudinary:\/\/(?:(\w+)(?:\:([\w-]+))?@)?([\w\.-]+)(?:\/([^?]*))?(?:\?(.+))?/;
	        uri = uriRegex.exec(cloudinary_url);
	        if (uri) {
	          if (uri[3] != null) {
	            this.configuration['cloud_name'] = uri[3];
	          }
	          if (uri[1] != null) {
	            this.configuration['api_key'] = uri[1];
	          }
	          if (uri[2] != null) {
	            this.configuration['api_secret'] = uri[2];
	          }
	          if (uri[4] != null) {
	            this.configuration['private_cdn'] = uri[4] != null;
	          }
	          if (uri[4] != null) {
	            this.configuration['secure_distribution'] = uri[4];
	          }
	          query = uri[5];
	          if (query != null) {
	            ref2 = query.split('&');
	            for (j = 0, len = ref2.length; j < len; j++) {
	              value = ref2[j];
	              ref3 = value.split('='), k = ref3[0], v = ref3[1];
	              if (v == null) {
	                v = true;
	              }
	              this.configuration[k] = v;
	            }
	          }
	        }
	      }
	      return this;
	    };
	
	
	    /**
	     * Create or modify the Cloudinary client configuration
	     *
	     * Warning: `config()` returns the actual internal configuration object. modifying it will change the configuration.
	     *
	     * This is a backward compatibility method. For new code, use get(), merge() etc.
	     * @function Configuration#config
	     * @param {hash|string|boolean} new_config
	     * @param {string} new_value
	     * @returns {*} configuration, or value
	     *
	     * @see {@link fromEnvironment} for initialization using environment variables
	     * @see {@link fromDocument} for initialization using HTML meta tags
	     */
	
	    Configuration.prototype.config = function(new_config, new_value) {
	      switch (false) {
	        case new_value === void 0:
	          this.set(new_config, new_value);
	          return this.configuration;
	        case !Util.isString(new_config):
	          return this.get(new_config);
	        case !Util.isPlainObject(new_config):
	          this.merge(new_config);
	          return this.configuration;
	        default:
	          return this.configuration;
	      }
	    };
	
	
	    /**
	     * Returns a copy of the configuration parameters
	     * @function Configuration#toOptions
	     * @returns {Object} a key:value collection of the configuration parameters
	     */
	
	    Configuration.prototype.toOptions = function() {
	      return Util.cloneDeep(this.configuration);
	    };
	
	    return Configuration;
	
	  })();
	
	  /**
	   * TransformationBase
	   * Depends on 'configuration', 'parameters','util'
	   * @internal
	   */
	  TransformationBase = (function() {
	    var VAR_NAME_RE, lastArgCallback, processVar;
	
	    VAR_NAME_RE = /^\$[a-zA-Z0-9]+$/;
	
	    TransformationBase.prototype.trans_separator = '/';
	
	    TransformationBase.prototype.param_separator = ',';
	
	    lastArgCallback = function(args) {
	      var callback;
	      callback = args != null ? args[args.length - 1] : void 0;
	      if (Util.isFunction(callback)) {
	        return callback;
	      } else {
	        return void 0;
	      }
	    };
	
	
	    /**
	     * The base class for transformations.
	     * Members of this class are documented as belonging to the {@link Transformation} class for convenience.
	     * @class TransformationBase
	     */
	
	    function TransformationBase(options) {
	      var parent, trans;
	      if (options == null) {
	        options = {};
	      }
	
	      /** @private */
	      parent = void 0;
	
	      /** @private */
	      trans = {};
	
	      /**
	       * Return an options object that can be used to create an identical Transformation
	       * @function Transformation#toOptions
	       * @return {Object} Returns a plain object representing this transformation
	       */
	      this.toOptions || (this.toOptions = function(withChain) {
	        var key, list, opt, ref, ref1, tr, value;
	        if (withChain == null) {
	          withChain = true;
	        }
	        opt = {};
	        for (key in trans) {
	          value = trans[key];
	          opt[key] = value.origValue;
	        }
	        ref = this.otherOptions;
	        for (key in ref) {
	          value = ref[key];
	          if (value !== void 0) {
	            opt[key] = value;
	          }
	        }
	        if (withChain && !Util.isEmpty(this.chained)) {
	          list = (function() {
	            var j, len, ref1, results;
	            ref1 = this.chained;
	            results = [];
	            for (j = 0, len = ref1.length; j < len; j++) {
	              tr = ref1[j];
	              results.push(tr.toOptions());
	            }
	            return results;
	          }).call(this);
	          list.push(opt);
	          opt = {};
	          ref1 = this.otherOptions;
	          for (key in ref1) {
	            value = ref1[key];
	            if (value !== void 0) {
	              opt[key] = value;
	            }
	          }
	          opt.transformation = list;
	        }
	        return opt;
	      });
	
	      /**
	       * Set a parent for this object for chaining purposes.
	       *
	       * @function Transformation#setParent
	       * @param {Object} object - the parent to be assigned to
	       * @returns {Transformation} Returns this instance for chaining purposes.
	       */
	      this.setParent || (this.setParent = function(object) {
	        parent = object;
	        if (object != null) {
	          this.fromOptions(typeof object.toOptions === "function" ? object.toOptions() : void 0);
	        }
	        return this;
	      });
	
	      /**
	       * Returns the parent of this object in the chain
	       * @function Transformation#getParent
	       * @protected
	       * @return {Object} Returns the parent of this object if there is any
	       */
	      this.getParent || (this.getParent = function() {
	        return parent;
	      });
	
	      /** @protected */
	      this.param || (this.param = function(value, name, abbr, defaultValue, process) {
	        if (process == null) {
	          if (Util.isFunction(defaultValue)) {
	            process = defaultValue;
	          } else {
	            process = Util.identity;
	          }
	        }
	        trans[name] = new Param(name, abbr, process).set(value);
	        return this;
	      });
	
	      /** @protected */
	      this.rawParam || (this.rawParam = function(value, name, abbr, defaultValue, process) {
	        if (process == null) {
	          process = Util.identity;
	        }
	        process = lastArgCallback(arguments);
	        trans[name] = new RawParam(name, abbr, process).set(value);
	        return this;
	      });
	
	      /** @protected */
	      this.rangeParam || (this.rangeParam = function(value, name, abbr, defaultValue, process) {
	        if (process == null) {
	          process = Util.identity;
	        }
	        process = lastArgCallback(arguments);
	        trans[name] = new RangeParam(name, abbr, process).set(value);
	        return this;
	      });
	
	      /** @protected */
	      this.arrayParam || (this.arrayParam = function(value, name, abbr, sep, defaultValue, process) {
	        if (sep == null) {
	          sep = ":";
	        }
	        if (defaultValue == null) {
	          defaultValue = [];
	        }
	        if (process == null) {
	          process = Util.identity;
	        }
	        process = lastArgCallback(arguments);
	        trans[name] = new ArrayParam(name, abbr, sep, process).set(value);
	        return this;
	      });
	
	      /** @protected */
	      this.transformationParam || (this.transformationParam = function(value, name, abbr, sep, defaultValue, process) {
	        if (sep == null) {
	          sep = ".";
	        }
	        if (process == null) {
	          process = Util.identity;
	        }
	        process = lastArgCallback(arguments);
	        trans[name] = new TransformationParam(name, abbr, sep, process).set(value);
	        return this;
	      });
	      this.layerParam || (this.layerParam = function(value, name, abbr) {
	        trans[name] = new LayerParam(name, abbr).set(value);
	        return this;
	      });
	
	      /**
	       * Get the value associated with the given name.
	       * @function Transformation#getValue
	       * @param {string} name - the name of the parameter
	       * @return {*} the processed value associated with the given name
	       * @description Use {@link get}.origValue for the value originally provided for the parameter
	       */
	      this.getValue || (this.getValue = function(name) {
	        var ref, ref1;
	        return (ref = (ref1 = trans[name]) != null ? ref1.value() : void 0) != null ? ref : this.otherOptions[name];
	      });
	
	      /**
	       * Get the parameter object for the given parameter name
	       * @function Transformation#get
	       * @param {string} name the name of the transformation parameter
	       * @returns {Param} the param object for the given name, or undefined
	       */
	      this.get || (this.get = function(name) {
	        return trans[name];
	      });
	
	      /**
	       * Remove a transformation option from the transformation.
	       * @function Transformation#remove
	       * @param {string} name - the name of the option to remove
	       * @return {*} Returns the option that was removed or null if no option by that name was found. The type of the
	       *              returned value depends on the value.
	       */
	      this.remove || (this.remove = function(name) {
	        var temp;
	        switch (false) {
	          case trans[name] == null:
	            temp = trans[name];
	            delete trans[name];
	            return temp.origValue;
	          case this.otherOptions[name] == null:
	            temp = this.otherOptions[name];
	            delete this.otherOptions[name];
	            return temp;
	          default:
	            return null;
	        }
	      });
	
	      /**
	       * Return an array of all the keys (option names) in the transformation.
	       * @return {Array<string>} the keys in snakeCase format
	       */
	      this.keys || (this.keys = function() {
	        var key;
	        return ((function() {
	          var results;
	          results = [];
	          for (key in trans) {
	            if (key != null) {
	              results.push(key.match(VAR_NAME_RE) ? key : Util.snakeCase(key));
	            }
	          }
	          return results;
	        })()).sort();
	      });
	
	      /**
	       * Returns a plain object representation of the transformation. Values are processed.
	       * @function Transformation#toPlainObject
	       * @return {Object} the transformation options as plain object
	       */
	      this.toPlainObject || (this.toPlainObject = function() {
	        var hash, key, list, tr;
	        hash = {};
	        for (key in trans) {
	          hash[key] = trans[key].value();
	          if (Util.isPlainObject(hash[key])) {
	            hash[key] = Util.cloneDeep(hash[key]);
	          }
	        }
	        if (!Util.isEmpty(this.chained)) {
	          list = (function() {
	            var j, len, ref, results;
	            ref = this.chained;
	            results = [];
	            for (j = 0, len = ref.length; j < len; j++) {
	              tr = ref[j];
	              results.push(tr.toPlainObject());
	            }
	            return results;
	          }).call(this);
	          list.push(hash);
	          hash = {
	            transformation: list
	          };
	        }
	        return hash;
	      });
	
	      /**
	       * Complete the current transformation and chain to a new one.
	       * In the URL, transformations are chained together by slashes.
	       * @function Transformation#chain
	       * @return {Transformation} Returns this transformation for chaining
	       * @example
	       * var tr = cloudinary.Transformation.new();
	       * tr.width(10).crop('fit').chain().angle(15).serialize()
	       * // produces "c_fit,w_10/a_15"
	       */
	      this.chain || (this.chain = function() {
	        var names, tr;
	        names = Object.getOwnPropertyNames(trans);
	        if (names.length !== 0) {
	          tr = new this.constructor(this.toOptions(false));
	          this.resetTransformations();
	          this.chained.push(tr);
	        }
	        return this;
	      });
	      this.resetTransformations || (this.resetTransformations = function() {
	        trans = {};
	        return this;
	      });
	      this.otherOptions || (this.otherOptions = {});
	      this.chained = [];
	      if (!Util.isEmpty(options)) {
	        this.fromOptions(options);
	      }
	    }
	
	
	    /**
	     * Merge the provided options with own's options
	     * @param {Object} [options={}] key-value list of options
	     * @returns {Transformation} Returns this instance for chaining
	     */
	
	    TransformationBase.prototype.fromOptions = function(options) {
	      var key, opt;
	      if (options instanceof TransformationBase) {
	        this.fromTransformation(options);
	      } else {
	        options || (options = {});
	        if (Util.isString(options) || Util.isArray(options)) {
	          options = {
	            transformation: options
	          };
	        }
	        options = Util.cloneDeep(options, function(value) {
	          if (value instanceof TransformationBase) {
	            return new value.constructor(value.toOptions());
	          }
	        });
	        if (options["if"]) {
	          this.set("if", options["if"]);
	          delete options["if"];
	        }
	        for (key in options) {
	          opt = options[key];
	          if (key.match(VAR_NAME_RE)) {
	            if (key !== '$attr') {
	              this.set('variable', key, opt);
	            }
	          } else {
	            this.set(key, opt);
	          }
	        }
	      }
	      return this;
	    };
	
	    TransformationBase.prototype.fromTransformation = function(other) {
	      var j, key, len, ref;
	      if (other instanceof TransformationBase) {
	        ref = other.keys();
	        for (j = 0, len = ref.length; j < len; j++) {
	          key = ref[j];
	          this.set(key, other.get(key).origValue);
	        }
	      }
	      return this;
	    };
	
	
	    /**
	     * Set a parameter.
	     * The parameter name `key` is converted to
	     * @param {string} key - the name of the parameter
	     * @param {*} value - the value of the parameter
	     * @returns {Transformation} Returns this instance for chaining
	     */
	
	    TransformationBase.prototype.set = function() {
	      var camelKey, key, values;
	      key = arguments[0], values = 2 <= arguments.length ? slice.call(arguments, 1) : [];
	      camelKey = Util.camelCase(key);
	      if (Util.contains(Transformation.methods, camelKey)) {
	        this[camelKey].apply(this, values);
	      } else {
	        this.otherOptions[key] = values[0];
	      }
	      return this;
	    };
	
	    TransformationBase.prototype.hasLayer = function() {
	      return this.getValue("overlay") || this.getValue("underlay");
	    };
	
	
	    /**
	     * Generate a string representation of the transformation.
	     * @function Transformation#serialize
	     * @return {string} Returns the transformation as a string
	     */
	
	    TransformationBase.prototype.serialize = function() {
	      var ifParam, j, len, paramList, ref, ref1, ref2, ref3, ref4, resultArray, t, tr, transformationList, transformationString, transformations, value, variables, vars;
	      resultArray = (function() {
	        var j, len, ref, results;
	        ref = this.chained;
	        results = [];
	        for (j = 0, len = ref.length; j < len; j++) {
	          tr = ref[j];
	          results.push(tr.serialize());
	        }
	        return results;
	      }).call(this);
	      paramList = this.keys();
	      transformations = (ref = this.get("transformation")) != null ? ref.serialize() : void 0;
	      ifParam = (ref1 = this.get("if")) != null ? ref1.serialize() : void 0;
	      variables = processVar((ref2 = this.get("variables")) != null ? ref2.value() : void 0);
	      paramList = Util.difference(paramList, ["transformation", "if", "variables"]);
	      vars = [];
	      transformationList = [];
	      for (j = 0, len = paramList.length; j < len; j++) {
	        t = paramList[j];
	        if (t.match(VAR_NAME_RE)) {
	          vars.push(t + "_" + Expression.normalize((ref3 = this.get(t)) != null ? ref3.value() : void 0));
	        } else {
	          transformationList.push((ref4 = this.get(t)) != null ? ref4.serialize() : void 0);
	        }
	      }
	      switch (false) {
	        case !Util.isString(transformations):
	          transformationList.push(transformations);
	          break;
	        case !Util.isArray(transformations):
	          resultArray = resultArray.concat(transformations);
	      }
	      transformationList = (function() {
	        var l, len1, results;
	        results = [];
	        for (l = 0, len1 = transformationList.length; l < len1; l++) {
	          value = transformationList[l];
	          if (Util.isArray(value) && !Util.isEmpty(value) || !Util.isArray(value) && value) {
	            results.push(value);
	          }
	        }
	        return results;
	      })();
	      transformationList = vars.sort().concat(variables).concat(transformationList.sort());
	      if (ifParam === "if_end") {
	        transformationList.push(ifParam);
	      } else if (!Util.isEmpty(ifParam)) {
	        transformationList.unshift(ifParam);
	      }
	      transformationString = Util.compact(transformationList).join(this.param_separator);
	      if (!Util.isEmpty(transformationString)) {
	        resultArray.push(transformationString);
	      }
	      return Util.compact(resultArray).join(this.trans_separator);
	    };
	
	
	    /**
	     * Provide a list of all the valid transformation option names
	     * @function Transformation#listNames
	     * @private
	     * @return {Array<string>} a array of all the valid option names
	     */
	
	    TransformationBase.prototype.listNames = function() {
	      return Transformation.methods;
	    };
	
	
	    /**
	     * Returns attributes for an HTML tag.
	     * @function Cloudinary.toHtmlAttributes
	     * @return PlainObject
	     */
	
	    TransformationBase.prototype.toHtmlAttributes = function() {
	      var attrName, height, j, key, len, options, ref, ref1, ref2, ref3, value;
	      options = {};
	      ref = this.otherOptions;
	      for (key in ref) {
	        value = ref[key];
	        if (!(!Util.contains(Transformation.PARAM_NAMES, Util.snakeCase(key)))) {
	          continue;
	        }
	        attrName = /^html_/.test(key) ? key.slice(5) : key;
	        options[attrName] = value;
	      }
	      ref1 = this.keys();
	      for (j = 0, len = ref1.length; j < len; j++) {
	        key = ref1[j];
	        if (/^html_/.test(key)) {
	          options[Util.camelCase(key.slice(5))] = this.getValue(key);
	        }
	      }
	      if (!(this.hasLayer() || this.getValue("angle") || Util.contains(["fit", "limit", "lfill"], this.getValue("crop")))) {
	        width = (ref2 = this.get("width")) != null ? ref2.origValue : void 0;
	        height = (ref3 = this.get("height")) != null ? ref3.origValue : void 0;
	        if (parseFloat(width) >= 1.0) {
	          if (options['width'] == null) {
	            options['width'] = width;
	          }
	        }
	        if (parseFloat(height) >= 1.0) {
	          if (options['height'] == null) {
	            options['height'] = height;
	          }
	        }
	      }
	      return options;
	    };
	
	    TransformationBase.prototype.isValidParamName = function(name) {
	      return Transformation.methods.indexOf(Util.camelCase(name)) >= 0;
	    };
	
	
	    /**
	     * Delegate to the parent (up the call chain) to produce HTML
	     * @function Transformation#toHtml
	     * @return {string} HTML representation of the parent if possible.
	     * @example
	     * tag = cloudinary.ImageTag.new("sample", {cloud_name: "demo"})
	     * // ImageTag {name: "img", publicId: "sample"}
	     * tag.toHtml()
	     * // <img src="http://res.cloudinary.com/demo/image/upload/sample">
	     * tag.transformation().crop("fit").width(300).toHtml()
	     * // <img src="http://res.cloudinary.com/demo/image/upload/c_fit,w_300/sample">
	     */
	
	    TransformationBase.prototype.toHtml = function() {
	      var ref;
	      return (ref = this.getParent()) != null ? typeof ref.toHtml === "function" ? ref.toHtml() : void 0 : void 0;
	    };
	
	    TransformationBase.prototype.toString = function() {
	      return this.serialize();
	    };
	
	    processVar = function(varArray) {
	      var j, len, name, ref, results, v;
	      if (Util.isArray(varArray)) {
	        results = [];
	        for (j = 0, len = varArray.length; j < len; j++) {
	          ref = varArray[j], name = ref[0], v = ref[1];
	          results.push(name + "_" + (Expression.normalize(v)));
	        }
	        return results;
	      } else {
	        return varArray;
	      }
	
	      /**
	       * Transformation Class methods.
	       * This is a list of the parameters defined in Transformation.
	       * Values are camelCased.
	       * @const Transformation.methods
	       * @private
	       * @ignore
	       * @type {Array<string>}
	       */
	
	      /**
	       * Parameters that are filtered out before passing the options to an HTML tag.
	       *
	       * The list of parameters is a combination of `Transformation::methods` and `Configuration::CONFIG_PARAMS`
	       * @const {Array<string>} Transformation.PARAM_NAMES
	       * @private
	       * @ignore
	       * @see toHtmlAttributes
	       */
	    };
	
	    return TransformationBase;
	
	  })();
	  Transformation = (function(superClass) {
	    extend(Transformation, superClass);
	
	
	    /**
	     *  Represents a single transformation.
	     *  @class Transformation
	     *  @example
	     *  t = new cloudinary.Transformation();
	     * t.angle(20).crop("scale").width("auto");
	     *
	     * // or
	     *
	     * t = new cloudinary.Transformation( {angle: 20, crop: "scale", width: "auto"});
	     */
	
	    function Transformation(options) {
	      if (options == null) {
	        options = {};
	      }
	      Transformation.__super__.constructor.call(this, options);
	      this;
	    }
	
	
	    /**
	     * Convenience constructor
	     * @param {Object} options
	     * @return {Transformation}
	     * @example cl = cloudinary.Transformation.new( {angle: 20, crop: "scale", width: "auto"})
	     */
	
	    Transformation["new"] = function(args) {
	      return new Transformation(args);
	    };
	
	
	    /*
	      Transformation Parameters
	     */
	
	    Transformation.prototype.angle = function(value) {
	      return this.arrayParam(value, "angle", "a", ".", Expression.normalize);
	    };
	
	    Transformation.prototype.audioCodec = function(value) {
	      return this.param(value, "audio_codec", "ac");
	    };
	
	    Transformation.prototype.audioFrequency = function(value) {
	      return this.param(value, "audio_frequency", "af");
	    };
	
	    Transformation.prototype.aspectRatio = function(value) {
	      return this.param(value, "aspect_ratio", "ar", Expression.normalize);
	    };
	
	    Transformation.prototype.background = function(value) {
	      return this.param(value, "background", "b", Param.norm_color);
	    };
	
	    Transformation.prototype.bitRate = function(value) {
	      return this.param(value, "bit_rate", "br");
	    };
	
	    Transformation.prototype.border = function(value) {
	      return this.param(value, "border", "bo", function(border) {
	        if (Util.isPlainObject(border)) {
	          border = Util.assign({}, {
	            color: "black",
	            width: 2
	          }, border);
	          return border.width + "px_solid_" + (Param.norm_color(border.color));
	        } else {
	          return border;
	        }
	      });
	    };
	
	    Transformation.prototype.color = function(value) {
	      return this.param(value, "color", "co", Param.norm_color);
	    };
	
	    Transformation.prototype.colorSpace = function(value) {
	      return this.param(value, "color_space", "cs");
	    };
	
	    Transformation.prototype.crop = function(value) {
	      return this.param(value, "crop", "c");
	    };
	
	    Transformation.prototype.defaultImage = function(value) {
	      return this.param(value, "default_image", "d");
	    };
	
	    Transformation.prototype.delay = function(value) {
	      return this.param(value, "delay", "dl");
	    };
	
	    Transformation.prototype.density = function(value) {
	      return this.param(value, "density", "dn");
	    };
	
	    Transformation.prototype.duration = function(value) {
	      return this.rangeParam(value, "duration", "du");
	    };
	
	    Transformation.prototype.dpr = function(value) {
	      return this.param(value, "dpr", "dpr", (function(_this) {
	        return function(dpr) {
	          dpr = dpr.toString();
	          if (dpr != null ? dpr.match(/^\d+$/) : void 0) {
	            return dpr + ".0";
	          } else {
	            return Expression.normalize(dpr);
	          }
	        };
	      })(this));
	    };
	
	    Transformation.prototype.effect = function(value) {
	      return this.arrayParam(value, "effect", "e", ":", Expression.normalize);
	    };
	
	    Transformation.prototype["else"] = function() {
	      return this["if"]('else');
	    };
	
	    Transformation.prototype.endIf = function() {
	      return this["if"]('end');
	    };
	
	    Transformation.prototype.endOffset = function(value) {
	      return this.rangeParam(value, "end_offset", "eo");
	    };
	
	    Transformation.prototype.fallbackContent = function(value) {
	      return this.param(value, "fallback_content");
	    };
	
	    Transformation.prototype.fetchFormat = function(value) {
	      return this.param(value, "fetch_format", "f");
	    };
	
	    Transformation.prototype.format = function(value) {
	      return this.param(value, "format");
	    };
	
	    Transformation.prototype.flags = function(value) {
	      return this.arrayParam(value, "flags", "fl", ".");
	    };
	
	    Transformation.prototype.gravity = function(value) {
	      return this.param(value, "gravity", "g");
	    };
	
	    Transformation.prototype.height = function(value) {
	      return this.param(value, "height", "h", (function(_this) {
	        return function() {
	          if (_this.getValue("crop") || _this.getValue("overlay") || _this.getValue("underlay")) {
	            return Expression.normalize(value);
	          } else {
	            return null;
	          }
	        };
	      })(this));
	    };
	
	    Transformation.prototype.htmlHeight = function(value) {
	      return this.param(value, "html_height");
	    };
	
	    Transformation.prototype.htmlWidth = function(value) {
	      return this.param(value, "html_width");
	    };
	
	    Transformation.prototype["if"] = function(value) {
	      var i, ifVal, j, ref, trIf, trRest;
	      if (value == null) {
	        value = "";
	      }
	      switch (value) {
	        case "else":
	          this.chain();
	          return this.param(value, "if", "if");
	        case "end":
	          this.chain();
	          for (i = j = ref = this.chained.length - 1; j >= 0; i = j += -1) {
	            ifVal = this.chained[i].getValue("if");
	            if (ifVal === "end") {
	              break;
	            } else if (ifVal != null) {
	              trIf = Transformation["new"]()["if"](ifVal);
	              this.chained[i].remove("if");
	              trRest = this.chained[i];
	              this.chained[i] = Transformation["new"]().transformation([trIf, trRest]);
	              if (ifVal !== "else") {
	                break;
	              }
	            }
	          }
	          return this.param(value, "if", "if");
	        case "":
	          return Condition["new"]().setParent(this);
	        default:
	          return this.param(value, "if", "if", function(value) {
	            return Condition["new"](value).toString();
	          });
	      }
	    };
	
	    Transformation.prototype.keyframeInterval = function(value) {
	      return this.param(value, "keyframe_interval", "ki");
	    };
	
	    Transformation.prototype.offset = function(value) {
	      var end_o, ref, start_o;
	      ref = Util.isFunction(value != null ? value.split : void 0) ? value.split('..') : Util.isArray(value) ? value : [null, null], start_o = ref[0], end_o = ref[1];
	      if (start_o != null) {
	        this.startOffset(start_o);
	      }
	      if (end_o != null) {
	        return this.endOffset(end_o);
	      }
	    };
	
	    Transformation.prototype.opacity = function(value) {
	      return this.param(value, "opacity", "o", Expression.normalize);
	    };
	
	    Transformation.prototype.overlay = function(value) {
	      return this.layerParam(value, "overlay", "l");
	    };
	
	    Transformation.prototype.page = function(value) {
	      return this.param(value, "page", "pg");
	    };
	
	    Transformation.prototype.poster = function(value) {
	      return this.param(value, "poster");
	    };
	
	    Transformation.prototype.prefix = function(value) {
	      return this.param(value, "prefix", "p");
	    };
	
	    Transformation.prototype.quality = function(value) {
	      return this.param(value, "quality", "q", Expression.normalize);
	    };
	
	    Transformation.prototype.radius = function(value) {
	      return this.param(value, "radius", "r", Expression.normalize);
	    };
	
	    Transformation.prototype.rawTransformation = function(value) {
	      return this.rawParam(value, "raw_transformation");
	    };
	
	    Transformation.prototype.size = function(value) {
	      var height, ref;
	      if (Util.isFunction(value != null ? value.split : void 0)) {
	        ref = value.split('x'), width = ref[0], height = ref[1];
	        this.width(width);
	        return this.height(height);
	      }
	    };
	
	    Transformation.prototype.sourceTypes = function(value) {
	      return this.param(value, "source_types");
	    };
	
	    Transformation.prototype.sourceTransformation = function(value) {
	      return this.param(value, "source_transformation");
	    };
	
	    Transformation.prototype.startOffset = function(value) {
	      return this.rangeParam(value, "start_offset", "so");
	    };
	
	    Transformation.prototype.streamingProfile = function(value) {
	      return this.param(value, "streaming_profile", "sp");
	    };
	
	    Transformation.prototype.transformation = function(value) {
	      return this.transformationParam(value, "transformation", "t");
	    };
	
	    Transformation.prototype.underlay = function(value) {
	      return this.layerParam(value, "underlay", "u");
	    };
	
	    Transformation.prototype.variable = function(name, value) {
	      return this.param(value, name, name);
	    };
	
	    Transformation.prototype.variables = function(values) {
	      return this.arrayParam(values, "variables");
	    };
	
	    Transformation.prototype.videoCodec = function(value) {
	      return this.param(value, "video_codec", "vc", Param.process_video_params);
	    };
	
	    Transformation.prototype.videoSampling = function(value) {
	      return this.param(value, "video_sampling", "vs");
	    };
	
	    Transformation.prototype.width = function(value) {
	      return this.param(value, "width", "w", (function(_this) {
	        return function() {
	          if (_this.getValue("crop") || _this.getValue("overlay") || _this.getValue("underlay")) {
	            return Expression.normalize(value);
	          } else {
	            return null;
	          }
	        };
	      })(this));
	    };
	
	    Transformation.prototype.x = function(value) {
	      return this.param(value, "x", "x", Expression.normalize);
	    };
	
	    Transformation.prototype.y = function(value) {
	      return this.param(value, "y", "y", Expression.normalize);
	    };
	
	    Transformation.prototype.zoom = function(value) {
	      return this.param(value, "zoom", "z", Expression.normalize);
	    };
	
	    return Transformation;
	
	  })(TransformationBase);
	
	  /**
	   * Transformation Class methods.
	   * This is a list of the parameters defined in Transformation.
	   * Values are camelCased.
	   */
	  Transformation.methods || (Transformation.methods = Util.difference(Util.functions(Transformation.prototype), Util.functions(TransformationBase.prototype)));
	
	  /**
	   * Parameters that are filtered out before passing the options to an HTML tag.
	   *
	   * The list of parameters is a combination of `Transformation::methods` and `Configuration::CONFIG_PARAMS`
	   */
	  Transformation.PARAM_NAMES || (Transformation.PARAM_NAMES = ((function() {
	    var j, len, ref, results;
	    ref = Transformation.methods;
	    results = [];
	    for (j = 0, len = ref.length; j < len; j++) {
	      m = ref[j];
	      results.push(Util.snakeCase(m));
	    }
	    return results;
	  })()).concat(Configuration.CONFIG_PARAMS));
	
	  /**
	   * Generic HTML tag
	   * Depends on 'transformation', 'util'
	   */
	  HtmlTag = (function() {
	
	    /**
	     * Represents an HTML (DOM) tag
	     * @constructor HtmlTag
	     * @param {string} name - the name of the tag
	     * @param {string} [publicId]
	     * @param {Object} options
	     * @example tag = new HtmlTag( 'div', { 'width': 10})
	     */
	    var toAttribute;
	
	    function HtmlTag(name, publicId, options) {
	      var transformation;
	      this.name = name;
	      this.publicId = publicId;
	      if (options == null) {
	        if (Util.isPlainObject(publicId)) {
	          options = publicId;
	          this.publicId = void 0;
	        } else {
	          options = {};
	        }
	      }
	      transformation = new Transformation(options);
	      transformation.setParent(this);
	      this.transformation = function() {
	        return transformation;
	      };
	    }
	
	
	    /**
	     * Convenience constructor
	     * Creates a new instance of an HTML (DOM) tag
	     * @function HtmlTag.new
	     * @param {string} name - the name of the tag
	     * @param {string} [publicId]
	     * @param {Object} options
	     * @return {HtmlTag}
	     * @example tag = HtmlTag.new( 'div', { 'width': 10})
	     */
	
	    HtmlTag["new"] = function(name, publicId, options) {
	      return new this(name, publicId, options);
	    };
	
	
	    /**
	     * Represent the given key and value as an HTML attribute.
	     * @function HtmlTag#toAttribute
	     * @protected
	     * @param {string} key - attribute name
	     * @param {*|boolean} value - the value of the attribute. If the value is boolean `true`, return the key only.
	     * @returns {string} the attribute  
	     *
	     */
	
	    toAttribute = function(key, value) {
	      if (!value) {
	        return void 0;
	      } else if (value === true) {
	        return key;
	      } else {
	        return key + "=\"" + value + "\"";
	      }
	    };
	
	
	    /**
	     * combine key and value from the `attr` to generate an HTML tag attributes string.
	     * `Transformation::toHtmlTagOptions` is used to filter out transformation and configuration keys.
	     * @protected
	     * @param {Object} attrs
	     * @return {string} the attributes in the format `'key1="value1" key2="value2"'`
	     * @ignore
	     */
	
	    HtmlTag.prototype.htmlAttrs = function(attrs) {
	      var key, pairs, value;
	      return pairs = ((function() {
	        var results;
	        results = [];
	        for (key in attrs) {
	          value = attrs[key];
	          if (value) {
	            results.push(toAttribute(key, value));
	          }
	        }
	        return results;
	      })()).sort().join(' ');
	    };
	
	
	    /**
	     * Get all options related to this tag.
	     * @function HtmlTag#getOptions
	     * @returns {Object} the options
	     *
	     */
	
	    HtmlTag.prototype.getOptions = function() {
	      return this.transformation().toOptions();
	    };
	
	
	    /**
	     * Get the value of option `name`
	     * @function HtmlTag#getOption
	     * @param {string} name - the name of the option
	     * @returns {*} Returns the value of the option
	     *
	     */
	
	    HtmlTag.prototype.getOption = function(name) {
	      return this.transformation().getValue(name);
	    };
	
	
	    /**
	     * Get the attributes of the tag.
	     * @function HtmlTag#attributes
	     * @returns {Object} attributes
	     */
	
	    HtmlTag.prototype.attributes = function() {
	      return this.transformation().toHtmlAttributes();
	    };
	
	
	    /**
	     * Set a tag attribute named `name` to `value`
	     * @function HtmlTag#setAttr
	     * @param {string} name - the name of the attribute
	     * @param {string} value - the value of the attribute
	     */
	
	    HtmlTag.prototype.setAttr = function(name, value) {
	      this.transformation().set("html_" + name, value);
	      return this;
	    };
	
	
	    /**
	     * Get the value of the tag attribute `name`
	     * @function HtmlTag#getAttr
	     * @param {string} name - the name of the attribute
	     * @returns {*}
	     */
	
	    HtmlTag.prototype.getAttr = function(name) {
	      return this.attributes()["html_" + name] || this.attributes()[name];
	    };
	
	
	    /**
	     * Remove the tag attributed named `name`
	     * @function HtmlTag#removeAttr
	     * @param {string} name - the name of the attribute
	     * @returns {*}
	     */
	
	    HtmlTag.prototype.removeAttr = function(name) {
	      var ref;
	      return (ref = this.transformation().remove("html_" + name)) != null ? ref : this.transformation().remove(name);
	    };
	
	
	    /**
	     * @function HtmlTag#content
	     * @protected
	     * @ignore
	     */
	
	    HtmlTag.prototype.content = function() {
	      return "";
	    };
	
	
	    /**
	     * @function HtmlTag#openTag
	     * @protected
	     * @ignore
	     */
	
	    HtmlTag.prototype.openTag = function() {
	      return "<" + this.name + " " + (this.htmlAttrs(this.attributes())) + ">";
	    };
	
	
	    /**
	     * @function HtmlTag#closeTag
	     * @protected
	     * @ignore
	     */
	
	    HtmlTag.prototype.closeTag = function() {
	      return "</" + this.name + ">";
	    };
	
	
	    /**
	     * Generates an HTML representation of the tag.
	     * @function HtmlTag#toHtml
	     * @returns {string} Returns HTML in string format
	     */
	
	    HtmlTag.prototype.toHtml = function() {
	      return this.openTag() + this.content() + this.closeTag();
	    };
	
	
	    /**
	     * Creates a DOM object representing the tag.
	     * @function HtmlTag#toDOM
	     * @returns {Element}
	     */
	
	    HtmlTag.prototype.toDOM = function() {
	      var element, name, ref, value;
	      if (!Util.isFunction(typeof document !== "undefined" && document !== null ? document.createElement : void 0)) {
	        throw "Can't create DOM if document is not present!";
	      }
	      element = document.createElement(this.name);
	      ref = this.attributes();
	      for (name in ref) {
	        value = ref[name];
	        element[name] = value;
	      }
	      return element;
	    };
	
	    HtmlTag.isResponsive = function(tag, responsiveClass) {
	      var dataSrc;
	      dataSrc = Util.getData(tag, 'src-cache') || Util.getData(tag, 'src');
	      return Util.hasClass(tag, responsiveClass) && /\bw_auto\b/.exec(dataSrc);
	    };
	
	    return HtmlTag;
	
	  })();
	
	  /**
	   * Image Tag
	   * Depends on 'tags/htmltag', 'cloudinary'
	   */
	  ImageTag = (function(superClass) {
	    extend(ImageTag, superClass);
	
	
	    /**
	     * Creates an HTML (DOM) Image tag using Cloudinary as the source.
	     * @constructor ImageTag
	     * @extends HtmlTag
	     * @param {string} [publicId]
	     * @param {Object} [options]
	     */
	
	    function ImageTag(publicId, options) {
	      if (options == null) {
	        options = {};
	      }
	      ImageTag.__super__.constructor.call(this, "img", publicId, options);
	    }
	
	
	    /** @override */
	
	    ImageTag.prototype.closeTag = function() {
	      return "";
	    };
	
	
	    /** @override */
	
	    ImageTag.prototype.attributes = function() {
	      var attr, options, srcAttribute;
	      attr = ImageTag.__super__.attributes.call(this) || [];
	      options = this.getOptions();
	      srcAttribute = options.responsive && !options.client_hints ? 'data-src' : 'src';
	      if (attr[srcAttribute] == null) {
	        attr[srcAttribute] = new Cloudinary(this.getOptions()).url(this.publicId);
	      }
	      return attr;
	    };
	
	    return ImageTag;
	
	  })(HtmlTag);
	
	  /**
	   * Video Tag
	   * Depends on 'tags/htmltag', 'util', 'cloudinary'
	   */
	  VideoTag = (function(superClass) {
	    var DEFAULT_POSTER_OPTIONS, DEFAULT_VIDEO_SOURCE_TYPES, VIDEO_TAG_PARAMS;
	
	    extend(VideoTag, superClass);
	
	    VIDEO_TAG_PARAMS = ['source_types', 'source_transformation', 'fallback_content', 'poster'];
	
	    DEFAULT_VIDEO_SOURCE_TYPES = ['webm', 'mp4', 'ogv'];
	
	    DEFAULT_POSTER_OPTIONS = {
	      format: 'jpg',
	      resource_type: 'video'
	    };
	
	
	    /**
	     * Creates an HTML (DOM) Video tag using Cloudinary as the source.
	     * @constructor VideoTag
	     * @extends HtmlTag
	     * @param {string} [publicId]
	     * @param {Object} [options]
	     */
	
	    function VideoTag(publicId, options) {
	      if (options == null) {
	        options = {};
	      }
	      options = Util.defaults({}, options, Cloudinary.DEFAULT_VIDEO_PARAMS);
	      VideoTag.__super__.constructor.call(this, "video", publicId.replace(/\.(mp4|ogv|webm)$/, ''), options);
	    }
	
	
	    /**
	     * Set the transformation to apply on each source
	     * @function VideoTag#setSourceTransformation
	     * @param {Object} an object with pairs of source type and source transformation
	     * @returns {VideoTag} Returns this instance for chaining purposes.
	     */
	
	    VideoTag.prototype.setSourceTransformation = function(value) {
	      this.transformation().sourceTransformation(value);
	      return this;
	    };
	
	
	    /**
	     * Set the source types to include in the video tag
	     * @function VideoTag#setSourceTypes
	     * @param {Array<string>} an array of source types
	     * @returns {VideoTag} Returns this instance for chaining purposes.
	     */
	
	    VideoTag.prototype.setSourceTypes = function(value) {
	      this.transformation().sourceTypes(value);
	      return this;
	    };
	
	
	    /**
	     * Set the poster to be used in the video tag
	     * @function VideoTag#setPoster
	     * @param {string|Object} value
	     * - string: a URL to use for the poster
	     * - Object: transformation parameters to apply to the poster. May optionally include a public_id to use instead of the video public_id.
	     * @returns {VideoTag} Returns this instance for chaining purposes.
	     */
	
	    VideoTag.prototype.setPoster = function(value) {
	      this.transformation().poster(value);
	      return this;
	    };
	
	
	    /**
	     * Set the content to use as fallback in the video tag
	     * @function VideoTag#setFallbackContent
	     * @param {string} value - the content to use, in HTML format
	     * @returns {VideoTag} Returns this instance for chaining purposes.
	     */
	
	    VideoTag.prototype.setFallbackContent = function(value) {
	      this.transformation().fallbackContent(value);
	      return this;
	    };
	
	    VideoTag.prototype.content = function() {
	      var cld, fallback, innerTags, mimeType, sourceTransformation, sourceTypes, src, srcType, transformation, videoType;
	      sourceTypes = this.transformation().getValue('source_types');
	      sourceTransformation = this.transformation().getValue('source_transformation');
	      fallback = this.transformation().getValue('fallback_content');
	      if (Util.isArray(sourceTypes)) {
	        cld = new Cloudinary(this.getOptions());
	        innerTags = (function() {
	          var j, len, results;
	          results = [];
	          for (j = 0, len = sourceTypes.length; j < len; j++) {
	            srcType = sourceTypes[j];
	            transformation = sourceTransformation[srcType] || {};
	            src = cld.url("" + this.publicId, Util.defaults({}, transformation, {
	              resource_type: 'video',
	              format: srcType
	            }));
	            videoType = srcType === 'ogv' ? 'ogg' : srcType;
	            mimeType = 'video/' + videoType;
	            results.push("<source " + (this.htmlAttrs({
	              src: src,
	              type: mimeType
	            })) + ">");
	          }
	          return results;
	        }).call(this);
	      } else {
	        innerTags = [];
	      }
	      return innerTags.join('') + fallback;
	    };
	
	    VideoTag.prototype.attributes = function() {
	      var a, attr, j, len, poster, ref, ref1, sourceTypes;
	      sourceTypes = this.getOption('source_types');
	      poster = (ref = this.getOption('poster')) != null ? ref : {};
	      if (Util.isPlainObject(poster)) {
	        defaults = poster.public_id != null ? Cloudinary.DEFAULT_IMAGE_PARAMS : DEFAULT_POSTER_OPTIONS;
	        poster = new Cloudinary(this.getOptions()).url((ref1 = poster.public_id) != null ? ref1 : this.publicId, Util.defaults({}, poster, defaults));
	      }
	      attr = VideoTag.__super__.attributes.call(this) || [];
	      for (j = 0, len = attr.length; j < len; j++) {
	        a = attr[j];
	        if (!Util.contains(VIDEO_TAG_PARAMS)) {
	          attr = a;
	        }
	      }
	      if (!Util.isArray(sourceTypes)) {
	        attr["src"] = new Cloudinary(this.getOptions()).url(this.publicId, {
	          resource_type: 'video',
	          format: sourceTypes
	        });
	      }
	      if (poster != null) {
	        attr["poster"] = poster;
	      }
	      return attr;
	    };
	
	    return VideoTag;
	
	  })(HtmlTag);
	
	  /**
	   * Image Tag
	   * Depends on 'tags/htmltag', 'cloudinary'
	   */
	  ClientHintsMetaTag = (function(superClass) {
	    extend(ClientHintsMetaTag, superClass);
	
	
	    /**
	     * Creates an HTML (DOM) Meta tag that enables client-hints.
	     * @constructor ClientHintsMetaTag
	     * @extends HtmlTag
	     */
	
	    function ClientHintsMetaTag(options) {
	      ClientHintsMetaTag.__super__.constructor.call(this, 'meta', void 0, Util.assign({
	        "http-equiv": "Accept-CH",
	        content: "DPR, Viewport-Width, Width"
	      }, options));
	    }
	
	
	    /** @override */
	
	    ClientHintsMetaTag.prototype.closeTag = function() {
	      return "";
	    };
	
	    return ClientHintsMetaTag;
	
	  })(HtmlTag);
	  Cloudinary = (function() {
	    var AKAMAI_SHARED_CDN, CF_SHARED_CDN, DEFAULT_POSTER_OPTIONS, DEFAULT_VIDEO_SOURCE_TYPES, OLD_AKAMAI_SHARED_CDN, SEO_TYPES, SHARED_CDN, VERSION, absolutize, applyBreakpoints, cdnSubdomainNumber, closestAbove, cloudinaryUrlPrefix, defaultBreakpoints, finalizeResourceType, findContainerWidth, maxWidth, updateDpr;
	
	    VERSION = "2.5.0";
	
	    CF_SHARED_CDN = "d3jpl91pxevbkh.cloudfront.net";
	
	    OLD_AKAMAI_SHARED_CDN = "cloudinary-a.akamaihd.net";
	
	    AKAMAI_SHARED_CDN = "res.cloudinary.com";
	
	    SHARED_CDN = AKAMAI_SHARED_CDN;
	
	    DEFAULT_POSTER_OPTIONS = {
	      format: 'jpg',
	      resource_type: 'video'
	    };
	
	    DEFAULT_VIDEO_SOURCE_TYPES = ['webm', 'mp4', 'ogv'];
	
	    SEO_TYPES = {
	      "image/upload": "images",
	      "image/private": "private_images",
	      "image/authenticated": "authenticated_images",
	      "raw/upload": "files",
	      "video/upload": "videos"
	    };
	
	
	    /**
	    * @const {Object} Cloudinary.DEFAULT_IMAGE_PARAMS
	    * Defaults values for image parameters.
	    *
	    * (Previously defined using option_consume() )
	     */
	
	    Cloudinary.DEFAULT_IMAGE_PARAMS = {
	      resource_type: "image",
	      transformation: [],
	      type: 'upload'
	    };
	
	
	    /**
	    * Defaults values for video parameters.
	    * @const {Object} Cloudinary.DEFAULT_VIDEO_PARAMS
	    * (Previously defined using option_consume() )
	     */
	
	    Cloudinary.DEFAULT_VIDEO_PARAMS = {
	      fallback_content: '',
	      resource_type: "video",
	      source_transformation: {},
	      source_types: DEFAULT_VIDEO_SOURCE_TYPES,
	      transformation: [],
	      type: 'upload'
	    };
	
	
	    /**
	     * Main Cloudinary class
	     * @class Cloudinary
	     * @param {Object} options - options to configure Cloudinary
	     * @see Configuration for more details
	     * @example
	     *    var cl = new cloudinary.Cloudinary( { cloud_name: "mycloud"});
	     *    var imgTag = cl.image("myPicID");
	     */
	
	    function Cloudinary(options) {
	      var configuration;
	      this.devicePixelRatioCache = {};
	      this.responsiveConfig = {};
	      this.responsiveResizeInitialized = false;
	      configuration = new Configuration(options);
	      this.config = function(newConfig, newValue) {
	        return configuration.config(newConfig, newValue);
	      };
	
	      /**
	       * Use \<meta\> tags in the document to configure this Cloudinary instance.
	       * @return {Cloudinary} this for chaining
	       */
	      this.fromDocument = function() {
	        configuration.fromDocument();
	        return this;
	      };
	
	      /**
	       * Use environment variables to configure this Cloudinary instance.
	       * @return {Cloudinary} this for chaining
	       */
	      this.fromEnvironment = function() {
	        configuration.fromEnvironment();
	        return this;
	      };
	
	      /**
	       * Initialize configuration.
	       * @function Cloudinary#init
	       * @see Configuration#init
	       * @return {Cloudinary} this for chaining
	       */
	      this.init = function() {
	        configuration.init();
	        return this;
	      };
	    }
	
	
	    /**
	     * Convenience constructor
	     * @param {Object} options
	     * @return {Cloudinary}
	     * @example cl = cloudinary.Cloudinary.new( { cloud_name: "mycloud"})
	     */
	
	    Cloudinary["new"] = function(options) {
	      return new this(options);
	    };
	
	
	    /**
	     * Return the resource type and action type based on the given configuration
	     * @function Cloudinary#finalizeResourceType
	     * @param {Object|string} resourceType
	     * @param {string} [type='upload']
	     * @param {string} [urlSuffix]
	     * @param {boolean} [useRootPath]
	     * @param {boolean} [shorten]
	     * @returns {string} resource_type/type
	     * @ignore
	     */
	
	    finalizeResourceType = function(resourceType, type, urlSuffix, useRootPath, shorten) {
	      var key, options;
	      if (resourceType == null) {
	        resourceType = "image";
	      }
	      if (type == null) {
	        type = "upload";
	      }
	      if (Util.isPlainObject(resourceType)) {
	        options = resourceType;
	        resourceType = options.resource_type;
	        type = options.type;
	        urlSuffix = options.url_suffix;
	        useRootPath = options.use_root_path;
	        shorten = options.shorten;
	      }
	      if (type == null) {
	        type = 'upload';
	      }
	      if (urlSuffix != null) {
	        resourceType = SEO_TYPES[resourceType + "/" + type];
	        type = null;
	        if (resourceType == null) {
	          throw new Error("URL Suffix only supported for " + (((function() {
	            var results;
	            results = [];
	            for (key in SEO_TYPES) {
	              results.push(key);
	            }
	            return results;
	          })()).join(', ')));
	        }
	      }
	      if (useRootPath) {
	        if (resourceType === 'image' && type === 'upload' || resourceType === "images") {
	          resourceType = null;
	          type = null;
	        } else {
	          throw new Error("Root path only supported for image/upload");
	        }
	      }
	      if (shorten && resourceType === 'image' && type === 'upload') {
	        resourceType = 'iu';
	        type = null;
	      }
	      return [resourceType, type].join("/");
	    };
	
	    absolutize = function(url) {
	      var prefix;
	      if (!url.match(/^https?:\//)) {
	        prefix = document.location.protocol + '//' + document.location.host;
	        if (url[0] === '?') {
	          prefix += document.location.pathname;
	        } else if (url[0] !== '/') {
	          prefix += document.location.pathname.replace(/\/[^\/]*$/, '/');
	        }
	        url = prefix + url;
	      }
	      return url;
	    };
	
	
	    /**
	     * Generate an resource URL.
	     * @function Cloudinary#url
	     * @param {string} publicId - the public ID of the resource
	     * @param {Object} [options] - options for the tag and transformations, possible values include all {@link Transformation} parameters
	     *                          and {@link Configuration} parameters
	     * @param {string} [options.type='upload'] - the classification of the resource
	     * @param {Object} [options.resource_type='image'] - the type of the resource
	     * @return {string} The resource URL
	     */
	
	    Cloudinary.prototype.url = function(publicId, options) {
	      var error, error1, prefix, ref, resourceTypeAndType, transformation, transformationString, url, version;
	      if (options == null) {
	        options = {};
	      }
	      if (!publicId) {
	        return publicId;
	      }
	      if (options instanceof Transformation) {
	        options = options.toOptions();
	      }
	      options = Util.defaults({}, options, this.config(), Cloudinary.DEFAULT_IMAGE_PARAMS);
	      if (options.type === 'fetch') {
	        options.fetch_format = options.fetch_format || options.format;
	        publicId = absolutize(publicId);
	      }
	      transformation = new Transformation(options);
	      transformationString = transformation.serialize();
	      if (!options.cloud_name) {
	        throw 'Unknown cloud_name';
	      }
	      if (publicId.search('/') >= 0 && !publicId.match(/^v[0-9]+/) && !publicId.match(/^https?:\//) && !((ref = options.version) != null ? ref.toString() : void 0)) {
	        options.version = 1;
	      }
	      if (publicId.match(/^https?:/)) {
	        if (options.type === 'upload' || options.type === 'asset') {
	          url = publicId;
	        } else {
	          publicId = encodeURIComponent(publicId).replace(/%3A/g, ':').replace(/%2F/g, '/');
	        }
	      } else {
	        try {
	          publicId = decodeURIComponent(publicId);
	        } catch (error1) {
	          error = error1;
	        }
	        publicId = encodeURIComponent(publicId).replace(/%3A/g, ':').replace(/%2F/g, '/');
	        if (options.url_suffix) {
	          if (options.url_suffix.match(/[\.\/]/)) {
	            throw 'url_suffix should not include . or /';
	          }
	          publicId = publicId + '/' + options.url_suffix;
	        }
	        if (options.format) {
	          if (!options.trust_public_id) {
	            publicId = publicId.replace(/\.(jpg|png|gif|webp)$/, '');
	          }
	          publicId = publicId + '.' + options.format;
	        }
	      }
	      prefix = cloudinaryUrlPrefix(publicId, options);
	      resourceTypeAndType = finalizeResourceType(options.resource_type, options.type, options.url_suffix, options.use_root_path, options.shorten);
	      version = options.version ? 'v' + options.version : '';
	      return url || Util.compact([prefix, resourceTypeAndType, transformationString, version, publicId]).join('/').replace(/([^:])\/+/g, '$1/');
	    };
	
	
	    /**
	     * Generate an video resource URL.
	     * @function Cloudinary#video_url
	     * @param {string} publicId - the public ID of the resource
	     * @param {Object} [options] - options for the tag and transformations, possible values include all {@link Transformation} parameters
	     *                          and {@link Configuration} parameters
	     * @param {string} [options.type='upload'] - the classification of the resource
	     * @return {string} The video URL
	     */
	
	    Cloudinary.prototype.video_url = function(publicId, options) {
	      options = Util.assign({
	        resource_type: 'video'
	      }, options);
	      return this.url(publicId, options);
	    };
	
	
	    /**
	     * Generate an video thumbnail URL.
	     * @function Cloudinary#video_thumbnail_url
	     * @param {string} publicId - the public ID of the resource
	     * @param {Object} [options] - options for the tag and transformations, possible values include all {@link Transformation} parameters
	     *                          and {@link Configuration} parameters
	     * @param {string} [options.type='upload'] - the classification of the resource
	     * @return {string} The video thumbnail URL
	     */
	
	    Cloudinary.prototype.video_thumbnail_url = function(publicId, options) {
	      options = Util.assign({}, DEFAULT_POSTER_OPTIONS, options);
	      return this.url(publicId, options);
	    };
	
	
	    /**
	     * Generate a string representation of the provided transformation options.
	     * @function Cloudinary#transformation_string
	     * @param {Object} options - the transformation options
	     * @returns {string} The transformation string
	     */
	
	    Cloudinary.prototype.transformation_string = function(options) {
	      return new Transformation(options).serialize();
	    };
	
	
	    /**
	     * Generate an image tag.
	     * @function Cloudinary#image
	     * @param {string} publicId - the public ID of the image
	     * @param {Object} [options] - options for the tag and transformations
	     * @return {HTMLImageElement} an image tag element
	     */
	
	    Cloudinary.prototype.image = function(publicId, options) {
	      var client_hints, img, ref, ref1;
	      if (options == null) {
	        options = {};
	      }
	      img = this.imageTag(publicId, options);
	      client_hints = (ref = (ref1 = options.client_hints) != null ? ref1 : this.config('client_hints')) != null ? ref : false;
	      if (!((options.src != null) || client_hints)) {
	        img.setAttr("src", '');
	      }
	      img = img.toDOM();
	      if (!client_hints) {
	        Util.setData(img, 'src-cache', this.url(publicId, options));
	        this.cloudinary_update(img, options);
	      }
	      return img;
	    };
	
	
	    /**
	     * Creates a new ImageTag instance, configured using this own's configuration.
	     * @function Cloudinary#imageTag
	     * @param {string} publicId - the public ID of the resource
	     * @param {Object} options - additional options to pass to the new ImageTag instance
	     * @return {ImageTag} An ImageTag that is attached (chained) to this Cloudinary instance
	     */
	
	    Cloudinary.prototype.imageTag = function(publicId, options) {
	      var tag;
	      tag = new ImageTag(publicId, this.config());
	      tag.transformation().fromOptions(options);
	      return tag;
	    };
	
	
	    /**
	     * Generate an image tag for the video thumbnail.
	     * @function Cloudinary#video_thumbnail
	     * @param {string} publicId - the public ID of the video
	     * @param {Object} [options] - options for the tag and transformations
	     * @return {HTMLImageElement} An image tag element
	     */
	
	    Cloudinary.prototype.video_thumbnail = function(publicId, options) {
	      return this.image(publicId, Util.merge({}, DEFAULT_POSTER_OPTIONS, options));
	    };
	
	
	    /**
	     * @function Cloudinary#facebook_profile_image
	     * @param {string} publicId - the public ID of the image
	     * @param {Object} [options] - options for the tag and transformations
	     * @return {HTMLImageElement} an image tag element
	     */
	
	    Cloudinary.prototype.facebook_profile_image = function(publicId, options) {
	      return this.image(publicId, Util.assign({
	        type: 'facebook'
	      }, options));
	    };
	
	
	    /**
	     * @function Cloudinary#twitter_profile_image
	     * @param {string} publicId - the public ID of the image
	     * @param {Object} [options] - options for the tag and transformations
	     * @return {HTMLImageElement} an image tag element
	     */
	
	    Cloudinary.prototype.twitter_profile_image = function(publicId, options) {
	      return this.image(publicId, Util.assign({
	        type: 'twitter'
	      }, options));
	    };
	
	
	    /**
	     * @function Cloudinary#twitter_name_profile_image
	     * @param {string} publicId - the public ID of the image
	     * @param {Object} [options] - options for the tag and transformations
	     * @return {HTMLImageElement} an image tag element
	     */
	
	    Cloudinary.prototype.twitter_name_profile_image = function(publicId, options) {
	      return this.image(publicId, Util.assign({
	        type: 'twitter_name'
	      }, options));
	    };
	
	
	    /**
	     * @function Cloudinary#gravatar_image
	     * @param {string} publicId - the public ID of the image
	     * @param {Object} [options] - options for the tag and transformations
	     * @return {HTMLImageElement} an image tag element
	     */
	
	    Cloudinary.prototype.gravatar_image = function(publicId, options) {
	      return this.image(publicId, Util.assign({
	        type: 'gravatar'
	      }, options));
	    };
	
	
	    /**
	     * @function Cloudinary#fetch_image
	     * @param {string} publicId - the public ID of the image
	     * @param {Object} [options] - options for the tag and transformations
	     * @return {HTMLImageElement} an image tag element
	     */
	
	    Cloudinary.prototype.fetch_image = function(publicId, options) {
	      return this.image(publicId, Util.assign({
	        type: 'fetch'
	      }, options));
	    };
	
	
	    /**
	     * @function Cloudinary#video
	     * @param {string} publicId - the public ID of the image
	     * @param {Object} [options] - options for the tag and transformations
	     * @return {HTMLImageElement} an image tag element
	     */
	
	    Cloudinary.prototype.video = function(publicId, options) {
	      if (options == null) {
	        options = {};
	      }
	      return this.videoTag(publicId, options).toHtml();
	    };
	
	
	    /**
	     * Creates a new VideoTag instance, configured using this own's configuration.
	     * @function Cloudinary#videoTag
	     * @param {string} publicId - the public ID of the resource
	     * @param {Object} options - additional options to pass to the new VideoTag instance
	     * @return {VideoTag} A VideoTag that is attached (chained) to this Cloudinary instance
	     */
	
	    Cloudinary.prototype.videoTag = function(publicId, options) {
	      options = Util.defaults({}, options, this.config());
	      return new VideoTag(publicId, options);
	    };
	
	
	    /**
	     * Generate the URL of the sprite image
	     * @function Cloudinary#sprite_css
	     * @param {string} publicId - the public ID of the resource
	     * @param {Object} [options] - options for the tag and transformations
	     * @see {@link http://cloudinary.com/documentation/sprite_generation Sprite generation}
	     */
	
	    Cloudinary.prototype.sprite_css = function(publicId, options) {
	      options = Util.assign({
	        type: 'sprite'
	      }, options);
	      if (!publicId.match(/.css$/)) {
	        options.format = 'css';
	      }
	      return this.url(publicId, options);
	    };
	
	
	    /**
	    * Initialize the responsive behaviour.<br>
	    * Calls {@link Cloudinary#cloudinary_update} to modify image tags.
	     * @function Cloudinary#responsive
	    * @param {Object} options
	    * @param {String} [options.responsive_class='cld-responsive'] - provide an alternative class used to locate img tags
	    * @param {number} [options.responsive_debounce=100] - the debounce interval in milliseconds.
	    * @param {boolean} [bootstrap=true] if true processes the img tags by calling cloudinary_update. When false the tags will be processed only after a resize event.
	    * @see {@link Cloudinary#cloudinary_update} for additional configuration parameters
	     */
	
	    Cloudinary.prototype.responsive = function(options, bootstrap) {
	      var ref, ref1, ref2, responsiveClass, responsiveResize, timeout;
	      if (bootstrap == null) {
	        bootstrap = true;
	      }
	      this.responsiveConfig = Util.merge(this.responsiveConfig || {}, options);
	      responsiveClass = (ref = this.responsiveConfig['responsive_class']) != null ? ref : this.config('responsive_class');
	      if (bootstrap) {
	        this.cloudinary_update("img." + responsiveClass + ", img.cld-hidpi", this.responsiveConfig);
	      }
	      responsiveResize = (ref1 = (ref2 = this.responsiveConfig['responsive_resize']) != null ? ref2 : this.config('responsive_resize')) != null ? ref1 : true;
	      if (responsiveResize && !this.responsiveResizeInitialized) {
	        this.responsiveConfig.resizing = this.responsiveResizeInitialized = true;
	        timeout = null;
	        return window.addEventListener('resize', (function(_this) {
	          return function() {
	            var debounce, ref3, ref4, reset, run, wait, waitFunc;
	            debounce = (ref3 = (ref4 = _this.responsiveConfig['responsive_debounce']) != null ? ref4 : _this.config('responsive_debounce')) != null ? ref3 : 100;
	            reset = function() {
	              if (timeout) {
	                clearTimeout(timeout);
	                return timeout = null;
	              }
	            };
	            run = function() {
	              return _this.cloudinary_update("img." + responsiveClass, _this.responsiveConfig);
	            };
	            waitFunc = function() {
	              reset();
	              return run();
	            };
	            wait = function() {
	              reset();
	              return timeout = setTimeout(waitFunc, debounce);
	            };
	            if (debounce) {
	              return wait();
	            } else {
	              return run();
	            }
	          };
	        })(this));
	      }
	    };
	
	
	    /**
	     * @function Cloudinary#calc_breakpoint
	     * @private
	     * @ignore
	     */
	
	    Cloudinary.prototype.calc_breakpoint = function(element, width, steps) {
	      var breakpoints, point;
	      breakpoints = Util.getData(element, 'breakpoints') || Util.getData(element, 'stoppoints') || this.config('breakpoints') || this.config('stoppoints') || defaultBreakpoints;
	      if (Util.isFunction(breakpoints)) {
	        return breakpoints(width, steps);
	      } else {
	        if (Util.isString(breakpoints)) {
	          breakpoints = ((function() {
	            var j, len, ref, results;
	            ref = breakpoints.split(',');
	            results = [];
	            for (j = 0, len = ref.length; j < len; j++) {
	              point = ref[j];
	              results.push(parseInt(point));
	            }
	            return results;
	          })()).sort(function(a, b) {
	            return a - b;
	          });
	        }
	        return closestAbove(breakpoints, width);
	      }
	    };
	
	
	    /**
	     * @function Cloudinary#calc_stoppoint
	     * @deprecated Use {@link calc_breakpoint} instead.
	     * @private
	     * @ignore
	     */
	
	    Cloudinary.prototype.calc_stoppoint = Cloudinary.prototype.calc_breakpoint;
	
	
	    /**
	     * @function Cloudinary#device_pixel_ratio
	     * @private
	     */
	
	    Cloudinary.prototype.device_pixel_ratio = function(roundDpr) {
	      var dpr, dprString;
	      if (roundDpr == null) {
	        roundDpr = true;
	      }
	      dpr = (typeof window !== "undefined" && window !== null ? window.devicePixelRatio : void 0) || 1;
	      if (roundDpr) {
	        dpr = Math.ceil(dpr);
	      }
	      if (dpr <= 0 || dpr === NaN) {
	        dpr = 1;
	      }
	      dprString = dpr.toString();
	      if (dprString.match(/^\d+$/)) {
	        dprString += '.0';
	      }
	      return dprString;
	    };
	
	    defaultBreakpoints = function(width, steps) {
	      if (steps == null) {
	        steps = 100;
	      }
	      return steps * Math.ceil(width / steps);
	    };
	
	    closestAbove = function(list, value) {
	      var i;
	      i = list.length - 2;
	      while (i >= 0 && list[i] >= value) {
	        i--;
	      }
	      return list[i + 1];
	    };
	
	    cdnSubdomainNumber = function(publicId) {
	      return crc32(publicId) % 5 + 1;
	    };
	
	    cloudinaryUrlPrefix = function(publicId, options) {
	      var cdnPart, host, path, protocol, ref, subdomain;
	      if (((ref = options.cloud_name) != null ? ref.indexOf("/") : void 0) === 0) {
	        return '/res' + options.cloud_name;
	      }
	      protocol = "http://";
	      cdnPart = "";
	      subdomain = "res";
	      host = ".cloudinary.com";
	      path = "/" + options.cloud_name;
	      if (options.protocol) {
	        protocol = options.protocol + '//';
	      }
	      if (options.private_cdn) {
	        cdnPart = options.cloud_name + "-";
	        path = "";
	      }
	      if (options.cdn_subdomain) {
	        subdomain = "res-" + cdnSubdomainNumber(publicId);
	      }
	      if (options.secure) {
	        protocol = "https://";
	        if (options.secure_cdn_subdomain === false) {
	          subdomain = "res";
	        }
	        if ((options.secure_distribution != null) && options.secure_distribution !== OLD_AKAMAI_SHARED_CDN && options.secure_distribution !== SHARED_CDN) {
	          cdnPart = "";
	          subdomain = "";
	          host = options.secure_distribution;
	        }
	      } else if (options.cname) {
	        protocol = "http://";
	        cdnPart = "";
	        subdomain = options.cdn_subdomain ? 'a' + ((crc32(publicId) % 5) + 1) + '.' : '';
	        host = options.cname;
	      }
	      return [protocol, cdnPart, subdomain, host, path].join("");
	    };
	
	
	    /**
	    * Finds all `img` tags under each node and sets it up to provide the image through Cloudinary
	    * @param {Element[]} nodes the parent nodes to search for img under
	    * @param {Object} [options={}] options and transformations params
	    * @function Cloudinary#processImageTags
	     */
	
	    Cloudinary.prototype.processImageTags = function(nodes, options) {
	      var images, imgOptions, node, publicId, url;
	      if (options == null) {
	        options = {};
	      }
	      if (Util.isEmpty(nodes)) {
	        return this;
	      }
	      options = Util.defaults({}, options, this.config());
	      images = (function() {
	        var j, len, ref, results;
	        results = [];
	        for (j = 0, len = nodes.length; j < len; j++) {
	          node = nodes[j];
	          if (!(((ref = node.tagName) != null ? ref.toUpperCase() : void 0) === 'IMG')) {
	            continue;
	          }
	          imgOptions = Util.assign({
	            width: node.getAttribute('width'),
	            height: node.getAttribute('height'),
	            src: node.getAttribute('src')
	          }, options);
	          publicId = imgOptions['source'] || imgOptions['src'];
	          delete imgOptions['source'];
	          delete imgOptions['src'];
	          url = this.url(publicId, imgOptions);
	          imgOptions = new Transformation(imgOptions).toHtmlAttributes();
	          Util.setData(node, 'src-cache', url);
	          node.setAttribute('width', imgOptions.width);
	          node.setAttribute('height', imgOptions.height);
	          results.push(node);
	        }
	        return results;
	      }).call(this);
	      this.cloudinary_update(images, options);
	      return this;
	    };
	
	    applyBreakpoints = function(tag, width, steps, options) {
	      var ref, ref1, ref2, responsive_use_breakpoints;
	      responsive_use_breakpoints = (ref = (ref1 = (ref2 = options['responsive_use_breakpoints']) != null ? ref2 : options['responsive_use_stoppoints']) != null ? ref1 : this.config('responsive_use_breakpoints')) != null ? ref : this.config('responsive_use_stoppoints');
	      if ((!responsive_use_breakpoints) || (responsive_use_breakpoints === 'resize' && !options.resizing)) {
	        return width;
	      } else {
	        return this.calc_breakpoint(tag, width, steps);
	      }
	    };
	
	    findContainerWidth = function(element) {
	      var containerWidth, style;
	      containerWidth = 0;
	      while (((element = element != null ? element.parentNode : void 0) instanceof Element) && !containerWidth) {
	        style = window.getComputedStyle(element);
	        if (!/^inline/.test(style.display)) {
	          containerWidth = Util.width(element);
	        }
	      }
	      return containerWidth;
	    };
	
	    updateDpr = function(dataSrc, roundDpr) {
	      return dataSrc.replace(/\bdpr_(1\.0|auto)\b/g, 'dpr_' + this.device_pixel_ratio(roundDpr));
	    };
	
	    maxWidth = function(requiredWidth, tag) {
	      var imageWidth;
	      imageWidth = Util.getData(tag, 'width') || 0;
	      if (requiredWidth > imageWidth) {
	        imageWidth = requiredWidth;
	        Util.setData(tag, 'width', requiredWidth);
	      }
	      return imageWidth;
	    };
	
	
	    /**
	    * Update hidpi (dpr_auto) and responsive (w_auto) fields according to the current container size and the device pixel ratio.
	    * Only images marked with the cld-responsive class have w_auto updated.
	    * @function Cloudinary#cloudinary_update
	    * @param {(Array|string|NodeList)} elements - the elements to modify
	    * @param {Object} options
	    * @param {boolean|string} [options.responsive_use_breakpoints=true]
	    *  - when `true`, always use breakpoints for width
	    * - when `"resize"` use exact width on first render and breakpoints on resize
	    * - when `false` always use exact width
	    * @param {boolean} [options.responsive] - if `true`, enable responsive on this element. Can be done by adding cld-responsive.
	    * @param {boolean} [options.responsive_preserve_height] - if set to true, original css height is preserved.
	    *   Should only be used if the transformation supports different aspect ratios.
	     */
	
	    Cloudinary.prototype.cloudinary_update = function(elements, options) {
	      var containerWidth, dataSrc, j, len, match, ref, ref1, ref2, ref3, ref4, ref5, requiredWidth, responsive, responsiveClass, roundDpr, setUrl, tag;
	      if (options == null) {
	        options = {};
	      }
	      if (elements === null) {
	        return this;
	      }
	      responsive = (ref = (ref1 = options.responsive) != null ? ref1 : this.config('responsive')) != null ? ref : false;
	      elements = (function() {
	        switch (false) {
	          case !Util.isArray(elements):
	            return elements;
	          case elements.constructor.name !== "NodeList":
	            return elements;
	          case !Util.isString(elements):
	            return document.querySelectorAll(elements);
	          default:
	            return [elements];
	        }
	      })();
	      responsiveClass = (ref2 = (ref3 = this.responsiveConfig['responsive_class']) != null ? ref3 : options['responsive_class']) != null ? ref2 : this.config('responsive_class');
	      roundDpr = (ref4 = options['round_dpr']) != null ? ref4 : this.config('round_dpr');
	      for (j = 0, len = elements.length; j < len; j++) {
	        tag = elements[j];
	        if (!((ref5 = tag.tagName) != null ? ref5.match(/img/i) : void 0)) {
	          continue;
	        }
	        setUrl = true;
	        if (responsive) {
	          Util.addClass(tag, responsiveClass);
	        }
	        dataSrc = Util.getData(tag, 'src-cache') || Util.getData(tag, 'src');
	        if (!Util.isEmpty(dataSrc)) {
	          dataSrc = updateDpr.call(this, dataSrc, roundDpr);
	          if (HtmlTag.isResponsive(tag, responsiveClass)) {
	            containerWidth = findContainerWidth(tag);
	            if (containerWidth !== 0) {
	              switch (false) {
	                case !/w_auto:breakpoints/.test(dataSrc):
	                  requiredWidth = maxWidth(containerWidth, tag);
	                  dataSrc = dataSrc.replace(/w_auto:breakpoints([_0-9]*)(:[0-9]+)?/, "w_auto:breakpoints$1:" + requiredWidth);
	                  break;
	                case !(match = /w_auto(:(\d+))?/.exec(dataSrc)):
	                  requiredWidth = applyBreakpoints.call(this, tag, containerWidth, match[2], options);
	                  requiredWidth = maxWidth(requiredWidth, tag);
	                  dataSrc = dataSrc.replace(/w_auto[^,\/]*/g, "w_" + requiredWidth);
	              }
	              Util.removeAttribute(tag, 'width');
	              if (!options.responsive_preserve_height) {
	                Util.removeAttribute(tag, 'height');
	              }
	            } else {
	              setUrl = false;
	            }
	          }
	          if (setUrl) {
	            Util.setAttribute(tag, 'src', dataSrc);
	          }
	        }
	      }
	      return this;
	    };
	
	
	    /**
	     * Provide a transformation object, initialized with own's options, for chaining purposes.
	     * @function Cloudinary#transformation
	     * @param {Object} options
	     * @return {Transformation}
	     */
	
	    Cloudinary.prototype.transformation = function(options) {
	      return Transformation["new"](this.config()).fromOptions(options).setParent(this);
	    };
	
	    return Cloudinary;
	
	  })();
	  cloudinary = {
	    utf8_encode: utf8_encode,
	    crc32: crc32,
	    Util: Util,
	    Condition: Condition,
	    Transformation: Transformation,
	    Configuration: Configuration,
	    HtmlTag: HtmlTag,
	    ImageTag: ImageTag,
	    VideoTag: VideoTag,
	    ClientHintsMetaTag: ClientHintsMetaTag,
	    Layer: Layer,
	    FetchLayer: FetchLayer,
	    TextLayer: TextLayer,
	    SubtitlesLayer: SubtitlesLayer,
	    Cloudinary: Cloudinary,
	    VERSION: "2.5.0"
	  };
	  return cloudinary;
	});
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(311).Buffer, __webpack_require__(45)))

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(27),
	    root = __webpack_require__(16);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 104 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 105 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(107),
	    eq = __webpack_require__(74);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(186);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(317);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(191);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(175),
	    stubArray = __webpack_require__(198);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(187);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(164)(module)))

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(26),
	    getPrototype = __webpack_require__(109),
	    isObjectLike = __webpack_require__(17);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(338),
	    baseUnary = __webpack_require__(70),
	    nodeUtil = __webpack_require__(111);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(12);
	var settle = __webpack_require__(271);
	var buildURL = __webpack_require__(274);
	var parseHeaders = __webpack_require__(280);
	var isURLSameOrigin = __webpack_require__(278);
	var createError = __webpack_require__(168);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(273);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(276);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),
/* 166 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),
/* 167 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(270);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ }),
/* 169 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(378),
	    mapCacheDelete = __webpack_require__(379),
	    mapCacheGet = __webpack_require__(380),
	    mapCacheHas = __webpack_require__(381),
	    mapCacheSet = __webpack_require__(382);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(67),
	    stackClear = __webpack_require__(391),
	    stackDelete = __webpack_require__(392),
	    stackGet = __webpack_require__(393),
	    stackHas = __webpack_require__(394),
	    stackSet = __webpack_require__(395);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 175 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(344),
	    isArguments = __webpack_require__(75),
	    isArray = __webpack_require__(21),
	    isBuffer = __webpack_require__(76),
	    isIndex = __webpack_require__(190),
	    isTypedArray = __webpack_require__(114);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(107),
	    eq = __webpack_require__(74);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(105),
	    isArray = __webpack_require__(21);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(52),
	    nativeKeys = __webpack_require__(383);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(112),
	    overRest = __webpack_require__(386),
	    setToString = __webpack_require__(389);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(51),
	    arrayMap = __webpack_require__(104),
	    isArray = __webpack_require__(21),
	    isSymbol = __webpack_require__(197);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(16);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(164)(module)))

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(108);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 184 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(180),
	    isIterateeCall = __webpack_require__(370);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(27);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 187 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(105),
	    getPrototype = __webpack_require__(109),
	    getSymbols = __webpack_require__(110),
	    stubArray = __webpack_require__(198);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(327),
	    getPrototype = __webpack_require__(109),
	    isPrototype = __webpack_require__(52);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 190 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 191 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 192 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key`, unless `key` is "__proto__".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  if (key == '__proto__') {
	    return;
	  }
	
	  return object[key];
	}
	
	module.exports = safeGet;


/***/ }),
/* 193 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(28),
	    isObjectLike = __webpack_require__(17);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ }),
/* 195 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(26),
	    isArray = __webpack_require__(21),
	    isObjectLike = __webpack_require__(17);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(26),
	    isObjectLike = __webpack_require__(17);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 198 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _jump = __webpack_require__(549);
	
	var _jump2 = _interopRequireDefault(_jump);
	
	var _func = __webpack_require__(639);
	
	var _scroll = __webpack_require__(640);
	
	var _hash = __webpack_require__(258);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var defaultConfig = {
	  offset: 0,
	  scrollDuration: 400,
	  keepLastAnchorHash: false
	};
	
	var Manager = function Manager() {
	  var _this = this;
	
	  _classCallCheck(this, Manager);
	
	  this.addListeners = function () {
	    window.addEventListener('scroll', _this.scrollHandler, false);
	    window.addEventListener('hashchange', _this.handleHashChange);
	  };
	
	  this.removeListeners = function () {
	    window.removeEventListener('scroll', _this.scrollHandler, false);
	    window.removeEventListener('hashchange', _this.handleHashChange);
	  };
	
	  this.configure = function (config) {
	    _this.config = _extends({}, defaultConfig, config);
	  };
	
	  this.goToTop = function () {
	    if ((0, _scroll.getScrollTop)() === 0) return;
	    _this.forcedHash = true;
	    window.scroll(0, 0);
	  };
	
	  this.addAnchor = function (id, component) {
	    // if this is the first anchor, set up listeners
	    if (Object.keys(_this.anchors).length === 0) {
	      _this.addListeners();
	    }
	    _this.forceHashUpdate();
	    _this.anchors[id] = component;
	  };
	
	  this.removeAnchor = function (id) {
	    delete _this.anchors[id];
	    // if this is the last anchor, remove listeners
	    if (Object.keys(_this.anchors).length === 0) {
	      _this.removeListeners();
	    }
	  };
	
	  this.handleScroll = function () {
	    var _config = _this.config,
	        offset = _config.offset,
	        keepLastAnchorHash = _config.keepLastAnchorHash;
	
	    var bestAnchorId = (0, _scroll.getBestAnchorGivenScrollLocation)(_this.anchors, offset);
	
	    if (bestAnchorId && (0, _hash.getHash)() !== bestAnchorId) {
	      _this.forcedHash = true;
	      (0, _hash.updateHash)(bestAnchorId, false);
	    } else if (!bestAnchorId && !keepLastAnchorHash) {
	      (0, _hash.removeHash)();
	    }
	  };
	
	  this.handleHashChange = function (e) {
	    if (_this.forcedHash) {
	      _this.forcedHash = false;
	    } else {
	      _this.goToSection((0, _hash.getHash)());
	    }
	  };
	
	  this.goToSection = function (id) {
	    var element = _this.anchors[id];
	    if (element) {
	      (0, _jump2.default)(element, {
	        duration: _this.config.scrollDuration,
	        offset: _this.config.offset
	      });
	    } else {
	      // make sure that standard hash anchors don't break.
	      // simply jump to them.
	      element = document.getElementById(id);
	      if (element) {
	        (0, _jump2.default)(element, {
	          duration: 0,
	          offset: _this.config.offset
	        });
	      }
	    }
	  };
	
	  this.anchors = {};
	  this.forcedHash = false;
	  this.config = defaultConfig;
	
	  this.scrollHandler = (0, _func.debounce)(this.handleScroll, 100);
	  this.forceHashUpdate = (0, _func.debounce)(this.handleHashChange, 1);
	};
	
	exports.default = new Manager();

/***/ }),
/* 258 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getHash = exports.getHash = function getHash() {
	  return decodeURI(window.location.hash.slice(1));
	};
	
	var updateHash = exports.updateHash = function updateHash(hash, affectHistory) {
	  if (affectHistory) {
	    window.location.hash = hash;
	  } else {
	    window.location.replace("#" + hash);
	  }
	};
	
	// remove hash in url without affecting history or forcing reload
	var removeHash = exports.removeHash = function removeHash() {
	  history.replaceState("", document.title, window.location.pathname + window.location.search);
	};

/***/ }),
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(265);

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(12);
	var bind = __webpack_require__(169);
	var Axios = __webpack_require__(267);
	var defaults = __webpack_require__(98);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(166);
	axios.CancelToken = __webpack_require__(266);
	axios.isCancel = __webpack_require__(167);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(281);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(166);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(98);
	var utils = __webpack_require__(12);
	var InterceptorManager = __webpack_require__(268);
	var dispatchRequest = __webpack_require__(269);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
	  config.method = config.method.toLowerCase();
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(12);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(12);
	var transformData = __webpack_require__(272);
	var isCancel = __webpack_require__(167);
	var defaults = __webpack_require__(98);
	var isAbsoluteURL = __webpack_require__(277);
	var combineURLs = __webpack_require__(275);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),
/* 270 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(168);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(12);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),
/* 273 */
/***/ (function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(12);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),
/* 275 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(12);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ }),
/* 277 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(12);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(12);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(12);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ }),
/* 281 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cloudinaryReact = __webpack_require__(429);
	
	var _axios = __webpack_require__(264);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _gatsbyLink = __webpack_require__(90);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(510);
	
	var _reactScrollableAnchor = __webpack_require__(638);
	
	var _reactScrollableAnchor2 = _interopRequireDefault(_reactScrollableAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	if (typeof window !== 'undefined') {
	    var GLightbox = __webpack_require__(539);
	}
	
	var Gallery = function (_React$Component) {
	    _inherits(Gallery, _React$Component);
	
	    function Gallery(props) {
	        _classCallCheck(this, Gallery);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            gallery: [],
	            galleryName: _this.props.galleryName,
	            galleryTitle: _this.props.galleryTitle,
	            galleryDesc: _this.props.galleryDesc
	        };
	        _this.lightBox = _this.lightBox.bind(_this);
	        return _this;
	    }
	
	    Gallery.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        _axios2.default.get('https://res.cloudinary.com/zackshave/image/list/' + this.state.galleryName + '.json').then(function (res) {
	            console.log(res.data.resources);
	            _this2.setState({ gallery: res.data.resources });
	        });
	    };
	
	    Gallery.prototype.lightBox = function lightBox(e) {
	        e.preventDefault();
	        if (typeof navigator !== 'undefined') {
	            var lightBox = GLightbox({
	                selector: 'lightbox-' + this.state.galleryName
	            });
	        }
	    };
	
	    Gallery.prototype.render = function render() {
	        var _this3 = this;
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'gallery' },
	            _react2.default.createElement(
	                _reactScrollableAnchor2.default,
	                { id: this.state.galleryName },
	                _react2.default.createElement(
	                    'h2',
	                    { className: 'title is-4' },
	                    this.state.galleryTitle
	                )
	            ),
	            _react2.default.createElement(
	                _cloudinaryReact.CloudinaryContext,
	                { cloudName: 'zackshave', className: 'columns is-multiline is-mobile is-centered', onLoad: this.lightBox },
	                this.state.gallery.sort(function (a, b) {
	                    return a - b;
	                }).map(function (data) {
	                    var _React$createElement;
	
	                    return _react2.default.createElement(
	                        'div',
	                        { className: 'column is-half-mobile is-one-third-tablet', key: data.public_id },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'img' },
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'https://res.cloudinary.com/zackshave/image/upload/v1/' + data.public_id + '.jpg', className: 'lightbox-' + _this3.state.galleryName, 'data-title': data.context.custom.caption, 'data-description': data.context.custom.alt },
	                                _react2.default.createElement(
	                                    _cloudinaryReact.Image,
	                                    { publicId: data.public_id },
	                                    _react2.default.createElement(_cloudinaryReact.Transformation, (_React$createElement = {
	                                        crop: 'scale',
	                                        height: '725',
	                                        width: '725'
	                                    }, _React$createElement['crop'] = 'lpad', _React$createElement.dpr = 'auto', _React$createElement.responsive_placeholder = 'blank', _React$createElement))
	                                )
	                            )
	                        )
	                    );
	                })
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                this.state.galleryDesc,
	                this.state.galleryName === 'gallery-1' ? _react2.default.createElement(
	                    'small',
	                    { className: 'giclee mt-1' },
	                    '* The images in this gallery are available on giclee, an archival inkjet print with pigment inks. You can ',
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: '/contact', className: 'giclee-link' },
	                        'contact me'
	                    ),
	                    ' for more details.'
	                ) : ''
	            )
	        );
	    };
	
	    return Gallery;
	}(_react2.default.Component);
	
	exports.default = Gallery;
	module.exports = exports['default'];

/***/ }),
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Gallery = __webpack_require__(290);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _gatsbyLink = __webpack_require__(90);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'section' },
	      _react2.default.createElement(
	        'p',
	        { className: 'is-size-4' },
	        'Welcome to my online gallery of art. I am  delighted that you are interested in my work. All paintings displayed in the galleries below are available for sale. Click on the image to find out more about the work; dimensions, title and pricing. ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/contact' },
	          'Requests for commissions are also welcome.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'section' },
	      _react2.default.createElement(_Gallery2.default, {
	        galleryName: 'gallery-1',
	        galleryDesc: 'The first selection of paintings featured is part of an ongoing series called \'Garden Gnomes\'. Some of the themes captured in these images address current environmental stories. The results are colourful, gestural bodies caught in fragile, whimsical situations that draw attention to serious events such as the troubling plight of bees in \u2018Just the Bee\u2019s Knees\u2019.',
	        galleryTitle: 'Garden Gnomes'
	
	      }),
	      _react2.default.createElement(_Gallery2.default, {
	        galleryName: 'gallery-2',
	        galleryTitle: 'At One With Nature',
	        galleryDesc: 'The second gallery called \u2018At One with Nature\u2019 asks about humanity\u2019s interaction with the natural landscape, spiritually, physically, and ethically. \u2019Tossing Rocks\u2019 depicts two figures effortlessly throwing a boulder symbolizing humankind\u2019s drive to manipulate the environment without anticipating a dangerous outcome. More like large scale drawings, this body of work radiates a bold, youthful exuberance because of Sherry\u2019s technique of applying vivid colours with long, linear, gestural strokes.'
	      })
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ }),
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  for (var i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(310)
	var ieee754 = __webpack_require__(540)
	var isArray = __webpack_require__(229)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(27),
	    root = __webpack_require__(16);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(362),
	    hashDelete = __webpack_require__(363),
	    hashGet = __webpack_require__(364),
	    hashHas = __webpack_require__(365),
	    hashSet = __webpack_require__(366);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(27),
	    root = __webpack_require__(16);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(27),
	    root = __webpack_require__(16);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(173),
	    setCacheAdd = __webpack_require__(387),
	    setCacheHas = __webpack_require__(388);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(16);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(27),
	    root = __webpack_require__(16);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 319 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 320 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(69);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ }),
/* 322 */
/***/ (function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ }),
/* 323 */
/***/ (function(module, exports) {

	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	module.exports = asciiToArray;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(33),
	    keys = __webpack_require__(34);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(33),
	    keysIn = __webpack_require__(77);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(174),
	    arrayEach = __webpack_require__(320),
	    assignValue = __webpack_require__(106),
	    baseAssign = __webpack_require__(324),
	    baseAssignIn = __webpack_require__(325),
	    cloneBuffer = __webpack_require__(182),
	    copyArray = __webpack_require__(184),
	    copySymbols = __webpack_require__(353),
	    copySymbolsIn = __webpack_require__(354),
	    getAllKeys = __webpack_require__(357),
	    getAllKeysIn = __webpack_require__(358),
	    getTag = __webpack_require__(72),
	    initCloneArray = __webpack_require__(367),
	    initCloneByTag = __webpack_require__(368),
	    initCloneObject = __webpack_require__(189),
	    isArray = __webpack_require__(21),
	    isBuffer = __webpack_require__(76),
	    isMap = __webpack_require__(408),
	    isObject = __webpack_require__(22),
	    isSet = __webpack_require__(409),
	    keys = __webpack_require__(34);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	
	    return result;
	  }
	
	  if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	
	    return result;
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(22);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(316),
	    arrayIncludes = __webpack_require__(321),
	    arrayIncludesWith = __webpack_require__(322),
	    arrayMap = __webpack_require__(104),
	    baseUnary = __webpack_require__(70),
	    cacheHas = __webpack_require__(346);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee == null ? value : iteratee(value);
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ }),
/* 329 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(105),
	    isFlattenable = __webpack_require__(369);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(356);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(175),
	    isFunction = __webpack_require__(53);
	
	/**
	 * The base implementation of `_.functions` which creates an array of
	 * `object` function property names filtered from `props`.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Array} props The property names to filter.
	 * @returns {Array} Returns the function names.
	 */
	function baseFunctions(object, props) {
	  return arrayFilter(props, function(key) {
	    return isFunction(object[key]);
	  });
	}
	
	module.exports = baseFunctions;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(26),
	    isObjectLike = __webpack_require__(17);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(72),
	    isObjectLike = __webpack_require__(17);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ }),
/* 335 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(53),
	    isMasked = __webpack_require__(372),
	    isObject = __webpack_require__(22),
	    toSource = __webpack_require__(193);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(72),
	    isObjectLike = __webpack_require__(17);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(26),
	    isLength = __webpack_require__(195),
	    isObjectLike = __webpack_require__(17);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(22),
	    isPrototype = __webpack_require__(52),
	    nativeKeysIn = __webpack_require__(384);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(174),
	    assignMergeValue = __webpack_require__(177),
	    baseFor = __webpack_require__(331),
	    baseMergeDeep = __webpack_require__(341),
	    isObject = __webpack_require__(22),
	    keysIn = __webpack_require__(77),
	    safeGet = __webpack_require__(192);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(177),
	    cloneBuffer = __webpack_require__(182),
	    cloneTypedArray = __webpack_require__(183),
	    copyArray = __webpack_require__(184),
	    initCloneObject = __webpack_require__(189),
	    isArguments = __webpack_require__(75),
	    isArray = __webpack_require__(21),
	    isArrayLikeObject = __webpack_require__(194),
	    isBuffer = __webpack_require__(76),
	    isFunction = __webpack_require__(53),
	    isObject = __webpack_require__(22),
	    isPlainObject = __webpack_require__(113),
	    isTypedArray = __webpack_require__(114),
	    safeGet = __webpack_require__(192),
	    toPlainObject = __webpack_require__(415);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || isFunction(objValue)) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(402),
	    defineProperty = __webpack_require__(186),
	    identity = __webpack_require__(112);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 343 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ }),
/* 344 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(104);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ }),
/* 346 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(343);
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	module.exports = castSlice;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(69);
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	 * that is not found in the character symbols.
	 *
	 * @private
	 * @param {Array} strSymbols The string symbols to inspect.
	 * @param {Array} chrSymbols The character symbols to find.
	 * @returns {number} Returns the index of the last unmatched string symbol.
	 */
	function charsEndIndex(strSymbols, chrSymbols) {
	  var index = strSymbols.length;
	
	  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	  return index;
	}
	
	module.exports = charsEndIndex;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(69);
	
	/**
	 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	 * that is not found in the character symbols.
	 *
	 * @private
	 * @param {Array} strSymbols The string symbols to inspect.
	 * @param {Array} chrSymbols The character symbols to find.
	 * @returns {number} Returns the index of the first unmatched string symbol.
	 */
	function charsStartIndex(strSymbols, chrSymbols) {
	  var index = -1,
	      length = strSymbols.length;
	
	  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	  return index;
	}
	
	module.exports = charsStartIndex;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(108);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ }),
/* 351 */
/***/ (function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(51);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(33),
	    getSymbols = __webpack_require__(110);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(33),
	    getSymbolsIn = __webpack_require__(188);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(16);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 356 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(178),
	    getSymbols = __webpack_require__(110),
	    keys = __webpack_require__(34);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(178),
	    getSymbolsIn = __webpack_require__(188),
	    keysIn = __webpack_require__(77);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(51);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 360 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 361 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	module.exports = hasUnicode;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(73);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 363 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(73);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(73);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(73);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 367 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(108),
	    cloneDataView = __webpack_require__(350),
	    cloneRegExp = __webpack_require__(351),
	    cloneSymbol = __webpack_require__(352),
	    cloneTypedArray = __webpack_require__(183);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(51),
	    isArguments = __webpack_require__(75),
	    isArray = __webpack_require__(21);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(74),
	    isArrayLike = __webpack_require__(28),
	    isIndex = __webpack_require__(190),
	    isObject = __webpack_require__(22);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 371 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(355);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 373 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(68);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(68);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(68);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(68);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(313),
	    ListCache = __webpack_require__(67),
	    Map = __webpack_require__(103);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(71);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(71);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(71);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(71);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(191);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 384 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 385 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(319);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 387 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 388 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(342),
	    shortOut = __webpack_require__(390);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 390 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(67);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 392 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 393 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 394 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(67),
	    Map = __webpack_require__(103),
	    MapCache = __webpack_require__(173);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 396 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	var asciiToArray = __webpack_require__(323),
	    hasUnicode = __webpack_require__(361),
	    unicodeToArray = __webpack_require__(398);
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	module.exports = stringToArray;


/***/ }),
/* 398 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	module.exports = unicodeToArray;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(106),
	    copyObject = __webpack_require__(33),
	    createAssigner = __webpack_require__(185),
	    isArrayLike = __webpack_require__(28),
	    isPrototype = __webpack_require__(52),
	    keys = __webpack_require__(34);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	module.exports = assign;


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(326);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = cloneDeep;


/***/ }),
/* 401 */
/***/ (function(module, exports) {

	/**
	 * Creates an array with all falsey values removed. The values `false`, `null`,
	 * `0`, `""`, `undefined`, and `NaN` are falsey.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to compact.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.compact([0, 1, false, 2, '', 3]);
	 * // => [1, 2, 3]
	 */
	function compact(array) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = compact;


/***/ }),
/* 402 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(328),
	    baseFlatten = __webpack_require__(330),
	    baseRest = __webpack_require__(180),
	    isArrayLikeObject = __webpack_require__(194);
	
	/**
	 * Creates an array of `array` values not included in the other given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * **Note:** Unlike `_.pullAll`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...Array} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.without, _.xor
	 * @example
	 *
	 * _.difference([2, 1], [2, 3]);
	 * // => [1]
	 */
	var difference = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	    : [];
	});
	
	module.exports = difference;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFunctions = __webpack_require__(332),
	    keys = __webpack_require__(34);
	
	/**
	 * Creates an array of function property names from own enumerable properties
	 * of `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to inspect.
	 * @returns {Array} Returns the function names.
	 * @see _.functionsIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = _.constant('a');
	 *   this.b = _.constant('b');
	 * }
	 *
	 * Foo.prototype.c = _.constant('c');
	 *
	 * _.functions(new Foo);
	 * // => ['a', 'b']
	 */
	function functions(object) {
	  return object == null ? [] : baseFunctions(object, keys(object));
	}
	
	module.exports = functions;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(69),
	    isArrayLike = __webpack_require__(28),
	    isString = __webpack_require__(196),
	    toInteger = __webpack_require__(413),
	    values = __webpack_require__(418);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string, it's
	 * checked for a substring of `value`, otherwise
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'a': 1, 'b': 2 }, 1);
	 * // => true
	 *
	 * _.includes('abcd', 'bc');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike(collection) ? collection : values(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return isString(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	}
	
	module.exports = includes;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(17),
	    isPlainObject = __webpack_require__(113);
	
	/**
	 * Checks if `value` is likely a DOM element.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	 * @example
	 *
	 * _.isElement(document.body);
	 * // => true
	 *
	 * _.isElement('<body>');
	 * // => false
	 */
	function isElement(value) {
	  return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	}
	
	module.exports = isElement;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(179),
	    getTag = __webpack_require__(72),
	    isArguments = __webpack_require__(75),
	    isArray = __webpack_require__(21),
	    isArrayLike = __webpack_require__(28),
	    isBuffer = __webpack_require__(76),
	    isPrototype = __webpack_require__(52),
	    isTypedArray = __webpack_require__(114);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !baseKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__(334),
	    baseUnary = __webpack_require__(70),
	    nodeUtil = __webpack_require__(111);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsSet = __webpack_require__(337),
	    baseUnary = __webpack_require__(70),
	    nodeUtil = __webpack_require__(111);
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(340),
	    createAssigner = __webpack_require__(185);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ }),
/* 411 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(414);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(412);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(22),
	    isSymbol = __webpack_require__(197);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(33),
	    keysIn = __webpack_require__(77);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(181);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(181),
	    castSlice = __webpack_require__(347),
	    charsEndIndex = __webpack_require__(348),
	    charsStartIndex = __webpack_require__(349),
	    stringToArray = __webpack_require__(397),
	    toString = __webpack_require__(416);
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/**
	 * Removes leading and trailing whitespace or specified characters from `string`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to trim.
	 * @param {string} [chars=whitespace] The characters to trim.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {string} Returns the trimmed string.
	 * @example
	 *
	 * _.trim('  abc  ');
	 * // => 'abc'
	 *
	 * _.trim('-_-abc-_-', '_-');
	 * // => 'abc'
	 *
	 * _.map(['  foo  ', '  bar  '], _.trim);
	 * // => ['foo', 'bar']
	 */
	function trim(string, chars, guard) {
	  string = toString(string);
	  if (string && (guard || chars === undefined)) {
	    return string.replace(reTrim, '');
	  }
	  if (!string || !(chars = baseToString(chars))) {
	    return string;
	  }
	  var strSymbols = stringToArray(string),
	      chrSymbols = stringToArray(chars),
	      start = charsStartIndex(strSymbols, chrSymbols),
	      end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	  return castSlice(strSymbols, start, end).join('');
	}
	
	module.exports = trim;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(345),
	    keys = __webpack_require__(34);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object == null ? [] : baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "debounce", {
	  enumerable: true,
	  get: function get() {
	    return _debounce2.default;
	  }
	});
	Object.defineProperty(exports, "firstDefined", {
	  enumerable: true,
	  get: function get() {
	    return _firstDefined2.default;
	  }
	});
	Object.defineProperty(exports, "closestAbove", {
	  enumerable: true,
	  get: function get() {
	    return _closestAbove2.default;
	  }
	});
	Object.defineProperty(exports, "requestAnimationFrame", {
	  enumerable: true,
	  get: function get() {
	    return _requestAnimationFrame.requestAnimationFrame;
	  }
	});
	Object.defineProperty(exports, "cancelAnimationFrame", {
	  enumerable: true,
	  get: function get() {
	    return _requestAnimationFrame.cancelAnimationFrame;
	  }
	});
	Object.defineProperty(exports, "isElement", {
	  enumerable: true,
	  get: function get() {
	    return _isElement2.default;
	  }
	});
	
	var _debounce2 = _interopRequireDefault(__webpack_require__(421));
	
	var _firstDefined2 = _interopRequireDefault(__webpack_require__(422));
	
	var _closestAbove2 = _interopRequireDefault(__webpack_require__(420));
	
	var _requestAnimationFrame = __webpack_require__(424);
	
	var _isElement2 = _interopRequireDefault(__webpack_require__(423));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 420 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = closestAbove;
	
	/**
	 * Returns the first item in list that is greater or equal to the given value.
	 * @param {Array} list a sorted array of items
	 * @param {*} value
	 * @returns {*}
	 * @protected
	 */
	function closestAbove(list, value) {
	  return list.reduce(function (last, next) {
	    return value <= last ? last : next;
	  }, undefined);
	}

/***/ }),
/* 421 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = debounce;
	
	/**
	 * Delay execution of func until wait milliseconds have passed since the last invocation of the returned debounced function.
	 * @param {function} func the function to execute
	 * @param {number} wait waiting time in milliseconds
	 * @param {boolean=false} immediate if true execute func at the beginning of the wait period
	 * @returns {function()} debounced function
	 * @protected
	 */
	function debounce(func, wait, immediate) {
	  var _this = this,
	      _arguments = arguments;
	
	  var timeout = null;
	
	  var debounced = function debounced() {
	    var context = _this;
	    var args = _arguments;
	    var callNow = immediate && !timeout;
	
	    if (timeout) {
	      clearTimeout(timeout);
	    }
	
	    var later = function later() {
	      timeout = null;
	
	      if (!immediate) {
	        func.apply(context, args);
	      }
	    };
	
	    timeout = setTimeout(later, wait);
	
	    if (callNow) {
	      func.apply(context, args);
	    }
	  };
	
	  debounced.cancel = function () {
	    clearTimeout(timeout);
	    timeout = null;
	  };
	
	  return debounced;
	}

/***/ }),
/* 422 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = firstDefined;
	
	/**
	 * Returns the first argument that is not undefined
	 * @param {...*} values a list of arguments of any type
	 * @returns {*}
	 * @protected
	 */
	function firstDefined() {
	  for (var i = 0; i < arguments.length; i++) {
	    if ((i < 0 || arguments.length <= i ? undefined : arguments[i]) !== undefined) return i < 0 || arguments.length <= i ? undefined : arguments[i];
	  }
	
	  return undefined;
	}

/***/ }),
/* 423 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isElement;
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	// Originally from lodash
	
	/**
	 * Checks if `value` is a DOM element.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	 * @protected
	 * @example
	 *
	 * _.isElement(document.body);
	 * // => true
	 *
	 * _.isElement('<body>');
	 * // => false
	 */
	function isElement(value) {
	  return value != null && value.nodeType === 1 && isObjectLike(value);
	}
	
	function isObjectLike(value) {
	  return value != null && _typeof(value) == 'object';
	}

/***/ }),
/* 424 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cancelAnimationFrame = exports.requestAnimationFrame = void 0;
	// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
	// https://gist.github.com/paulirish/1579671
	// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
	// MIT license
	var lastTime = 0;
	var vendors = ['ms', 'moz', 'webkit', 'o'];
	var requestAnimationFrame;
	exports.requestAnimationFrame = requestAnimationFrame;
	var cancelAnimationFrame;
	exports.cancelAnimationFrame = cancelAnimationFrame;
	
	if (typeof window != "undefined") {
	  exports.requestAnimationFrame = requestAnimationFrame = window.requestAnimationFrame;
	  exports.cancelAnimationFrame = cancelAnimationFrame = window.cancelAnimationFrame;
	
	  for (var x = 0; x < vendors.length && !requestAnimationFrame; ++x) {
	    exports.requestAnimationFrame = requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
	    exports.cancelAnimationFrame = cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
	  }
	}
	
	if (!requestAnimationFrame) exports.requestAnimationFrame = requestAnimationFrame = function requestAnimationFrame(callback, element) {
	  var currTime = new Date().getTime();
	  var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	  var id = setTimeout(function () {
	    callback(currTime + timeToCall);
	  }, timeToCall);
	  lastTime = currTime + timeToCall;
	  return id;
	};
	if (!cancelAnimationFrame) exports.cancelAnimationFrame = cancelAnimationFrame = function cancelAnimationFrame(id) {
	  clearTimeout(id);
	};

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _CloudinaryComponent2 = _interopRequireDefault(__webpack_require__(78));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	/**
	 * Provides a container for Cloudinary components. Any option set in CloudinaryContext will be passed to the children.
	 * 
	 * @example
	 *<CloudinaryContext cloudName="mycloud" dpr="auto">
	 *    <!-- other tags -->
	 *    <Image publicId={id}/>
	 *</CloudinaryContext>
	 *
	 */
	var CloudinaryContext =
	/*#__PURE__*/
	function (_CloudinaryComponent) {
	  _inherits(CloudinaryContext, _CloudinaryComponent);
	
	  function CloudinaryContext(props, context) {
	    var _this;
	
	    _classCallCheck(this, CloudinaryContext);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(CloudinaryContext).call(this, props, context));
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CloudinaryContext, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      var _this2 = this;
	
	      var context = {}; // only pass valid Cloudinary options
	
	      _CloudinaryComponent2.default.VALID_OPTIONS.forEach(function (key) {
	        var val = _this2.props[key] || _this2.context[key];
	
	        if (val !== undefined && val !== null) {
	          context[key] = val;
	        }
	      });
	
	      return context;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      // Remove Cloudinary custom props that don't belong to div
	      var nonCloudinaryProps = Object.keys(this.props).filter(function (propName) {
	        return !CloudinaryContext.CLOUDINARY_PROPS[propName];
	      }).reduce(function (allowedProps, currentProp) {
	        allowedProps[currentProp] = _this3.props[currentProp];
	        return allowedProps;
	      }, {});
	      return _react.default.createElement("div", nonCloudinaryProps, this.props.children);
	    }
	  }]);
	
	  return CloudinaryContext;
	}(_CloudinaryComponent2.default); // Map Cloudinary props from array to object for efficient lookup
	
	
	CloudinaryContext.CLOUDINARY_PROPS = _CloudinaryComponent2.default.VALID_OPTIONS.reduce(function (accumulator, cloudinaryPropName) {
	  accumulator[cloudinaryPropName] = true;
	  return accumulator;
	}, {});
	CloudinaryContext.propTypes = _CloudinaryComponent2.default.propTypes;
	CloudinaryContext.defaultProps = {};
	CloudinaryContext.childContextTypes = _CloudinaryComponent2.default.contextTypes;
	var _default = CloudinaryContext;
	exports.default = _default;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _cloudinaryCore = _interopRequireWildcard(__webpack_require__(102));
	
	var _CloudinaryComponent2 = _interopRequireDefault(__webpack_require__(78));
	
	var _Util = __webpack_require__(419);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	/**
	 * A component representing a Cloudinary served image
	 */
	var Image =
	/*#__PURE__*/
	function (_CloudinaryComponent) {
	  _inherits(Image, _CloudinaryComponent);
	
	  function Image(props, context) {
	    var _this;
	
	    _classCallCheck(this, Image);
	
	    function defaultBreakpoints(width) {
	      var steps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
	      return steps * Math.ceil(width / steps);
	    }
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Image).call(this, props, context));
	    _this.handleResize = _this.handleResize.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    var state = {
	      responsive: false,
	      url: undefined,
	      breakpoints: defaultBreakpoints
	    };
	    _this.state = Object.assign(state, _this.prepareState(props, context));
	    return _this;
	  }
	  /**
	   * Retrieve the window or default view of the current element
	   * @returns {DocumentView|*}
	   * @private
	   */
	
	
	  _createClass(Image, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps, nextContext) {
	      var state = this.prepareState(nextProps, nextContext);
	      this.setState(state);
	    }
	    /**
	     * Generate update state of this element
	     * @param {Object} [props=this.props]
	     * @param {Object} [context=this.context]
	     * @returns {Object} state updates
	     * @private
	     */
	
	  }, {
	    key: "prepareState",
	    value: function prepareState() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.context;
	
	      var extendedProps = _CloudinaryComponent2.default.normalizeOptions(context, props);
	
	      var url = this.getUrl(extendedProps);
	      var state = {};
	
	      if (extendedProps.breakpoints !== undefined) {
	        state.breakpoints = extendedProps.breakpoints;
	      }
	
	      if (extendedProps.responsive) {
	        state.responsive = true;
	        url = this.cloudinary_update(url, state);
	      }
	
	      var currentState = this.state || {};
	
	      if (!_cloudinaryCore.Util.isEmpty(url) && url !== currentState.url) {
	        state.url = url;
	      }
	
	      return state;
	    }
	  }, {
	    key: "handleResize",
	    value: function handleResize(e) {
	      var _this2 = this;
	
	      if (this.rqf) return;
	      this.rqf = (0, _Util.requestAnimationFrame)(function () {
	        _this2.rqf = null;
	
	        var newState = _this2.prepareState();
	
	        if (!_cloudinaryCore.Util.isEmpty(newState.url)) {
	          _this2.setState(newState);
	        }
	      });
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // now that we have a this.element, we need to calculate the URL
	      this.handleResize();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.element = undefined;
	
	      if (this.listener) {
	        this.listener.cancel();
	        this.window && this.window.removeEventListener('resize', this.listener);
	      }
	
	      this.listener = undefined;
	    }
	  }, {
	    key: "componentWillUpdate",
	    value: function componentWillUpdate(nextProps, nextState, nextContext) {
	      if (nextState.responsive) {
	        var wait = (0, _Util.firstDefined)(nextProps.responsiveDebounce, nextContext.responsiveDebounce, 100);
	
	        if (this.listener) {
	          this.window && this.window.removeEventListener('resize', this.listener);
	        }
	
	        this.listener = (0, _Util.debounce)(this.handleResize, wait);
	        this.window && this.window.addEventListener('resize', this.listener);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _CloudinaryComponent$ = _CloudinaryComponent2.default.normalizeOptions(this.props, this.context),
	          publicId = _CloudinaryComponent$.publicId,
	          responsive = _CloudinaryComponent$.responsive,
	          responsiveDebounce = _CloudinaryComponent$.responsiveDebounce,
	          children = _CloudinaryComponent$.children,
	          options = _objectWithoutProperties(_CloudinaryComponent$, ["publicId", "responsive", "responsiveDebounce", "children"]);
	
	      var attributes = _cloudinaryCore.default.Transformation.new(options).toHtmlAttributes();
	
	      return _react.default.createElement("img", _extends({}, attributes, {
	        src: this.state.url,
	        ref: function ref(e) {
	          _this3.element = e;
	        }
	      }));
	    } // Methods from cloudinary_js
	
	  }, {
	    key: "findContainerWidth",
	    value: function findContainerWidth() {
	      var containerWidth, style;
	      containerWidth = 0;
	      var element = this.element;
	
	      while ((0, _Util.isElement)(element = element != null ? element.parentNode : void 0) && !containerWidth) {
	        style = this.window ? this.window.getComputedStyle(element) : '';
	
	        if (!/^inline/.test(style.display)) {
	          containerWidth = _cloudinaryCore.Util.width(element);
	        }
	      }
	
	      return containerWidth;
	    }
	  }, {
	    key: "applyBreakpoints",
	    value: function applyBreakpoints(width, steps, options) {
	      var responsive_use_breakpoints;
	      options = _CloudinaryComponent2.default.normalizeOptions(this.context, this.props, options);
	      responsive_use_breakpoints = options.responsive_use_breakpoints;
	
	      if (!responsive_use_breakpoints || responsive_use_breakpoints === 'resize' && !options.resizing) {
	        return width;
	      } else {
	        return this.calc_breakpoint(width, steps);
	      }
	    }
	  }, {
	    key: "calc_breakpoint",
	    value: function calc_breakpoint(width, steps) {
	      var breakpoints, point;
	      breakpoints = this.state.breakpoints || defaultBreakpoints;
	
	      if (_cloudinaryCore.Util.isFunction(breakpoints)) {
	        return breakpoints(width, steps);
	      } else {
	        if (_cloudinaryCore.Util.isString(breakpoints)) {
	          breakpoints = function () {
	            var j, len, ref, results;
	            ref = breakpoints.split(',');
	            results = [];
	
	            for (j = 0, len = ref.length; j < len; j++) {
	              point = ref[j];
	              results.push(parseInt(point));
	            }
	
	            return results;
	          }().sort(function (a, b) {
	            return a - b;
	          });
	        }
	
	        return (0, _Util.closestAbove)(breakpoints, width);
	      }
	    }
	  }, {
	    key: "device_pixel_ratio",
	    value: function device_pixel_ratio() {
	      var roundDpr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	      var dpr, dprString;
	      dpr = (typeof this.window !== "undefined" && this.window !== null ? this.window.devicePixelRatio : void 0) || 1;
	
	      if (roundDpr) {
	        dpr = Math.ceil(dpr);
	      }
	
	      if (dpr <= 0 || isNaN(dpr)) {
	        dpr = 1;
	      }
	
	      dprString = dpr.toString();
	
	      if (dprString.match(/^\d+$/)) {
	        dprString += '.0';
	      }
	
	      return dprString;
	    }
	  }, {
	    key: "updateDpr",
	    value: function updateDpr(dataSrc, roundDpr) {
	      return dataSrc.replace(/\bdpr_(1\.0|auto)\b/g, 'dpr_' + this.device_pixel_ratio(roundDpr));
	    }
	  }, {
	    key: "maxWidth",
	    value: function maxWidth(requiredWidth) {
	      var imageWidth;
	      imageWidth = this.state.width || 0;
	
	      if (requiredWidth > imageWidth) {
	        imageWidth = requiredWidth;
	        this.setState({
	          width: requiredWidth
	        });
	      }
	
	      return imageWidth;
	    }
	  }, {
	    key: "cloudinary_update",
	    value: function cloudinary_update(url) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var requiredWidth;
	      var match;
	      var resultUrl = this.updateDpr(url, options.roundDpr);
	
	      if (options.responsive || this.state && this.state.responsive) {
	        var containerWidth = this.findContainerWidth();
	
	        if (containerWidth !== 0) {
	          if (/w_auto:breakpoints/.test(resultUrl)) {
	            requiredWidth = this.maxWidth(containerWidth, this.element);
	            resultUrl = resultUrl.replace(/w_auto:breakpoints([_0-9]*)(:[0-9]+)?/, "w_auto:breakpoints$1:" + requiredWidth);
	          } else if (match = /w_auto(:(\d+))?/.exec(resultUrl)) {
	            requiredWidth = this.applyBreakpoints(containerWidth, match[2], options);
	            requiredWidth = this.maxWidth(requiredWidth, this.element);
	            resultUrl = resultUrl.replace(/w_auto[^,\/]*/g, "w_" + requiredWidth);
	          }
	        } else {
	          resultUrl = "";
	        }
	      }
	
	      return resultUrl;
	    }
	  }, {
	    key: "window",
	    get: function get() {
	      var windowRef = null;
	
	      if (typeof window !== "undefined") {
	        windowRef = window;
	      }
	
	      return this.element && this.element.ownerDocument ? this.element.ownerDocument.defaultView || windowRef : windowRef;
	    }
	  }]);
	
	  return Image;
	}(_CloudinaryComponent2.default);
	
	Image.defaultProps = {};
	Image.contextTypes = _CloudinaryComponent2.default.contextTypes;
	Image.propTypes = _CloudinaryComponent2.default.propTypes;
	var _default = Image;
	exports.default = _default;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _CloudinaryComponent2 = _interopRequireDefault(__webpack_require__(78));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	/**
	 * Define a transformation that is applied to the parent tag.
	 */
	var Transformation =
	/*#__PURE__*/
	function (_CloudinaryComponent) {
	  _inherits(Transformation, _CloudinaryComponent);
	
	  function Transformation(props) {
	    _classCallCheck(this, Transformation);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Transformation).call(this, props));
	  }
	
	  _createClass(Transformation, [{
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Transformation;
	}(_CloudinaryComponent2.default);
	
	Transformation.propTypes = _CloudinaryComponent2.default.propTypes;
	Transformation.defaultProps = {};
	Transformation.contextTypes = {};
	Transformation.exposesProps = true;
	var _default = Transformation;
	exports.default = _default;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _cloudinaryCore = __webpack_require__(102);
	
	var _CloudinaryComponent2 = _interopRequireDefault(__webpack_require__(78));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var DEFAULT_POSTER_OPTIONS = {
	  format: 'jpg',
	  resource_type: 'video'
	};
	/**
	 * A component representing a Cloudinary served video
	 */
	
	var Video =
	/*#__PURE__*/
	function (_CloudinaryComponent) {
	  _inherits(Video, _CloudinaryComponent);
	
	  function Video(props) {
	    var _this;
	
	    _classCallCheck(this, Video);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Video).call(this, props));
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Video, [{
	    key: "render",
	    value: function render() {
	      var _Object$assign = Object.assign({}, this.context, this.props),
	          publicId = _Object$assign.publicId,
	          poster = _Object$assign.poster,
	          sourceTypes = _Object$assign.sourceTypes,
	          fallback = _Object$assign.fallback,
	          sourceTransformations = _Object$assign.sourceTransformation,
	          options = _objectWithoutProperties(_Object$assign, ["publicId", "poster", "sourceTypes", "fallback", "sourceTransformation"]);
	
	      sourceTransformations = sourceTransformations || {};
	      sourceTypes = sourceTypes || _cloudinaryCore.Cloudinary.DEFAULT_VIDEO_PARAMS.source_types;
	      options = _CloudinaryComponent2.default.normalizeOptions(options, {});
	
	      var cld = _cloudinaryCore.Cloudinary.new(_cloudinaryCore.Util.withSnakeCaseKeys(options));
	
	      var sources = [];
	
	      var tagAttributes = _cloudinaryCore.Transformation.new(options).toHtmlAttributes();
	
	      var childTransformations = this.getTransformation(options);
	
	      if (_cloudinaryCore.Util.isPlainObject(poster)) {
	        var defaults = poster.publicId !== undefined && poster.publicId !== null ? _cloudinaryCore.Cloudinary.DEFAULT_IMAGE_PARAMS : DEFAULT_POSTER_OPTIONS;
	        poster = cld.url(poster.publicId || publicId, _cloudinaryCore.Util.defaults({}, _cloudinaryCore.Util.withSnakeCaseKeys(poster), defaults));
	      }
	
	      if (!_cloudinaryCore.Util.isEmpty(poster)) {
	        tagAttributes.poster = poster;
	      }
	
	      if (!_cloudinaryCore.Util.isEmpty(this.state.poster)) {
	        tagAttributes.poster = this.state.poster;
	      }
	
	      if (_cloudinaryCore.Util.isArray(sourceTypes)) {
	        sources = sourceTypes.map(function (srcType) {
	          var sourceTransformation = sourceTransformations[srcType] || {};
	          var src = cld.url(publicId, _cloudinaryCore.Util.defaults({}, sourceTransformation, childTransformations, {
	            resource_type: 'video',
	            format: srcType
	          }));
	          var mimeType = 'video/' + (srcType === 'ogv' ? 'ogg' : srcType);
	          return _react.default.createElement("source", {
	            key: mimeType,
	            src: src,
	            type: mimeType
	          });
	        });
	      } else {
	        var sourceTransformation = sourceTransformations[sourceTypes] || {};
	        tagAttributes.src = cld.url(publicId, _cloudinaryCore.Util.defaults({}, sourceTransformation, childTransformations, {
	          resource_type: 'video',
	          format: sourceTypes
	        }));
	      }
	
	      return _react.default.createElement("video", tagAttributes, sources, fallback, this.props.children);
	    }
	  }]);
	
	  return Video;
	}(_CloudinaryComponent2.default);
	
	Video.propTypes = {
	  publicId: _propTypes.default.string
	};
	Video.defaultProps = {};
	Video.contextTypes = _CloudinaryComponent2.default.contextTypes;
	var _default = Video;
	exports.default = _default;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "CloudinaryContext", {
	  enumerable: true,
	  get: function get() {
	    return _CloudinaryContext.default;
	  }
	});
	Object.defineProperty(exports, "Image", {
	  enumerable: true,
	  get: function get() {
	    return _Image.default;
	  }
	});
	Object.defineProperty(exports, "Transformation", {
	  enumerable: true,
	  get: function get() {
	    return _Transformation.default;
	  }
	});
	Object.defineProperty(exports, "Video", {
	  enumerable: true,
	  get: function get() {
	    return _Video.default;
	  }
	});
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _CloudinaryContext = _interopRequireDefault(__webpack_require__(425));
	
	var _Image = _interopRequireDefault(__webpack_require__(426));
	
	var _Transformation = _interopRequireDefault(__webpack_require__(427));
	
	var _Video = _interopRequireDefault(__webpack_require__(428));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(e,t){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [module], __WEBPACK_AMD_DEFINE_FACTORY__ = (t), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if("undefined"!=typeof exports)t(module);else{var i={exports:{}};t(i),e.GLightbox=i.exports}}(this,function(e){"use strict";function t(){var e={},i=!1,n=0,s=arguments.length;"[object Boolean]"===Object.prototype.toString.call(arguments[0])&&(i=arguments[0],n++);for(var o=function(n){for(var s in n)Object.prototype.hasOwnProperty.call(n,s)&&(i&&"[object Object]"===Object.prototype.toString.call(n[s])?e[s]=t(!0,e[s],n[s]):e[s]=n[s])};n<s;n++){o(arguments[n])}return e}function i(e,t){if((I.isNode(e)||e===window||e===document)&&(e=[e]),I.isArrayLike(e)||I.isObject(e)||(e=[e]),0!=I.size(e))if(I.isArrayLike(e)&&!I.isObject(e))for(var i=e.length,n=0;n<i&&!1!==t.call(e[n],e[n],n,e);n++);else if(I.isObject(e))for(var s in e)if(I.has(e,s)&&!1===t.call(e[s],e[s],s,e))break}function n(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,s=e[N]=e[N]||[],o={all:s,evt:null,found:null};return t&&n&&I.size(s)>0&&i(s,function(e,i){if(e.eventName==t&&e.fn.toString()==n.toString())return o.found=!0,o.evt=i,!1}),o}function s(e){function t(e){I.isFunction(l)&&l.call(v,e,this),d&&t.destroy()}var s=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},o=s.onElement,l=s.withCallback,r=s.avoidDuplicate,a=void 0===r||r,c=s.once,d=void 0!==c&&c,u=s.useCapture,h=void 0!==u&&u,v=arguments[2],f=o||[];return I.isString(f)&&(f=document.querySelectorAll(f)),t.destroy=function(){i(f,function(i){var s=n(i,e,t);s.found&&s.all.splice(s.evt,1),i.removeEventListener&&i.removeEventListener(e,t,h)})},i(f,function(i){var s=n(i,e,t);(i.addEventListener&&a&&!s.found||!a)&&(i.addEventListener(e,t,h),s.all.push({eventName:e,fn:t}))}),t}function o(e,t){r(e,t)||(e.classList?e.classList.add(t):e.className+=" "+t)}function l(e,t){var n=t.split(" ");n.length>1?i(n,function(t){l(e,t)}):e.classList?e.classList.remove(t):e.className=e.className.replace(t,"")}function r(e,t){return e.classList?e.classList.contains(t):new RegExp("(^| )"+t+"( |$)","gi").test(e.className)}function a(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if(!e||""===t)return!1;if("none"==t)return I.isFunction(n)&&n(),!1;var r=t.split(" ");i(r,function(t){o(e,"g"+t)}),s(O,{onElement:e,avoidDuplicate:!1,once:!0,withCallback:function(e,t){i(r,function(e){l(t,"g"+e)}),I.isFunction(n)&&n()}})}function c(e){var t=document.createDocumentFragment(),i=document.createElement("div");for(i.innerHTML=e;i.firstChild;)t.appendChild(i.firstChild);return t}function d(e,t){for(;e!==document.body;){if("function"==typeof(e=e.parentElement).matches?e.matches(t):e.msMatchesSelector(t))return e}}function u(e){e.style.display="block"}function h(e){e.style.display="none"}function v(e,i,n){var s=this,l=i.source,r="gvideo"+i.index,a=e.querySelector(".gslide-media"),d=i.href,u=location.protocol.replace(":","");if("file"==u&&(u="http"),"vimeo"==l){var h=/vimeo.*\/(\d+)/i.exec(d),v=y(this.settings.vimeo.params),p=u+"://player.vimeo.com/video/"+h[1]+"?"+v;g(this.settings.vimeo.api);var m=f(p,i.width,i.height,function(){!function(e,t,i,n){if(e())t();else{i||(i=100);var s,o=setInterval(function(){e()&&(clearInterval(o),s&&clearTimeout(s),t())},i);n&&(s=setTimeout(function(){clearInterval(o)},n))}}(function(){return"undefined"!=typeof Vimeo},function(){var e=new Vimeo.Player(m);L[r]=e,I.isFunction(n)&&n()})},a);m.id=r,m.className="vimeo-video gvideo",this.settings.autoplayVideos&&!k&&(m.className+=" wait-autoplay")}if("youtube"==l){var b=y(t(this.settings.youtube.params,{playerapiid:r})),w=u+"://www.youtube.com/embed/"+function(e){var t="";t=void 0!==(e=e.replace(/(>|<)/gi,"").split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/))[2]?(t=e[2].split(/[^0-9a-z_\-]/i))[0]:e;return t}(d)+"?"+b;g(this.settings.youtube.api);var S=f(w,i.width,i.height,function(){if(!I.isNil(YT)&&YT.loaded){var e=new YT.Player(S);L[r]=e}else q.push(S);I.isFunction(n)&&n()},a);S.id=r,S.className="youtube-video gvideo",this.settings.autoplayVideos&&!k&&(S.className+=" wait-autoplay")}if("local"==l){var x='<video id="'+r+'" ';x+='style="background:#000; width: '+i.width+"px; height: "+i.height+'px;" ',x+='preload="metadata" ',x+='x-webkit-airplay="allow" ',x+='webkit-playsinline="" ',x+="controls ",x+='class="gvideo">';var E={mp4:"",ogg:"",webm:""};E[d.toLowerCase().split(".").pop()]=d;for(var C in E)if(E.hasOwnProperty(C)){var A=E[C];i.hasOwnProperty(C)&&(A=i[C]),""!==A&&(x+='<source src="'+A+'" type="video/'+C+'">')}var T=c(x+="</video>");a.appendChild(T);var O=document.getElementById(r);if(null!==this.settings.jwplayer&&null!==this.settings.jwplayer.api){this.settings.jwplayer;var N=this.settings.jwplayer.api;if(!N)return console.warn("Missing jwplayer api file"),I.isFunction(n)&&n(),!1;g(N,function(){var e=t(s.settings.jwplayer.params,{width:i.width+"px",height:i.height+"px",file:d});jwplayer.key=s.settings.jwplayer.licenseKey;var l=jwplayer(r);l.setup(e),L[r]=l,l.on("ready",function(){o(O=a.querySelector(".jw-video"),"gvideo"),O.id=r,I.isFunction(n)&&n()})})}else o(O,"html5-video"),L[r]=O,I.isFunction(n)&&n()}}function f(e,t,i,n,s){var l=document.createElement("iframe"),r=window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;return l.className="vimeo-video gvideo",l.src=e,l.style.height=k&&r<767?"":i+"px",l.style.width=t+"px",l.setAttribute("allowFullScreen",""),l.onload=function(){o(l,"iframe-ready"),I.isFunction(n)&&n()},s&&s.appendChild(l),l}function g(e,t){if(I.isNil(e))console.error("Inject videos api error");else{var i=document.querySelectorAll('script[src="'+e+'"]');if(I.isNil(i)||0==i.length){var n=document.createElement("script");return n.type="text/javascript",n.src=e,n.onload=function(){I.isFunction(t)&&t()},document.body.appendChild(n),!1}I.isFunction(t)&&t()}}function p(){for(var e=0;e<q.length;e++){var t=q[e],i=new YT.Player(t);L[t.id]=i}}function y(e){var t="",n=0;return i(e,function(e,i){n>0&&(t+="&amp;"),t+=i+"="+e,n+=1}),t}function m(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"";if(""==t)return e.style.webkitTransform="",e.style.MozTransform="",e.style.msTransform="",e.style.OTransform="",e.style.transform="",!1;e.style.webkitTransform=t,e.style.MozTransform=t,e.style.msTransform=t,e.style.OTransform=t,e.style.transform=t}function b(e){var t=e.querySelector(".gslide-media"),i=e.querySelector(".gslide-description");o(t,"greset"),m(t,"translate3d(0, 0, 0)");s(T,{onElement:t,once:!0,withCallback:function(e,i){l(t,"greset")}});t.style.opacity="",i&&(i.style.opacity="")}function w(e,t){var i=e.querySelector(".desc-more");if(!i)return!1;s("click",{onElement:i,withCallback:function(e,i){e.preventDefault();var n=d(i,".gslide-desc");if(!n)return!1;n.innerHTML=t.description,o(A,"gdesc-open");var r=s("click",{onElement:[A,d(n,".gslide-description")],withCallback:function(e,i){"a"!==e.target.nodeName.toLowerCase()&&(l(A,"gdesc-open"),o(A,"gdesc-closed"),n.innerHTML=t.smallDescription,w(n,t),setTimeout(function(){l(A,"gdesc-closed")},400),r.destroy())}})}})}var S=function(){function e(e,t){for(var i=0;i<t.length;i++){var n=t[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,i,n){return i&&e(t.prototype,i),n&&e(t,n),t}}(),x="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},k=navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(Android)|(PlayBook)|(BB10)|(BlackBerry)|(Opera Mini)|(IEMobile)|(webOS)|(MeeGo)/i),E=null!==k||void 0!==document.createTouch||"ontouchstart"in window||"onmsgesturechange"in window||navigator.msMaxTouchPoints,C=document.getElementsByTagName("html")[0],A=document.body,T=function(){var e=void 0,t=document.createElement("fakeelement"),i={transition:"transitionend",OTransition:"oTransitionEnd",MozTransition:"transitionend",WebkitTransition:"webkitTransitionEnd"};for(e in i)if(void 0!==t.style[e])return i[e]}(),O=function(){var e=void 0,t=document.createElement("fakeelement"),i={animation:"animationend",OAnimation:"oAnimationEnd",MozAnimation:"animationend",WebkitAnimation:"webkitAnimationEnd"};for(e in i)if(void 0!==t.style[e])return i[e]}(),N=Date.now(),q=[],L={},j={selector:"glightbox",skin:"clean",closeButton:!0,startAt:0,autoplayVideos:!0,descPosition:"bottom",width:900,height:506,videosWidth:960,videosHeight:540,beforeSlideChange:null,afterSlideChange:null,beforeSlideLoad:null,afterSlideLoad:null,onOpen:null,onClose:null,loopAtEnd:!1,touchNavigation:!0,keyboardNavigation:!0,closeOnOutsideClick:!0,jwplayer:{api:null,licenseKey:null,params:{width:"100%",aspectratio:"16:9",stretching:"uniform"}},vimeo:{api:"https://player.vimeo.com/api/player.js",params:{api:1,title:0,byline:0,portrait:0}},youtube:{api:"https://www.youtube.com/iframe_api",params:{enablejsapi:1,showinfo:0}},openEffect:"zoomIn",closeEffect:"zoomOut",slideEffect:"slide",moreText:"See more",moreLength:60,slideHtml:"",lightboxHtml:"",cssEfects:{fade:{in:"fadeIn",out:"fadeOut"},zoom:{in:"zoomIn",out:"zoomOut"},slide:{in:"slideInRight",out:"slideOutLeft"},slide_back:{in:"slideInLeft",out:"slideOutRight"}}};j.slideHtml='<div class="gslide">         <div class="gslide-inner-content">            <div class="ginner-container">               <div class="gslide-media">               </div>               <div class="gslide-description">                  <h4 class="gslide-title"></h4>                  <div class="gslide-desc"></div>               </div>            </div>         </div>       </div>';j.lightboxHtml='<div id="glightbox-body" class="glightbox-container">            <div class="gloader visible"></div>            <div class="goverlay"></div>            <div class="gcontainer">               <div id="glightbox-slider" class="gslider"></div>               <a class="gnext"></a>               <a class="gprev"></a>               <a class="gclose"></a>            </div>   </div>';var I={isFunction:function(e){return"function"==typeof e},isString:function(e){return"string"==typeof e},isNode:function(e){return!(!e||!e.nodeType||1!=e.nodeType)},isArray:function(e){return Array.isArray(e)},isArrayLike:function(e){return e&&e.length&&isFinite(e.length)},isObject:function(e){return"object"===(void 0===e?"undefined":x(e))&&null!=e&&!I.isFunction(e)&&!I.isArray(e)},isNil:function(e){return null==e},has:function(e,t){return null!==e&&hasOwnProperty.call(e,t)},size:function(e){if(I.isObject(e)){if(e.keys)return e.keys().length;var t=0;for(var i in e)I.has(e,i)&&t++;return t}return e.length},isNumber:function(e){return!isNaN(parseFloat(e))&&isFinite(e)}},F=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,n=arguments[1],s={href:"",title:"",description:"",descPosition:"bottom",effect:"",node:e};if(I.isObject(e)&&!I.isNode(e))return t(s,e);var o="",l=e.getAttribute("data-glightbox"),r=e.nodeName.toLowerCase();"a"===r&&(o=e.href),"img"===r&&(o=e.src),s.href=o,i(s,function(t,i){I.has(n,i)&&(s[i]=n[i]);var o=e.dataset[i];I.isNil(o)||(s[i]=o)});var a=P(o);if(s=t(s,a),I.isNil(l)){if("a"==r){var c=e.title;I.isNil(c)||""===c||(s.title=c)}if("img"==r){var d=e.alt;I.isNil(d)||""===d||(s.title=d)}var u=e.getAttribute("data-description");I.isNil(u)||""===u||(s.description=u)}else{var h=[];i(s,function(e,t){h.push(";\\s?"+t)}),h=h.join("\\s?:|"),""!==l.trim()&&i(s,function(e,t){var i=l,n="s?"+t+"s?:s?(.*?)("+h+"s?:|$)",o=new RegExp(n),r=i.match(o);if(r&&r.length&&r[1]){var a=r[1].trim().replace(/;\s*$/,"");s[t]=a}})}var v=e.querySelector(".glightbox-desc");v&&(s.description=v.innerHTML),s.sourcetype=s.hasOwnProperty("type")?s.type:s.sourcetype,s.type=s.sourcetype;var f="video"==s.sourcetype?n.videosWidth:n.width,g="video"==s.sourcetype?n.videosHeight:n.height;return s.width=I.has(s,"width")?s.width:f,s.height=I.has(s,"height")?s.height:g,s},B=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=this,i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if(r(e,"loaded"))return!1;I.isFunction(this.settings.beforeSlideLoad)&&this.settings.beforeSlideLoad(e,i);var s=i.type,l=i.descPosition,a=e.querySelector(".gslide-media"),c=e.querySelector(".gslide-title"),d=e.querySelector(".gslide-desc"),u=e.querySelector(".gslide-description"),h=n;if(I.isFunction(this.settings.afterSlideLoad)&&(h=function(){I.isFunction(n)&&n(),t.settings.afterSlideLoad(e,i)}),""==i.title&&""==i.description?u&&u.parentNode.removeChild(u):(c&&""!==i.title?c.innerHTML=i.title:c.parentNode.removeChild(c),d&&""!==i.description?k&&this.settings.moreLength>0?(i.smallDescription=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:50,i=arguments.length>2&&void 0!==arguments[2]&&arguments[2],n=i;if((e=e.trim()).length<=t)return e;var s=e.substr(0,t-1);return n?s+'... <a href="#" class="desc-more">'+i+"</a>":s}(i.description,this.settings.moreLength,this.settings.moreText),d.innerHTML=i.smallDescription,w.apply(this,[d,i])):d.innerHTML=i.description:d.parentNode.removeChild(d),o(a.parentNode,"desc-"+l),o(u,"description-"+l)),o(a,"gslide-"+s),o(e,"loaded"),"video"!==s)if("external"!==s)if("inline"!==s){if("image"===s){var g=new Image;return g.addEventListener("load",function(){I.isFunction(h)&&h()},!1),g.src=i.href,void a.appendChild(g)}I.isFunction(h)&&h()}else(function(e,t,i){var n=e.querySelector(".gslide-media"),s=document.getElementById(t.inlined.replace("#",""));if(s){var l=s.cloneNode(!0);return l.style.height=t.height+"px",l.style.maxWidth=t.width+"px",o(l,"ginlined-content"),n.appendChild(l),void(I.isFunction(i)&&i())}}).apply(this,[e,i,h]);else{var p=f(i.href,i.width,i.height,h);a.appendChild(p)}else v.apply(this,[e,i,h])};void 0!==window.onYouTubeIframeAPIReady?window.onYouTubeIframeAPIReady=function(){window.onYouTubeIframeAPIReady(),p()}:window.onYouTubeIframeAPIReady=p;var P=function(e){var t=e,i={};if(null!==(e=e.toLowerCase()).match(/\.(jpeg|jpg|gif|png|apn|webp|svg)$/))return i.sourcetype="image",i;if(e.match(/(youtube\.com|youtube-nocookie\.com)\/watch\?v=([a-zA-Z0-9\-_]+)/)||e.match(/youtu\.be\/([a-zA-Z0-9\-_]+)/))return i.sourcetype="video",i.source="youtube",i;if(e.match(/vimeo\.com\/([0-9]*)/))return i.sourcetype="video",i.source="vimeo",i;if(null!==e.match(/\.(mp4|ogg|webm)$/))return i.sourcetype="video",i.source="local",i;if(e.indexOf("#")>-1){var n=t.split("#").pop();if(""!==n.trim())return i.sourcetype="inline",i.source=e,i.inlined="#"+n,i}return e.includes("gajax=true")&&(i.sourcetype="ajax",i.source=e),i.sourcetype="external",i.source=e,i},M=function(){function e(i){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.settings=t(j,i||{}),this.effectsClasses=this.getAnimationClasses()}return S(e,[{key:"init",value:function(){var e=this;this.baseEvents=s("click",{onElement:"."+this.settings.selector,withCallback:function(t,i){t.preventDefault(),e.open(i)}})}},{key:"open",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;if(this.elements=this.getElements(e),0==this.elements.length)return!1;this.activeSlide=null,this.prevActiveSlideIndex=null,this.prevActiveSlide=null;var t=this.settings.startAt;e&&(t=this.elements.indexOf(e))<0&&(t=0),this.build(),a(this.overlay,"none"==this.settings.openEffect?"none":this.settings.cssEfects.fade.in);var i=A.offsetWidth;if(A.style.width=i+"px",o(A,"glightbox-open"),o(C,"glightbox-open"),k&&(o(C,"glightbox-mobile"),this.settings.slideEffect="slide"),this.showSlide(t,!0),1==this.elements.length?(h(this.prevButton),h(this.nextButton)):(u(this.prevButton),u(this.nextButton)),this.lightboxOpen=!0,I.isFunction(this.settings.onOpen)&&this.settings.onOpen(),k&&E&&this.settings.touchNavigation)return function(){var e=this;if(this.events.hasOwnProperty("touchStart"))return!1;var t=void 0,i=void 0,n=void 0,a=void 0,c=void 0,d=void 0,u=!1,h=!1,v=!1,f=!1,g={},p={},y=(this.slidesContainer,null),w=0,S=0,x=null,k=null,E=null,C=window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight,this.events.doctouchmove=s("touchmove",{onElement:document,withCallback:function(e,t){if(r(A,"gdesc-open"))return e.preventDefault(),!1}}),this.events.touchStart=s("touchstart",{onElement:A,withCallback:function(i,n){r(A,"gdesc-open")||(o(A,"touching"),y=e.getActiveSlide(),x=y.querySelector(".gslide-image"),k=y.querySelector(".gslide-media"),E=y.querySelector(".gslide-description"),t=e.index,p=i.targetTouches[0],g.pageX=i.targetTouches[0].pageX,g.pageY=i.targetTouches[0].pageY,w=i.targetTouches[0].clientX,S=i.targetTouches[0].clientY)}}),this.events.gestureStart=s("gesturestart",{onElement:A,withCallback:function(e,t){x&&(e.preventDefault(),v=!0)}}),this.events.gestureChange=s("gesturechange",{onElement:A,withCallback:function(e,t){e.preventDefault(),m(x,"scale("+e.scale+")")}}),this.events.gesturEend=s("gestureend",{onElement:A,withCallback:function(e,t){v=!1,e.scale<1?(f=!1,m(x,"scale(1)")):f=!0}}),this.events.touchMove=s("touchmove",{onElement:A,withCallback:function(t,s){if(r(A,"touching")&&!(r(A,"gdesc-open")||v||f)){t.preventDefault(),p=t.targetTouches[0];var o=y.querySelector(".gslide-inner-content").offsetHeight,l=y.querySelector(".gslide-inner-content").offsetWidth,x=t.targetTouches[0].clientX,T=t.targetTouches[0].clientY,O=w-x,N=S-T;if(Math.abs(O)>Math.abs(N)?(u=!1,h=!0):(h=!1,u=!0),u){if(c=n,n=p.pageY-g.pageY,Math.abs(n)>=0||u){var q=.75-Math.abs(n)/o;k.style.opacity=q,E&&(E.style.opacity=q),m(k,"translate3d(0, "+n+"px, 0)")}}else if(a=i,i=p.pageX-g.pageX,d=100*i/C,h){if(e.index+1==e.elements.length&&i<-60)return b(y),!1;if(e.index-1<0&&i>60)return b(y),!1;var L=.75-Math.abs(i)/l;k.style.opacity=L,E&&(E.style.opacity=L),m(k,"translate3d("+d+"%, 0, 0)")}}}}),this.events.touchEnd=s("touchend",{onElement:A,withCallback:function(t,s){n=p.pageY-g.pageY,i=p.pageX-g.pageX,d=100*i/C,l(A,"touching");var o=y.querySelector(".gslide-inner-content").offsetHeight,r=y.querySelector(".gslide-inner-content").offsetWidth;if(u){var a=o/2;return u=!1,Math.abs(n)>=a?void e.close():void b(y)}if(h){h=!1;var c="prev",v=!0;if(i<0&&(c="next",i=Math.abs(i)),"prev"==c&&e.index-1<0&&(v=!1),"next"==c&&e.index+1>=e.elements.length&&(v=!1),v&&i>=r/2-90)return void("next"==c?e.nextSlide():e.prevSlide());b(y)}}})}.apply(this),!1;this.settings.keyboardNavigation&&function(){var e=this;if(this.events.hasOwnProperty("keyboard"))return!1;this.events.keyboard=s("keydown",{onElement:window,withCallback:function(t,i){var n=(t=t||window.event).keyCode;39==n&&e.nextSlide(),37==n&&e.prevSlide(),27==n&&e.close()}})}.apply(this)}},{key:"showSlide",value:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,i=arguments.length>1&&void 0!==arguments[1]&&arguments[1];u(this.loader),this.index=t;var n=this.slidesContainer.querySelector(".current");n&&l(n,"current"),this.slideAnimateOut();var s=this.slidesContainer.querySelectorAll(".gslide")[t];if(u(this.slidesContainer),r(s,"loaded"))this.slideAnimateIn(s,i),h(this.loader);else{u(this.loader);var a=F(this.elements[t],this.settings);a.index=t,B.apply(this,[s,a,function(){h(e.loader),e.slideAnimateIn(s,i)}])}this.preloadSlide(t+1),this.preloadSlide(t-1),l(this.nextButton,"disabled"),l(this.prevButton,"disabled"),0===t?o(this.prevButton,"disabled"):t===this.elements.length-1&&!0!==this.settings.loopAtEnd&&o(this.nextButton,"disabled"),this.activeSlide=s}},{key:"preloadSlide",value:function(e){var t=this;if(e<0||e>this.elements.length)return!1;if(I.isNil(this.elements[e]))return!1;var i=this.slidesContainer.querySelectorAll(".gslide")[e];if(r(i,"loaded"))return!1;var n=F(this.elements[e],this.settings);n.index=e;var s=n.sourcetype;"video"==s||"external"==s?setTimeout(function(){B.apply(t,[i,n])},200):B.apply(this,[i,n])}},{key:"prevSlide",value:function(){var e=this.index-1;if(e<0)return!1;this.goToSlide(e)}},{key:"nextSlide",value:function(){var e=this.index+1;if(e>this.elements.length)return!1;this.goToSlide(e)}},{key:"goToSlide",value:function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];e>-1&&(this.prevActiveSlide=this.activeSlide,this.prevActiveSlideIndex=this.index,e<this.elements.length?this.showSlide(e):!0===this.settings.loopAtEnd&&(e=0,this.showSlide(e)))}},{key:"slideAnimateIn",value:function(e,t){var i=this,n=e.querySelector(".gslide-media"),s=e.querySelector(".gslide-description"),r={index:this.prevActiveSlideIndex,slide:this.prevActiveSlide},c={index:this.index,slide:this.activeSlide};if(n.offsetWidth>0&&s&&(h(s),e.querySelector(".ginner-container").style.maxWidth=n.offsetWidth+"px",s.style.display=""),l(e,this.effectsClasses),t)a(e,this.settings.openEffect,function(){!k&&i.settings.autoplayVideos&&i.playSlideVideo(e),I.isFunction(i.settings.afterSlideChange)&&i.settings.afterSlideChange.apply(i,[r,c])});else{var d=this.settings.slideEffect,u="none"!==d?this.settings.cssEfects[d].in:d;this.prevActiveSlideIndex>this.index&&"slide"==this.settings.slideEffect&&(u=this.settings.cssEfects.slide_back.in),a(e,u,function(){!k&&i.settings.autoplayVideos&&i.playSlideVideo(e),I.isFunction(i.settings.afterSlideChange)&&i.settings.afterSlideChange.apply(i,[r,c])})}o(e,"current")}},{key:"slideAnimateOut",value:function(){if(!this.prevActiveSlide)return!1;var e=this.prevActiveSlide;l(e,this.effectsClasses),o(e,"prev");var t=this.settings.slideEffect,i="none"!==t?this.settings.cssEfects[t].out:t;this.stopSlideVideo(e),I.isFunction(this.settings.beforeSlideChange)&&this.settings.beforeSlideChange.apply(this,[{index:this.prevActiveSlideIndex,slide:this.prevActiveSlide},{index:this.index,slide:this.activeSlide}]),this.prevActiveSlideIndex>this.index&&"slide"==this.settings.slideEffect&&(i=this.settings.cssEfects.slide_back.out),a(e,i,function(){var t=e.querySelector(".gslide-media"),i=e.querySelector(".gslide-description");t.style.transform="",l(t,"greset"),t.style.opacity="",i&&(i.style.opacity=""),l(e,"prev")})}},{key:"stopSlideVideo",value:function(e){I.isNumber(e)&&(e=this.slidesContainer.querySelectorAll(".gslide")[e]);var t=e?e.querySelector(".gvideo"):null;if(!t)return!1;var i=t.id;if(L&&L.hasOwnProperty(i)){var n=L[i];r(t,"vimeo-video")&&n.pause(),r(t,"youtube-video")&&n.pauseVideo(),r(t,"jw-video")&&n.pause(!0),r(t,"html5-video")&&n.pause()}}},{key:"playSlideVideo",value:function(e){I.isNumber(e)&&(e=this.slidesContainer.querySelectorAll(".gslide")[e]);var t=e.querySelector(".gvideo");if(!t)return!1;var i=t.id;if(L&&L.hasOwnProperty(i)){var n=L[i];return r(t,"vimeo-video")&&n.play(),r(t,"youtube-video")&&n.playVideo(),r(t,"jw-video")&&n.play(),r(t,"html5-video")&&n.play(),setTimeout(function(){l(t,"wait-autoplay")},300),!1}}},{key:"setElements",value:function(e){this.settings.elements=e}},{key:"getElements",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;if(this.elements=[],!I.isNil(this.settings.elements)&&I.isArray(this.settings.elements))return this.settings.elements;var t=!1;if(null!==e){var i=e.getAttribute("data-gallery");i&&""!==i&&(t=document.querySelectorAll('[data-gallery="'+i+'"]'))}return 0==t&&(t=document.querySelectorAll("."+this.settings.selector)),t=Array.prototype.slice.call(t)}},{key:"getActiveSlide",value:function(){return this.slidesContainer.querySelectorAll(".gslide")[this.index]}},{key:"getActiveSlideIndex",value:function(){return this.index}},{key:"getAnimationClasses",value:function(){var e=[];for(var t in this.settings.cssEfects)if(this.settings.cssEfects.hasOwnProperty(t)){var i=this.settings.cssEfects[t];e.push("g"+i.in),e.push("g"+i.out)}return e.join(" ")}},{key:"build",value:function(){var e=this;if(this.built)return!1;var t=c(this.settings.lightboxHtml);document.body.appendChild(t);var n=document.getElementById("glightbox-body");this.modal=n;var l=n.querySelector(".gclose");this.prevButton=n.querySelector(".gprev"),this.nextButton=n.querySelector(".gnext"),this.overlay=n.querySelector(".goverlay"),this.loader=n.querySelector(".gloader"),this.slidesContainer=document.getElementById("glightbox-slider"),this.events={},o(this.modal,"glightbox-"+this.settings.skin),this.settings.closeButton&&l&&(this.events.close=s("click",{onElement:l,withCallback:function(t,i){t.preventDefault(),e.close()}})),l&&!this.settings.closeButton&&l.parentNode.removeChild(l),this.nextButton&&(this.events.next=s("click",{onElement:this.nextButton,withCallback:function(t,i){t.preventDefault(),e.nextSlide()}})),this.prevButton&&(this.events.prev=s("click",{onElement:this.prevButton,withCallback:function(t,i){t.preventDefault(),e.prevSlide()}})),this.settings.closeOnOutsideClick&&(this.events.outClose=s("click",{onElement:n,withCallback:function(t,i){d(t.target,".ginner-container")||r(t.target,"gnext")||r(t.target,"gprev")||e.close()}})),i(this.elements,function(){var t=c(e.settings.slideHtml);e.slidesContainer.appendChild(t)}),E&&o(C,"glightbox-touch"),this.built=!0}},{key:"reload",value:function(){this.init()}},{key:"close",value:function(){var e=this;if(this.closing)return!1;this.closing=!0,this.stopSlideVideo(this.activeSlide),o(this.modal,"glightbox-closing"),a(this.overlay,"none"==this.settings.openEffect?"none":this.settings.cssEfects.fade.out),a(this.activeSlide,this.settings.closeEffect,function(){if(e.activeSlide=null,e.prevActiveSlideIndex=null,e.prevActiveSlide=null,e.built=!1,e.events)for(var t in e.events)e.events.hasOwnProperty(t)&&e.events[t].destroy();l(A,"glightbox-open"),l(C,"glightbox-open"),l(A,"touching"),l(A,"gdesc-open"),A.style.width="",e.modal.parentNode.removeChild(e.modal),I.isFunction(e.settings.onClose)&&e.settings.onClose(),e.closing=null})}},{key:"destroy",value:function(){this.close(),this.baseEvents.destroy()}}]),e}();e.exports=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=new M(e);return t.init(),t}});

/***/ }),
/* 540 */
/***/ (function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 541 */
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ }),
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Jump.js 1.0.1 - A small, modern, dependency-free smooth scrolling library.
	 * Copyright (c) 2016 Michael Cavalea - https://github.com/callmecavs/jump.js
	 * License: MIT
	 */
	
	!function(o,n){ true?module.exports=n():"function"==typeof define&&define.amd?define(n):o.Jump=n()}(this,function(){"use strict";var o=function(o,n,e,t){return o/=t/2,o<1?e/2*o*o+n:(o--,-e/2*(o*(o-2)-1)+n)},n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(o){return typeof o}:function(o){return o&&"function"==typeof Symbol&&o.constructor===Symbol?"symbol":typeof o},e=function(){function e(){return window.scrollY||window.pageYOffset}function t(o){return o.getBoundingClientRect().top+d}function i(o){v||(v=o),b=o-v,p=s(b,d,y,m),window.scrollTo(0,p),b<m?requestAnimationFrame(i):r()}function r(){window.scrollTo(0,d+y),c&&l&&(c.setAttribute("tabindex","-1"),c.focus()),"function"==typeof w&&w(),v=!1}function u(r){var u=arguments.length<=1||void 0===arguments[1]?{}:arguments[1];switch(m=u.duration||1e3,a=u.offset||0,w=u.callback,s=u.easing||o,l=u.a11y||!1,d=e(),"undefined"==typeof r?"undefined":n(r)){case"number":c=void 0,l=!1,f=d+r;break;case"object":c=r,f=t(c);break;case"string":c=document.querySelector(r),f=t(c)}switch(y=f-d+a,n(u.duration)){case"number":m=u.duration;break;case"function":m=u.duration(y)}requestAnimationFrame(i)}var c=void 0,d=void 0,f=void 0,a=void 0,s=void 0,l=void 0,y=void 0,m=void 0,v=void 0,b=void 0,p=void 0,w=void 0;return u},t=e();return t});

/***/ }),
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(144);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Manager = __webpack_require__(257);
	
	var _Manager2 = _interopRequireDefault(_Manager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollableAnchor = function (_Component) {
	  _inherits(ScrollableAnchor, _Component);
	
	  function ScrollableAnchor(props) {
	    _classCallCheck(this, ScrollableAnchor);
	
	    var _this = _possibleConstructorReturn(this, (ScrollableAnchor.__proto__ || Object.getPrototypeOf(ScrollableAnchor)).call(this, props));
	
	    _this.id = props.id || props.children.ref;
	    return _this;
	  }
	
	  _createClass(ScrollableAnchor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var element = _reactDom2.default.findDOMNode(this.refs[Object.keys(this.refs)[0]]);
	      _Manager2.default.addAnchor(this.id, element);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _Manager2.default.removeAnchor(this.id);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          id = _props.id;
	
	
	      return _react2.default.cloneElement(children, {
	        ref: children.ref || id
	      });
	    }
	  }]);
	
	  return ScrollableAnchor;
	}(_react.Component);
	
	ScrollableAnchor.propTypes = {
	  children: _propTypes2.default.node,
	  id: _propTypes2.default.string
	};
	exports.default = ScrollableAnchor;

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.removeHash = exports.goToAnchor = exports.configureAnchors = exports.goToTop = undefined;
	
	var _hash = __webpack_require__(258);
	
	Object.defineProperty(exports, 'goToAnchor', {
	  enumerable: true,
	  get: function get() {
	    return _hash.updateHash;
	  }
	});
	Object.defineProperty(exports, 'removeHash', {
	  enumerable: true,
	  get: function get() {
	    return _hash.removeHash;
	  }
	});
	
	var _ScrollableAnchor = __webpack_require__(637);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ScrollableAnchor).default;
	  }
	});
	
	var _Manager = __webpack_require__(257);
	
	var _Manager2 = _interopRequireDefault(_Manager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var goToTop = exports.goToTop = _Manager2.default.goToTop;
	var configureAnchors = exports.configureAnchors = _Manager2.default.configure;

/***/ }),
/* 639 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _arguments = arguments;
	var debounce = exports.debounce = function debounce(func, wait, immediate) {
	  var timeout = void 0;
	  return function () {
	    var context = undefined;
	    var args = _arguments;
	    var later = function later() {
	      timeout = null;
	      if (!immediate) {
	        func.apply(context, args);
	      }
	    };
	    var callNow = immediate && !timeout;
	    clearTimeout(timeout);
	    timeout = setTimeout(later, wait);
	    if (callNow) {
	      func.apply(context, args);
	    }
	  };
	};

/***/ }),
/* 640 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getScrollTop = exports.getScrollTop = function getScrollTop() {
	  return document.body.scrollTop || document.documentElement.scrollTop;
	};
	
	// get vertical offsets of element, taking scrollTop into consideration
	var getElementOffset = exports.getElementOffset = function getElementOffset(element) {
	  var scrollTop = getScrollTop();
	
	  var _element$getBoundingC = element.getBoundingClientRect(),
	      top = _element$getBoundingC.top,
	      bottom = _element$getBoundingC.bottom;
	
	  return {
	    top: Math.floor(top + scrollTop),
	    bottom: Math.floor(bottom + scrollTop)
	  };
	};
	
	// does scrollTop live within element bounds?
	var doesElementContainScrollTop = exports.doesElementContainScrollTop = function doesElementContainScrollTop(element) {
	  var extraOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  var scrollTop = getScrollTop();
	  var offsetTop = getElementOffset(element).top + extraOffset;
	  return scrollTop >= offsetTop && scrollTop < offsetTop + element.offsetHeight;
	};
	
	// is el2's location more relevant than el2,
	// parent-child relationship aside?
	var checkLocationRelevance = exports.checkLocationRelevance = function checkLocationRelevance(el1, el2) {
	  var _getElementOffset = getElementOffset(el1),
	      top1 = _getElementOffset.top,
	      bottom1 = _getElementOffset.bottom;
	
	  var _getElementOffset2 = getElementOffset(el2),
	      top2 = _getElementOffset2.top,
	      bottom2 = _getElementOffset2.bottom;
	
	  if (top1 === top2) {
	    if (bottom1 === bottom2) {
	      // top and bottom of compared elements are the same,
	      // so return one randomly in a deterministic way
	      return el1 < el2;
	    }
	    // top of compared elements is the same, so return whichever
	    // element has its bottom higher on the page
	    return bottom2 < bottom1;
	  }
	  // top of compared elements differ, so return true
	  // if tested element has its top lower on the page
	  return top2 > top1;
	};
	
	// check if el2 is more relevant than el1, considering child-parent
	// relationships as well as node location.
	var checkElementRelevance = exports.checkElementRelevance = function checkElementRelevance(el1, el2) {
	  if (el1.contains(el2)) {
	    // el2 is child, so it gains relevance priority
	    return true;
	  } else if (!el2.contains(el1) && checkLocationRelevance(el1, el2)) {
	    // el1 and el2 are unrelated, but el2 has a better location,
	    // so it gains relevance priority
	    return true;
	  }
	  return false;
	};
	
	// given a set of anchors, find which one is, given the following logic:
	// 1. children nodes are more relevant than parent nodes
	// 2. if neither node contains the other, and their top locations differ,
	//    the node with the top lower on the page is more relevant
	// 3. if neither node contains the other, and their top locations are the same,
	//    the node with the bottom higher on the page is more relevant
	// 4. if neither node contains the other, and their top and bottom locations
	//    are the same, a node is chosen at random, in a deterministic way,
	//    to be more relevant.
	var getBestAnchorGivenScrollLocation = exports.getBestAnchorGivenScrollLocation = function getBestAnchorGivenScrollLocation(anchors, offset) {
	  var bestId = void 0,
	      bestElement = void 0;
	
	  Object.keys(anchors).forEach(function (id) {
	    var element = anchors[id];
	    if (doesElementContainScrollTop(element, offset)) {
	      if (!bestElement || checkElementRelevance(bestElement, element)) {
	        bestElement = element;
	        bestId = id;
	      }
	    }
	  });
	  return bestId;
	};

/***/ })
]);


// WEBPACK FOOTER //
// component---src-pages-index-js-63925e3bc89faa81277c.js